export default [
  {
    "id": 241900492,
    "node_id": "MDEwOlJlcG9zaXRvcnkyNDE5MDA0OTI=",
    "name": "animated-guide-vue3",
    "full_name": "sdras/animated-guide-vue3",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/animated-guide-vue3",
    "description": null,
    "fork": false,
    "url": "https://api.github.com/repos/sdras/animated-guide-vue3",
    "forks_url": "https://api.github.com/repos/sdras/animated-guide-vue3/forks",
    "keys_url": "https://api.github.com/repos/sdras/animated-guide-vue3/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/animated-guide-vue3/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/animated-guide-vue3/teams",
    "hooks_url": "https://api.github.com/repos/sdras/animated-guide-vue3/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/animated-guide-vue3/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/animated-guide-vue3/events",
    "assignees_url": "https://api.github.com/repos/sdras/animated-guide-vue3/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/animated-guide-vue3/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/animated-guide-vue3/tags",
    "blobs_url": "https://api.github.com/repos/sdras/animated-guide-vue3/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/animated-guide-vue3/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/animated-guide-vue3/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/animated-guide-vue3/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/animated-guide-vue3/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/animated-guide-vue3/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/animated-guide-vue3/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/animated-guide-vue3/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/animated-guide-vue3/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/animated-guide-vue3/subscription",
    "commits_url": "https://api.github.com/repos/sdras/animated-guide-vue3/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/animated-guide-vue3/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/animated-guide-vue3/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/animated-guide-vue3/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/animated-guide-vue3/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/animated-guide-vue3/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/animated-guide-vue3/merges",
    "archive_url": "https://api.github.com/repos/sdras/animated-guide-vue3/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/animated-guide-vue3/downloads",
    "issues_url": "https://api.github.com/repos/sdras/animated-guide-vue3/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/animated-guide-vue3/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/animated-guide-vue3/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/animated-guide-vue3/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/animated-guide-vue3/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/animated-guide-vue3/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/animated-guide-vue3/deployments",
    "created_at": "2020-02-20T14:09:31Z",
    "updated_at": "2021-01-14T07:49:57Z",
    "pushed_at": "2020-02-21T10:24:39Z",
    "git_url": "git://github.com/sdras/animated-guide-vue3.git",
    "ssh_url": "git@github.com:sdras/animated-guide-vue3.git",
    "clone_url": "https://github.com/sdras/animated-guide-vue3.git",
    "svn_url": "https://github.com/sdras/animated-guide-vue3",
    "homepage": "",
    "size": 5844,
    "stargazers_count": 135,
    "watchers_count": 135,
    "language": null,
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 9,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 9,
    "open_issues": 0,
    "watchers": 135,
    "default_branch": "master"
  },
  {
    "id": 115382152,
    "node_id": "MDEwOlJlcG9zaXRvcnkxMTUzODIxNTI=",
    "name": "array-explorer",
    "full_name": "sdras/array-explorer",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/array-explorer",
    "description": "⚡️ A resource to help figure out what JavaScript array method would be best to use at any given time",
    "fork": false,
    "url": "https://api.github.com/repos/sdras/array-explorer",
    "forks_url": "https://api.github.com/repos/sdras/array-explorer/forks",
    "keys_url": "https://api.github.com/repos/sdras/array-explorer/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/array-explorer/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/array-explorer/teams",
    "hooks_url": "https://api.github.com/repos/sdras/array-explorer/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/array-explorer/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/array-explorer/events",
    "assignees_url": "https://api.github.com/repos/sdras/array-explorer/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/array-explorer/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/array-explorer/tags",
    "blobs_url": "https://api.github.com/repos/sdras/array-explorer/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/array-explorer/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/array-explorer/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/array-explorer/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/array-explorer/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/array-explorer/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/array-explorer/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/array-explorer/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/array-explorer/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/array-explorer/subscription",
    "commits_url": "https://api.github.com/repos/sdras/array-explorer/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/array-explorer/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/array-explorer/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/array-explorer/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/array-explorer/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/array-explorer/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/array-explorer/merges",
    "archive_url": "https://api.github.com/repos/sdras/array-explorer/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/array-explorer/downloads",
    "issues_url": "https://api.github.com/repos/sdras/array-explorer/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/array-explorer/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/array-explorer/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/array-explorer/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/array-explorer/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/array-explorer/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/array-explorer/deployments",
    "created_at": "2017-12-26T03:30:38Z",
    "updated_at": "2021-01-14T05:10:01Z",
    "pushed_at": "2020-12-21T16:45:49Z",
    "git_url": "git://github.com/sdras/array-explorer.git",
    "ssh_url": "git@github.com:sdras/array-explorer.git",
    "clone_url": "https://github.com/sdras/array-explorer.git",
    "svn_url": "https://github.com/sdras/array-explorer",
    "homepage": "https://arrayexplorer.netlify.com/",
    "size": 3438,
    "stargazers_count": 2355,
    "watchers_count": 2355,
    "language": "JavaScript",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": true,
    "forks_count": 223,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 11,
    "license": {
      "key": "mit",
      "name": "MIT License",
      "spdx_id": "MIT",
      "url": "https://api.github.com/licenses/mit",
      "node_id": "MDc6TGljZW5zZTEz"
    },
    "forks": 223,
    "open_issues": 11,
    "watchers": 2355,
    "default_branch": "master"
  },
  {
    "id": 226587442,
    "node_id": "MDEwOlJlcG9zaXRvcnkyMjY1ODc0NDI=",
    "name": "awesome",
    "full_name": "sdras/awesome",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/awesome",
    "description": "😎 Awesome lists about all kinds of interesting topics",
    "fork": true,
    "url": "https://api.github.com/repos/sdras/awesome",
    "forks_url": "https://api.github.com/repos/sdras/awesome/forks",
    "keys_url": "https://api.github.com/repos/sdras/awesome/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/awesome/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/awesome/teams",
    "hooks_url": "https://api.github.com/repos/sdras/awesome/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/awesome/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/awesome/events",
    "assignees_url": "https://api.github.com/repos/sdras/awesome/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/awesome/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/awesome/tags",
    "blobs_url": "https://api.github.com/repos/sdras/awesome/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/awesome/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/awesome/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/awesome/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/awesome/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/awesome/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/awesome/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/awesome/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/awesome/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/awesome/subscription",
    "commits_url": "https://api.github.com/repos/sdras/awesome/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/awesome/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/awesome/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/awesome/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/awesome/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/awesome/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/awesome/merges",
    "archive_url": "https://api.github.com/repos/sdras/awesome/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/awesome/downloads",
    "issues_url": "https://api.github.com/repos/sdras/awesome/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/awesome/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/awesome/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/awesome/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/awesome/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/awesome/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/awesome/deployments",
    "created_at": "2019-12-07T23:06:43Z",
    "updated_at": "2021-01-01T06:01:36Z",
    "pushed_at": "2019-12-07T23:12:27Z",
    "git_url": "git://github.com/sdras/awesome.git",
    "ssh_url": "git@github.com:sdras/awesome.git",
    "clone_url": "https://github.com/sdras/awesome.git",
    "svn_url": "https://github.com/sdras/awesome",
    "homepage": "",
    "size": 855,
    "stargazers_count": 16,
    "watchers_count": 16,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": false,
    "has_pages": false,
    "forks_count": 11,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "cc0-1.0",
      "name": "Creative Commons Zero v1.0 Universal",
      "spdx_id": "CC0-1.0",
      "url": "https://api.github.com/licenses/cc0-1.0",
      "node_id": "MDc6TGljZW5zZTY="
    },
    "forks": 11,
    "open_issues": 0,
    "watchers": 16,
    "default_branch": "master"
  },
  {
    "id": 153500249,
    "node_id": "MDEwOlJlcG9zaXRvcnkxNTM1MDAyNDk=",
    "name": "awesome-actions",
    "full_name": "sdras/awesome-actions",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/awesome-actions",
    "description": "A curated list of awesome actions to use on GitHub",
    "fork": false,
    "url": "https://api.github.com/repos/sdras/awesome-actions",
    "forks_url": "https://api.github.com/repos/sdras/awesome-actions/forks",
    "keys_url": "https://api.github.com/repos/sdras/awesome-actions/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/awesome-actions/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/awesome-actions/teams",
    "hooks_url": "https://api.github.com/repos/sdras/awesome-actions/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/awesome-actions/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/awesome-actions/events",
    "assignees_url": "https://api.github.com/repos/sdras/awesome-actions/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/awesome-actions/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/awesome-actions/tags",
    "blobs_url": "https://api.github.com/repos/sdras/awesome-actions/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/awesome-actions/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/awesome-actions/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/awesome-actions/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/awesome-actions/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/awesome-actions/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/awesome-actions/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/awesome-actions/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/awesome-actions/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/awesome-actions/subscription",
    "commits_url": "https://api.github.com/repos/sdras/awesome-actions/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/awesome-actions/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/awesome-actions/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/awesome-actions/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/awesome-actions/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/awesome-actions/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/awesome-actions/merges",
    "archive_url": "https://api.github.com/repos/sdras/awesome-actions/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/awesome-actions/downloads",
    "issues_url": "https://api.github.com/repos/sdras/awesome-actions/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/awesome-actions/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/awesome-actions/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/awesome-actions/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/awesome-actions/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/awesome-actions/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/awesome-actions/deployments",
    "created_at": "2018-10-17T17:53:45Z",
    "updated_at": "2021-01-15T14:05:24Z",
    "pushed_at": "2021-01-07T20:29:34Z",
    "git_url": "git://github.com/sdras/awesome-actions.git",
    "ssh_url": "git@github.com:sdras/awesome-actions.git",
    "clone_url": "https://github.com/sdras/awesome-actions.git",
    "svn_url": "https://github.com/sdras/awesome-actions",
    "homepage": "",
    "size": 1229,
    "stargazers_count": 12051,
    "watchers_count": 12051,
    "language": null,
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 761,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 36,
    "license": {
      "key": "cc0-1.0",
      "name": "Creative Commons Zero v1.0 Universal",
      "spdx_id": "CC0-1.0",
      "url": "https://api.github.com/licenses/cc0-1.0",
      "node_id": "MDc6TGljZW5zZTY="
    },
    "forks": 761,
    "open_issues": 36,
    "watchers": 12051,
    "default_branch": "master"
  },
  {
    "id": 130668902,
    "node_id": "MDEwOlJlcG9zaXRvcnkxMzA2Njg5MDI=",
    "name": "awesome-conference-practices",
    "full_name": "sdras/awesome-conference-practices",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/awesome-conference-practices",
    "description": "Did you like anything in particular about a conference? Let's make an awesome list 🎉",
    "fork": true,
    "url": "https://api.github.com/repos/sdras/awesome-conference-practices",
    "forks_url": "https://api.github.com/repos/sdras/awesome-conference-practices/forks",
    "keys_url": "https://api.github.com/repos/sdras/awesome-conference-practices/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/awesome-conference-practices/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/awesome-conference-practices/teams",
    "hooks_url": "https://api.github.com/repos/sdras/awesome-conference-practices/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/awesome-conference-practices/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/awesome-conference-practices/events",
    "assignees_url": "https://api.github.com/repos/sdras/awesome-conference-practices/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/awesome-conference-practices/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/awesome-conference-practices/tags",
    "blobs_url": "https://api.github.com/repos/sdras/awesome-conference-practices/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/awesome-conference-practices/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/awesome-conference-practices/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/awesome-conference-practices/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/awesome-conference-practices/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/awesome-conference-practices/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/awesome-conference-practices/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/awesome-conference-practices/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/awesome-conference-practices/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/awesome-conference-practices/subscription",
    "commits_url": "https://api.github.com/repos/sdras/awesome-conference-practices/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/awesome-conference-practices/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/awesome-conference-practices/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/awesome-conference-practices/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/awesome-conference-practices/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/awesome-conference-practices/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/awesome-conference-practices/merges",
    "archive_url": "https://api.github.com/repos/sdras/awesome-conference-practices/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/awesome-conference-practices/downloads",
    "issues_url": "https://api.github.com/repos/sdras/awesome-conference-practices/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/awesome-conference-practices/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/awesome-conference-practices/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/awesome-conference-practices/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/awesome-conference-practices/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/awesome-conference-practices/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/awesome-conference-practices/deployments",
    "created_at": "2018-04-23T08:58:11Z",
    "updated_at": "2020-03-11T18:04:14Z",
    "pushed_at": "2018-04-23T08:38:16Z",
    "git_url": "git://github.com/sdras/awesome-conference-practices.git",
    "ssh_url": "git@github.com:sdras/awesome-conference-practices.git",
    "clone_url": "https://github.com/sdras/awesome-conference-practices.git",
    "svn_url": "https://github.com/sdras/awesome-conference-practices",
    "homepage": null,
    "size": 64,
    "stargazers_count": 7,
    "watchers_count": 7,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 2,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 2,
    "open_issues": 0,
    "watchers": 7,
    "default_branch": "master"
  },
  {
    "id": 116068741,
    "node_id": "MDEwOlJlcG9zaXRvcnkxMTYwNjg3NDE=",
    "name": "awesome-javascript",
    "full_name": "sdras/awesome-javascript",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/awesome-javascript",
    "description": "🐢 A collection of awesome browser-side  JavaScript libraries, resources and shiny things.",
    "fork": true,
    "url": "https://api.github.com/repos/sdras/awesome-javascript",
    "forks_url": "https://api.github.com/repos/sdras/awesome-javascript/forks",
    "keys_url": "https://api.github.com/repos/sdras/awesome-javascript/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/awesome-javascript/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/awesome-javascript/teams",
    "hooks_url": "https://api.github.com/repos/sdras/awesome-javascript/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/awesome-javascript/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/awesome-javascript/events",
    "assignees_url": "https://api.github.com/repos/sdras/awesome-javascript/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/awesome-javascript/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/awesome-javascript/tags",
    "blobs_url": "https://api.github.com/repos/sdras/awesome-javascript/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/awesome-javascript/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/awesome-javascript/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/awesome-javascript/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/awesome-javascript/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/awesome-javascript/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/awesome-javascript/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/awesome-javascript/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/awesome-javascript/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/awesome-javascript/subscription",
    "commits_url": "https://api.github.com/repos/sdras/awesome-javascript/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/awesome-javascript/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/awesome-javascript/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/awesome-javascript/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/awesome-javascript/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/awesome-javascript/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/awesome-javascript/merges",
    "archive_url": "https://api.github.com/repos/sdras/awesome-javascript/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/awesome-javascript/downloads",
    "issues_url": "https://api.github.com/repos/sdras/awesome-javascript/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/awesome-javascript/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/awesome-javascript/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/awesome-javascript/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/awesome-javascript/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/awesome-javascript/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/awesome-javascript/deployments",
    "created_at": "2018-01-02T23:39:26Z",
    "updated_at": "2020-05-19T00:43:32Z",
    "pushed_at": "2018-01-03T14:33:51Z",
    "git_url": "git://github.com/sdras/awesome-javascript.git",
    "ssh_url": "git@github.com:sdras/awesome-javascript.git",
    "clone_url": "https://github.com/sdras/awesome-javascript.git",
    "svn_url": "https://github.com/sdras/awesome-javascript",
    "homepage": "",
    "size": 588,
    "stargazers_count": 44,
    "watchers_count": 44,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 19,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 19,
    "open_issues": 0,
    "watchers": 44,
    "default_branch": "master"
  },
  {
    "id": 100179936,
    "node_id": "MDEwOlJlcG9zaXRvcnkxMDAxNzk5MzY=",
    "name": "awesome-nuxt",
    "full_name": "sdras/awesome-nuxt",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/awesome-nuxt",
    "description": "A curated list of awesome things related to Nuxt.js",
    "fork": true,
    "url": "https://api.github.com/repos/sdras/awesome-nuxt",
    "forks_url": "https://api.github.com/repos/sdras/awesome-nuxt/forks",
    "keys_url": "https://api.github.com/repos/sdras/awesome-nuxt/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/awesome-nuxt/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/awesome-nuxt/teams",
    "hooks_url": "https://api.github.com/repos/sdras/awesome-nuxt/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/awesome-nuxt/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/awesome-nuxt/events",
    "assignees_url": "https://api.github.com/repos/sdras/awesome-nuxt/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/awesome-nuxt/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/awesome-nuxt/tags",
    "blobs_url": "https://api.github.com/repos/sdras/awesome-nuxt/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/awesome-nuxt/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/awesome-nuxt/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/awesome-nuxt/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/awesome-nuxt/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/awesome-nuxt/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/awesome-nuxt/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/awesome-nuxt/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/awesome-nuxt/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/awesome-nuxt/subscription",
    "commits_url": "https://api.github.com/repos/sdras/awesome-nuxt/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/awesome-nuxt/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/awesome-nuxt/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/awesome-nuxt/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/awesome-nuxt/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/awesome-nuxt/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/awesome-nuxt/merges",
    "archive_url": "https://api.github.com/repos/sdras/awesome-nuxt/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/awesome-nuxt/downloads",
    "issues_url": "https://api.github.com/repos/sdras/awesome-nuxt/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/awesome-nuxt/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/awesome-nuxt/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/awesome-nuxt/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/awesome-nuxt/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/awesome-nuxt/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/awesome-nuxt/deployments",
    "created_at": "2017-08-13T13:52:05Z",
    "updated_at": "2021-01-01T06:11:51Z",
    "pushed_at": "2017-08-13T13:55:58Z",
    "git_url": "git://github.com/sdras/awesome-nuxt.git",
    "ssh_url": "git@github.com:sdras/awesome-nuxt.git",
    "clone_url": "https://github.com/sdras/awesome-nuxt.git",
    "svn_url": "https://github.com/sdras/awesome-nuxt",
    "homepage": "",
    "size": 20,
    "stargazers_count": 5,
    "watchers_count": 5,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 2,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 2,
    "open_issues": 0,
    "watchers": 5,
    "default_branch": "master"
  },
  {
    "id": 97657280,
    "node_id": "MDEwOlJlcG9zaXRvcnk5NzY1NzI4MA==",
    "name": "awesome-vue",
    "full_name": "sdras/awesome-vue",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/awesome-vue",
    "description": "A curated list of awesome things related to Vue.js",
    "fork": true,
    "url": "https://api.github.com/repos/sdras/awesome-vue",
    "forks_url": "https://api.github.com/repos/sdras/awesome-vue/forks",
    "keys_url": "https://api.github.com/repos/sdras/awesome-vue/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/awesome-vue/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/awesome-vue/teams",
    "hooks_url": "https://api.github.com/repos/sdras/awesome-vue/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/awesome-vue/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/awesome-vue/events",
    "assignees_url": "https://api.github.com/repos/sdras/awesome-vue/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/awesome-vue/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/awesome-vue/tags",
    "blobs_url": "https://api.github.com/repos/sdras/awesome-vue/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/awesome-vue/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/awesome-vue/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/awesome-vue/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/awesome-vue/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/awesome-vue/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/awesome-vue/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/awesome-vue/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/awesome-vue/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/awesome-vue/subscription",
    "commits_url": "https://api.github.com/repos/sdras/awesome-vue/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/awesome-vue/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/awesome-vue/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/awesome-vue/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/awesome-vue/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/awesome-vue/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/awesome-vue/merges",
    "archive_url": "https://api.github.com/repos/sdras/awesome-vue/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/awesome-vue/downloads",
    "issues_url": "https://api.github.com/repos/sdras/awesome-vue/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/awesome-vue/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/awesome-vue/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/awesome-vue/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/awesome-vue/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/awesome-vue/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/awesome-vue/deployments",
    "created_at": "2017-07-19T00:59:54Z",
    "updated_at": "2021-01-01T06:11:03Z",
    "pushed_at": "2017-09-20T05:51:50Z",
    "git_url": "git://github.com/sdras/awesome-vue.git",
    "ssh_url": "git@github.com:sdras/awesome-vue.git",
    "clone_url": "https://github.com/sdras/awesome-vue.git",
    "svn_url": "https://github.com/sdras/awesome-vue",
    "homepage": "",
    "size": 1960,
    "stargazers_count": 11,
    "watchers_count": 11,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": false,
    "has_pages": false,
    "forks_count": 3,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 3,
    "open_issues": 0,
    "watchers": 11,
    "default_branch": "master"
  },
  {
    "id": 113219461,
    "node_id": "MDEwOlJlcG9zaXRvcnkxMTMyMTk0NjE=",
    "name": "azure-functions-cli",
    "full_name": "sdras/azure-functions-cli",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/azure-functions-cli",
    "description": "Command line tool for Azure Function",
    "fork": true,
    "url": "https://api.github.com/repos/sdras/azure-functions-cli",
    "forks_url": "https://api.github.com/repos/sdras/azure-functions-cli/forks",
    "keys_url": "https://api.github.com/repos/sdras/azure-functions-cli/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/azure-functions-cli/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/azure-functions-cli/teams",
    "hooks_url": "https://api.github.com/repos/sdras/azure-functions-cli/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/azure-functions-cli/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/azure-functions-cli/events",
    "assignees_url": "https://api.github.com/repos/sdras/azure-functions-cli/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/azure-functions-cli/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/azure-functions-cli/tags",
    "blobs_url": "https://api.github.com/repos/sdras/azure-functions-cli/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/azure-functions-cli/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/azure-functions-cli/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/azure-functions-cli/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/azure-functions-cli/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/azure-functions-cli/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/azure-functions-cli/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/azure-functions-cli/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/azure-functions-cli/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/azure-functions-cli/subscription",
    "commits_url": "https://api.github.com/repos/sdras/azure-functions-cli/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/azure-functions-cli/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/azure-functions-cli/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/azure-functions-cli/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/azure-functions-cli/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/azure-functions-cli/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/azure-functions-cli/merges",
    "archive_url": "https://api.github.com/repos/sdras/azure-functions-cli/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/azure-functions-cli/downloads",
    "issues_url": "https://api.github.com/repos/sdras/azure-functions-cli/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/azure-functions-cli/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/azure-functions-cli/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/azure-functions-cli/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/azure-functions-cli/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/azure-functions-cli/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/azure-functions-cli/deployments",
    "created_at": "2017-12-05T18:40:40Z",
    "updated_at": "2017-12-05T18:40:41Z",
    "pushed_at": "2017-12-06T21:43:09Z",
    "git_url": "git://github.com/sdras/azure-functions-cli.git",
    "ssh_url": "git@github.com:sdras/azure-functions-cli.git",
    "clone_url": "https://github.com/sdras/azure-functions-cli.git",
    "svn_url": "https://github.com/sdras/azure-functions-cli",
    "homepage": null,
    "size": 585,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "C#",
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "other",
      "name": "Other",
      "spdx_id": "NOASSERTION",
      "url": null,
      "node_id": "MDc6TGljZW5zZTA="
    },
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 150788236,
    "node_id": "MDEwOlJlcG9zaXRvcnkxNTA3ODgyMzY=",
    "name": "azure-functions-durable-extension",
    "full_name": "sdras/azure-functions-durable-extension",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/azure-functions-durable-extension",
    "description": "Durable Task Framework extension for Azure Functions",
    "fork": true,
    "url": "https://api.github.com/repos/sdras/azure-functions-durable-extension",
    "forks_url": "https://api.github.com/repos/sdras/azure-functions-durable-extension/forks",
    "keys_url": "https://api.github.com/repos/sdras/azure-functions-durable-extension/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/azure-functions-durable-extension/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/azure-functions-durable-extension/teams",
    "hooks_url": "https://api.github.com/repos/sdras/azure-functions-durable-extension/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/azure-functions-durable-extension/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/azure-functions-durable-extension/events",
    "assignees_url": "https://api.github.com/repos/sdras/azure-functions-durable-extension/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/azure-functions-durable-extension/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/azure-functions-durable-extension/tags",
    "blobs_url": "https://api.github.com/repos/sdras/azure-functions-durable-extension/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/azure-functions-durable-extension/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/azure-functions-durable-extension/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/azure-functions-durable-extension/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/azure-functions-durable-extension/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/azure-functions-durable-extension/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/azure-functions-durable-extension/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/azure-functions-durable-extension/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/azure-functions-durable-extension/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/azure-functions-durable-extension/subscription",
    "commits_url": "https://api.github.com/repos/sdras/azure-functions-durable-extension/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/azure-functions-durable-extension/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/azure-functions-durable-extension/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/azure-functions-durable-extension/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/azure-functions-durable-extension/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/azure-functions-durable-extension/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/azure-functions-durable-extension/merges",
    "archive_url": "https://api.github.com/repos/sdras/azure-functions-durable-extension/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/azure-functions-durable-extension/downloads",
    "issues_url": "https://api.github.com/repos/sdras/azure-functions-durable-extension/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/azure-functions-durable-extension/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/azure-functions-durable-extension/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/azure-functions-durable-extension/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/azure-functions-durable-extension/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/azure-functions-durable-extension/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/azure-functions-durable-extension/deployments",
    "created_at": "2018-09-28T19:52:09Z",
    "updated_at": "2018-09-28T19:52:11Z",
    "pushed_at": "2018-09-26T11:27:13Z",
    "git_url": "git://github.com/sdras/azure-functions-durable-extension.git",
    "ssh_url": "git@github.com:sdras/azure-functions-durable-extension.git",
    "clone_url": "https://github.com/sdras/azure-functions-durable-extension.git",
    "svn_url": "https://github.com/sdras/azure-functions-durable-extension",
    "homepage": null,
    "size": 9934,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "C#",
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "mit",
      "name": "MIT License",
      "spdx_id": "MIT",
      "url": "https://api.github.com/licenses/mit",
      "node_id": "MDc6TGljZW5zZTEz"
    },
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 25430428,
    "node_id": "MDEwOlJlcG9zaXRvcnkyNTQzMDQyOA==",
    "name": "Benchmarking-Animations",
    "full_name": "sdras/Benchmarking-Animations",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/Benchmarking-Animations",
    "description": "Writing the same simple animation in a loop in SMIL, Canvas, CSS, and Velocity for benchmarking purposes.",
    "fork": false,
    "url": "https://api.github.com/repos/sdras/Benchmarking-Animations",
    "forks_url": "https://api.github.com/repos/sdras/Benchmarking-Animations/forks",
    "keys_url": "https://api.github.com/repos/sdras/Benchmarking-Animations/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/Benchmarking-Animations/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/Benchmarking-Animations/teams",
    "hooks_url": "https://api.github.com/repos/sdras/Benchmarking-Animations/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/Benchmarking-Animations/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/Benchmarking-Animations/events",
    "assignees_url": "https://api.github.com/repos/sdras/Benchmarking-Animations/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/Benchmarking-Animations/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/Benchmarking-Animations/tags",
    "blobs_url": "https://api.github.com/repos/sdras/Benchmarking-Animations/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/Benchmarking-Animations/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/Benchmarking-Animations/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/Benchmarking-Animations/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/Benchmarking-Animations/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/Benchmarking-Animations/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/Benchmarking-Animations/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/Benchmarking-Animations/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/Benchmarking-Animations/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/Benchmarking-Animations/subscription",
    "commits_url": "https://api.github.com/repos/sdras/Benchmarking-Animations/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/Benchmarking-Animations/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/Benchmarking-Animations/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/Benchmarking-Animations/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/Benchmarking-Animations/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/Benchmarking-Animations/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/Benchmarking-Animations/merges",
    "archive_url": "https://api.github.com/repos/sdras/Benchmarking-Animations/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/Benchmarking-Animations/downloads",
    "issues_url": "https://api.github.com/repos/sdras/Benchmarking-Animations/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/Benchmarking-Animations/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/Benchmarking-Animations/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/Benchmarking-Animations/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/Benchmarking-Animations/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/Benchmarking-Animations/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/Benchmarking-Animations/deployments",
    "created_at": "2014-10-19T15:08:05Z",
    "updated_at": "2020-06-01T02:15:57Z",
    "pushed_at": "2015-01-23T06:05:05Z",
    "git_url": "git://github.com/sdras/Benchmarking-Animations.git",
    "ssh_url": "git@github.com:sdras/Benchmarking-Animations.git",
    "clone_url": "https://github.com/sdras/Benchmarking-Animations.git",
    "svn_url": "https://github.com/sdras/Benchmarking-Animations",
    "homepage": null,
    "size": 214,
    "stargazers_count": 6,
    "watchers_count": 6,
    "language": "CSS",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 1,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 1,
    "open_issues": 0,
    "watchers": 6,
    "default_branch": "master"
  },
  {
    "id": 285059448,
    "node_id": "MDEwOlJlcG9zaXRvcnkyODUwNTk0NDg=",
    "name": "building-web-apps-with-vue",
    "full_name": "sdras/building-web-apps-with-vue",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/building-web-apps-with-vue",
    "description": "building-web-app-with-vue",
    "fork": false,
    "url": "https://api.github.com/repos/sdras/building-web-apps-with-vue",
    "forks_url": "https://api.github.com/repos/sdras/building-web-apps-with-vue/forks",
    "keys_url": "https://api.github.com/repos/sdras/building-web-apps-with-vue/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/building-web-apps-with-vue/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/building-web-apps-with-vue/teams",
    "hooks_url": "https://api.github.com/repos/sdras/building-web-apps-with-vue/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/building-web-apps-with-vue/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/building-web-apps-with-vue/events",
    "assignees_url": "https://api.github.com/repos/sdras/building-web-apps-with-vue/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/building-web-apps-with-vue/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/building-web-apps-with-vue/tags",
    "blobs_url": "https://api.github.com/repos/sdras/building-web-apps-with-vue/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/building-web-apps-with-vue/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/building-web-apps-with-vue/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/building-web-apps-with-vue/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/building-web-apps-with-vue/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/building-web-apps-with-vue/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/building-web-apps-with-vue/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/building-web-apps-with-vue/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/building-web-apps-with-vue/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/building-web-apps-with-vue/subscription",
    "commits_url": "https://api.github.com/repos/sdras/building-web-apps-with-vue/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/building-web-apps-with-vue/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/building-web-apps-with-vue/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/building-web-apps-with-vue/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/building-web-apps-with-vue/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/building-web-apps-with-vue/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/building-web-apps-with-vue/merges",
    "archive_url": "https://api.github.com/repos/sdras/building-web-apps-with-vue/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/building-web-apps-with-vue/downloads",
    "issues_url": "https://api.github.com/repos/sdras/building-web-apps-with-vue/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/building-web-apps-with-vue/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/building-web-apps-with-vue/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/building-web-apps-with-vue/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/building-web-apps-with-vue/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/building-web-apps-with-vue/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/building-web-apps-with-vue/deployments",
    "created_at": "2020-08-04T18:03:35Z",
    "updated_at": "2021-01-14T14:37:12Z",
    "pushed_at": "2020-12-13T05:57:34Z",
    "git_url": "git://github.com/sdras/building-web-apps-with-vue.git",
    "ssh_url": "git@github.com:sdras/building-web-apps-with-vue.git",
    "clone_url": "https://github.com/sdras/building-web-apps-with-vue.git",
    "svn_url": "https://github.com/sdras/building-web-apps-with-vue",
    "homepage": null,
    "size": 2330,
    "stargazers_count": 142,
    "watchers_count": 142,
    "language": "Vue",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 55,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 4,
    "license": null,
    "forks": 55,
    "open_issues": 4,
    "watchers": 142,
    "default_branch": "master"
  },
  {
    "id": 103750851,
    "node_id": "MDEwOlJlcG9zaXRvcnkxMDM3NTA4NTE=",
    "name": "cda-locale",
    "full_name": "sdras/cda-locale",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/cda-locale",
    "description": "Showing Microsoft Cloud Developer Advocates speaking, 2017 and 2018",
    "fork": false,
    "url": "https://api.github.com/repos/sdras/cda-locale",
    "forks_url": "https://api.github.com/repos/sdras/cda-locale/forks",
    "keys_url": "https://api.github.com/repos/sdras/cda-locale/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/cda-locale/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/cda-locale/teams",
    "hooks_url": "https://api.github.com/repos/sdras/cda-locale/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/cda-locale/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/cda-locale/events",
    "assignees_url": "https://api.github.com/repos/sdras/cda-locale/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/cda-locale/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/cda-locale/tags",
    "blobs_url": "https://api.github.com/repos/sdras/cda-locale/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/cda-locale/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/cda-locale/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/cda-locale/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/cda-locale/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/cda-locale/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/cda-locale/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/cda-locale/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/cda-locale/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/cda-locale/subscription",
    "commits_url": "https://api.github.com/repos/sdras/cda-locale/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/cda-locale/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/cda-locale/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/cda-locale/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/cda-locale/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/cda-locale/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/cda-locale/merges",
    "archive_url": "https://api.github.com/repos/sdras/cda-locale/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/cda-locale/downloads",
    "issues_url": "https://api.github.com/repos/sdras/cda-locale/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/cda-locale/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/cda-locale/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/cda-locale/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/cda-locale/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/cda-locale/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/cda-locale/deployments",
    "created_at": "2017-09-16T12:35:56Z",
    "updated_at": "2021-01-07T16:01:19Z",
    "pushed_at": "2018-01-14T18:59:54Z",
    "git_url": "git://github.com/sdras/cda-locale.git",
    "ssh_url": "git@github.com:sdras/cda-locale.git",
    "clone_url": "https://github.com/sdras/cda-locale.git",
    "svn_url": "https://github.com/sdras/cda-locale",
    "homepage": "https://cda-locale.netlify.com/",
    "size": 1415,
    "stargazers_count": 100,
    "watchers_count": 100,
    "language": "JavaScript",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 10,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "mit",
      "name": "MIT License",
      "spdx_id": "MIT",
      "url": "https://api.github.com/licenses/mit",
      "node_id": "MDc6TGljZW5zZTEz"
    },
    "forks": 10,
    "open_issues": 0,
    "watchers": 100,
    "default_branch": "master"
  },
  {
    "id": 141358483,
    "node_id": "MDEwOlJlcG9zaXRvcnkxNDEzNTg0ODM=",
    "name": "cda-tracker",
    "full_name": "sdras/cda-tracker",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/cda-tracker",
    "description": null,
    "fork": true,
    "url": "https://api.github.com/repos/sdras/cda-tracker",
    "forks_url": "https://api.github.com/repos/sdras/cda-tracker/forks",
    "keys_url": "https://api.github.com/repos/sdras/cda-tracker/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/cda-tracker/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/cda-tracker/teams",
    "hooks_url": "https://api.github.com/repos/sdras/cda-tracker/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/cda-tracker/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/cda-tracker/events",
    "assignees_url": "https://api.github.com/repos/sdras/cda-tracker/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/cda-tracker/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/cda-tracker/tags",
    "blobs_url": "https://api.github.com/repos/sdras/cda-tracker/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/cda-tracker/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/cda-tracker/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/cda-tracker/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/cda-tracker/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/cda-tracker/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/cda-tracker/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/cda-tracker/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/cda-tracker/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/cda-tracker/subscription",
    "commits_url": "https://api.github.com/repos/sdras/cda-tracker/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/cda-tracker/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/cda-tracker/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/cda-tracker/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/cda-tracker/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/cda-tracker/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/cda-tracker/merges",
    "archive_url": "https://api.github.com/repos/sdras/cda-tracker/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/cda-tracker/downloads",
    "issues_url": "https://api.github.com/repos/sdras/cda-tracker/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/cda-tracker/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/cda-tracker/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/cda-tracker/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/cda-tracker/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/cda-tracker/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/cda-tracker/deployments",
    "created_at": "2018-07-18T00:01:59Z",
    "updated_at": "2018-07-18T00:15:41Z",
    "pushed_at": "2018-07-18T00:15:40Z",
    "git_url": "git://github.com/sdras/cda-tracker.git",
    "ssh_url": "git@github.com:sdras/cda-tracker.git",
    "clone_url": "https://github.com/sdras/cda-tracker.git",
    "svn_url": "https://github.com/sdras/cda-tracker",
    "homepage": null,
    "size": 39,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "JavaScript",
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "mit",
      "name": "MIT License",
      "spdx_id": "MIT",
      "url": "https://api.github.com/licenses/mit",
      "node_id": "MDc6TGljZW5zZTEz"
    },
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 189795452,
    "node_id": "MDEwOlJlcG9zaXRvcnkxODk3OTU0NTI=",
    "name": "cli",
    "full_name": "sdras/cli",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/cli",
    "description": "Netlify command line tool",
    "fork": true,
    "url": "https://api.github.com/repos/sdras/cli",
    "forks_url": "https://api.github.com/repos/sdras/cli/forks",
    "keys_url": "https://api.github.com/repos/sdras/cli/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/cli/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/cli/teams",
    "hooks_url": "https://api.github.com/repos/sdras/cli/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/cli/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/cli/events",
    "assignees_url": "https://api.github.com/repos/sdras/cli/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/cli/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/cli/tags",
    "blobs_url": "https://api.github.com/repos/sdras/cli/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/cli/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/cli/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/cli/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/cli/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/cli/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/cli/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/cli/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/cli/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/cli/subscription",
    "commits_url": "https://api.github.com/repos/sdras/cli/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/cli/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/cli/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/cli/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/cli/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/cli/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/cli/merges",
    "archive_url": "https://api.github.com/repos/sdras/cli/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/cli/downloads",
    "issues_url": "https://api.github.com/repos/sdras/cli/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/cli/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/cli/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/cli/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/cli/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/cli/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/cli/deployments",
    "created_at": "2019-06-02T02:10:32Z",
    "updated_at": "2019-06-02T02:10:35Z",
    "pushed_at": "2019-06-03T04:40:10Z",
    "git_url": "git://github.com/sdras/cli.git",
    "ssh_url": "git@github.com:sdras/cli.git",
    "clone_url": "https://github.com/sdras/cli.git",
    "svn_url": "https://github.com/sdras/cli",
    "homepage": "https://www.netlify.com/docs/cli",
    "size": 2062,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "JavaScript",
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "mit",
      "name": "MIT License",
      "spdx_id": "MIT",
      "url": "https://api.github.com/licenses/mit",
      "node_id": "MDc6TGljZW5zZTEz"
    },
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 255032668,
    "node_id": "MDEwOlJlcG9zaXRvcnkyNTUwMzI2Njg=",
    "name": "contentful-nuxt-netlify",
    "full_name": "sdras/contentful-nuxt-netlify",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/contentful-nuxt-netlify",
    "description": "Example setup for Contentful and Nuxt on Netlify",
    "fork": false,
    "url": "https://api.github.com/repos/sdras/contentful-nuxt-netlify",
    "forks_url": "https://api.github.com/repos/sdras/contentful-nuxt-netlify/forks",
    "keys_url": "https://api.github.com/repos/sdras/contentful-nuxt-netlify/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/contentful-nuxt-netlify/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/contentful-nuxt-netlify/teams",
    "hooks_url": "https://api.github.com/repos/sdras/contentful-nuxt-netlify/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/contentful-nuxt-netlify/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/contentful-nuxt-netlify/events",
    "assignees_url": "https://api.github.com/repos/sdras/contentful-nuxt-netlify/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/contentful-nuxt-netlify/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/contentful-nuxt-netlify/tags",
    "blobs_url": "https://api.github.com/repos/sdras/contentful-nuxt-netlify/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/contentful-nuxt-netlify/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/contentful-nuxt-netlify/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/contentful-nuxt-netlify/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/contentful-nuxt-netlify/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/contentful-nuxt-netlify/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/contentful-nuxt-netlify/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/contentful-nuxt-netlify/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/contentful-nuxt-netlify/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/contentful-nuxt-netlify/subscription",
    "commits_url": "https://api.github.com/repos/sdras/contentful-nuxt-netlify/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/contentful-nuxt-netlify/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/contentful-nuxt-netlify/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/contentful-nuxt-netlify/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/contentful-nuxt-netlify/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/contentful-nuxt-netlify/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/contentful-nuxt-netlify/merges",
    "archive_url": "https://api.github.com/repos/sdras/contentful-nuxt-netlify/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/contentful-nuxt-netlify/downloads",
    "issues_url": "https://api.github.com/repos/sdras/contentful-nuxt-netlify/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/contentful-nuxt-netlify/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/contentful-nuxt-netlify/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/contentful-nuxt-netlify/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/contentful-nuxt-netlify/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/contentful-nuxt-netlify/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/contentful-nuxt-netlify/deployments",
    "created_at": "2020-04-12T07:39:43Z",
    "updated_at": "2020-12-11T13:19:40Z",
    "pushed_at": "2020-11-25T04:41:56Z",
    "git_url": "git://github.com/sdras/contentful-nuxt-netlify.git",
    "ssh_url": "git@github.com:sdras/contentful-nuxt-netlify.git",
    "clone_url": "https://github.com/sdras/contentful-nuxt-netlify.git",
    "svn_url": "https://github.com/sdras/contentful-nuxt-netlify",
    "homepage": "https://contentful-nuxt-example.netlify.com/",
    "size": 891,
    "stargazers_count": 34,
    "watchers_count": 34,
    "language": "Vue",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 10,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 4,
    "license": null,
    "forks": 10,
    "open_issues": 4,
    "watchers": 34,
    "default_branch": "master"
  },
  {
    "id": 188726142,
    "node_id": "MDEwOlJlcG9zaXRvcnkxODg3MjYxNDI=",
    "name": "cssgridgenerator",
    "full_name": "sdras/cssgridgenerator",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/cssgridgenerator",
    "description": "🧮 Generate basic CSS Grid code to make dynamic layouts!",
    "fork": false,
    "url": "https://api.github.com/repos/sdras/cssgridgenerator",
    "forks_url": "https://api.github.com/repos/sdras/cssgridgenerator/forks",
    "keys_url": "https://api.github.com/repos/sdras/cssgridgenerator/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/cssgridgenerator/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/cssgridgenerator/teams",
    "hooks_url": "https://api.github.com/repos/sdras/cssgridgenerator/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/cssgridgenerator/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/cssgridgenerator/events",
    "assignees_url": "https://api.github.com/repos/sdras/cssgridgenerator/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/cssgridgenerator/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/cssgridgenerator/tags",
    "blobs_url": "https://api.github.com/repos/sdras/cssgridgenerator/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/cssgridgenerator/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/cssgridgenerator/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/cssgridgenerator/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/cssgridgenerator/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/cssgridgenerator/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/cssgridgenerator/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/cssgridgenerator/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/cssgridgenerator/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/cssgridgenerator/subscription",
    "commits_url": "https://api.github.com/repos/sdras/cssgridgenerator/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/cssgridgenerator/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/cssgridgenerator/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/cssgridgenerator/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/cssgridgenerator/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/cssgridgenerator/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/cssgridgenerator/merges",
    "archive_url": "https://api.github.com/repos/sdras/cssgridgenerator/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/cssgridgenerator/downloads",
    "issues_url": "https://api.github.com/repos/sdras/cssgridgenerator/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/cssgridgenerator/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/cssgridgenerator/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/cssgridgenerator/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/cssgridgenerator/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/cssgridgenerator/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/cssgridgenerator/deployments",
    "created_at": "2019-05-26T20:01:03Z",
    "updated_at": "2021-01-14T21:25:05Z",
    "pushed_at": "2020-12-11T08:13:28Z",
    "git_url": "git://github.com/sdras/cssgridgenerator.git",
    "ssh_url": "git@github.com:sdras/cssgridgenerator.git",
    "clone_url": "https://github.com/sdras/cssgridgenerator.git",
    "svn_url": "https://github.com/sdras/cssgridgenerator",
    "homepage": "https://cssgrid-generator.netlify.com/",
    "size": 1200,
    "stargazers_count": 3455,
    "watchers_count": 3455,
    "language": "Vue",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 300,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 13,
    "license": {
      "key": "mit",
      "name": "MIT License",
      "spdx_id": "MIT",
      "url": "https://api.github.com/licenses/mit",
      "node_id": "MDc6TGljZW5zZTEz"
    },
    "forks": 300,
    "open_issues": 13,
    "watchers": 3455,
    "default_branch": "master"
  },
  {
    "id": 157916577,
    "node_id": "MDEwOlJlcG9zaXRvcnkxNTc5MTY1Nzc=",
    "name": "d3-example-ignitetour",
    "full_name": "sdras/d3-example-ignitetour",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/d3-example-ignitetour",
    "description": " This repo serves as an example for Microsoft Ignite the Tour. In this session, we explore how to create basic charts and graphs using d3.",
    "fork": false,
    "url": "https://api.github.com/repos/sdras/d3-example-ignitetour",
    "forks_url": "https://api.github.com/repos/sdras/d3-example-ignitetour/forks",
    "keys_url": "https://api.github.com/repos/sdras/d3-example-ignitetour/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/d3-example-ignitetour/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/d3-example-ignitetour/teams",
    "hooks_url": "https://api.github.com/repos/sdras/d3-example-ignitetour/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/d3-example-ignitetour/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/d3-example-ignitetour/events",
    "assignees_url": "https://api.github.com/repos/sdras/d3-example-ignitetour/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/d3-example-ignitetour/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/d3-example-ignitetour/tags",
    "blobs_url": "https://api.github.com/repos/sdras/d3-example-ignitetour/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/d3-example-ignitetour/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/d3-example-ignitetour/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/d3-example-ignitetour/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/d3-example-ignitetour/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/d3-example-ignitetour/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/d3-example-ignitetour/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/d3-example-ignitetour/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/d3-example-ignitetour/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/d3-example-ignitetour/subscription",
    "commits_url": "https://api.github.com/repos/sdras/d3-example-ignitetour/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/d3-example-ignitetour/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/d3-example-ignitetour/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/d3-example-ignitetour/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/d3-example-ignitetour/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/d3-example-ignitetour/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/d3-example-ignitetour/merges",
    "archive_url": "https://api.github.com/repos/sdras/d3-example-ignitetour/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/d3-example-ignitetour/downloads",
    "issues_url": "https://api.github.com/repos/sdras/d3-example-ignitetour/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/d3-example-ignitetour/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/d3-example-ignitetour/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/d3-example-ignitetour/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/d3-example-ignitetour/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/d3-example-ignitetour/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/d3-example-ignitetour/deployments",
    "created_at": "2018-11-16T20:12:36Z",
    "updated_at": "2020-05-17T04:12:26Z",
    "pushed_at": "2018-12-10T11:57:10Z",
    "git_url": "git://github.com/sdras/d3-example-ignitetour.git",
    "ssh_url": "git@github.com:sdras/d3-example-ignitetour.git",
    "clone_url": "https://github.com/sdras/d3-example-ignitetour.git",
    "svn_url": "https://github.com/sdras/d3-example-ignitetour",
    "homepage": "",
    "size": 139,
    "stargazers_count": 21,
    "watchers_count": 21,
    "language": "JavaScript",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 3,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "mit",
      "name": "MIT License",
      "spdx_id": "MIT",
      "url": "https://api.github.com/licenses/mit",
      "node_id": "MDc6TGljZW5zZTEz"
    },
    "forks": 3,
    "open_issues": 0,
    "watchers": 21,
    "default_branch": "master"
  },
  {
    "id": 104523154,
    "node_id": "MDEwOlJlcG9zaXRvcnkxMDQ1MjMxNTQ=",
    "name": "data-in-motion",
    "full_name": "sdras/data-in-motion",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/data-in-motion",
    "description": "My talk about the importance of animation in data visualizations",
    "fork": false,
    "url": "https://api.github.com/repos/sdras/data-in-motion",
    "forks_url": "https://api.github.com/repos/sdras/data-in-motion/forks",
    "keys_url": "https://api.github.com/repos/sdras/data-in-motion/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/data-in-motion/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/data-in-motion/teams",
    "hooks_url": "https://api.github.com/repos/sdras/data-in-motion/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/data-in-motion/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/data-in-motion/events",
    "assignees_url": "https://api.github.com/repos/sdras/data-in-motion/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/data-in-motion/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/data-in-motion/tags",
    "blobs_url": "https://api.github.com/repos/sdras/data-in-motion/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/data-in-motion/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/data-in-motion/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/data-in-motion/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/data-in-motion/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/data-in-motion/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/data-in-motion/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/data-in-motion/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/data-in-motion/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/data-in-motion/subscription",
    "commits_url": "https://api.github.com/repos/sdras/data-in-motion/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/data-in-motion/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/data-in-motion/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/data-in-motion/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/data-in-motion/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/data-in-motion/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/data-in-motion/merges",
    "archive_url": "https://api.github.com/repos/sdras/data-in-motion/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/data-in-motion/downloads",
    "issues_url": "https://api.github.com/repos/sdras/data-in-motion/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/data-in-motion/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/data-in-motion/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/data-in-motion/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/data-in-motion/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/data-in-motion/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/data-in-motion/deployments",
    "created_at": "2017-09-22T22:15:41Z",
    "updated_at": "2020-07-24T05:52:09Z",
    "pushed_at": "2017-09-22T22:24:05Z",
    "git_url": "git://github.com/sdras/data-in-motion.git",
    "ssh_url": "git@github.com:sdras/data-in-motion.git",
    "clone_url": "https://github.com/sdras/data-in-motion.git",
    "svn_url": "https://github.com/sdras/data-in-motion",
    "homepage": null,
    "size": 467545,
    "stargazers_count": 14,
    "watchers_count": 14,
    "language": "JavaScript",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": true,
    "forks_count": 1,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 1,
    "open_issues": 0,
    "watchers": 14,
    "default_branch": "master"
  },
  {
    "id": 149911333,
    "node_id": "MDEwOlJlcG9zaXRvcnkxNDk5MTEzMzM=",
    "name": "design-for-developers",
    "full_name": "sdras/design-for-developers",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/design-for-developers",
    "description": "Design for Developers Workshop",
    "fork": false,
    "url": "https://api.github.com/repos/sdras/design-for-developers",
    "forks_url": "https://api.github.com/repos/sdras/design-for-developers/forks",
    "keys_url": "https://api.github.com/repos/sdras/design-for-developers/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/design-for-developers/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/design-for-developers/teams",
    "hooks_url": "https://api.github.com/repos/sdras/design-for-developers/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/design-for-developers/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/design-for-developers/events",
    "assignees_url": "https://api.github.com/repos/sdras/design-for-developers/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/design-for-developers/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/design-for-developers/tags",
    "blobs_url": "https://api.github.com/repos/sdras/design-for-developers/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/design-for-developers/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/design-for-developers/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/design-for-developers/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/design-for-developers/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/design-for-developers/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/design-for-developers/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/design-for-developers/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/design-for-developers/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/design-for-developers/subscription",
    "commits_url": "https://api.github.com/repos/sdras/design-for-developers/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/design-for-developers/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/design-for-developers/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/design-for-developers/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/design-for-developers/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/design-for-developers/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/design-for-developers/merges",
    "archive_url": "https://api.github.com/repos/sdras/design-for-developers/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/design-for-developers/downloads",
    "issues_url": "https://api.github.com/repos/sdras/design-for-developers/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/design-for-developers/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/design-for-developers/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/design-for-developers/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/design-for-developers/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/design-for-developers/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/design-for-developers/deployments",
    "created_at": "2018-09-22T19:42:40Z",
    "updated_at": "2021-01-14T21:53:23Z",
    "pushed_at": "2019-01-15T00:44:00Z",
    "git_url": "git://github.com/sdras/design-for-developers.git",
    "ssh_url": "git@github.com:sdras/design-for-developers.git",
    "clone_url": "https://github.com/sdras/design-for-developers.git",
    "svn_url": "https://github.com/sdras/design-for-developers",
    "homepage": "https://frontendmasters.com/courses/design-for-developers/",
    "size": 74970,
    "stargazers_count": 553,
    "watchers_count": 553,
    "language": null,
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 124,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 1,
    "license": null,
    "forks": 124,
    "open_issues": 1,
    "watchers": 553,
    "default_branch": "master"
  },
  {
    "id": 260720499,
    "node_id": "MDEwOlJlcG9zaXRvcnkyNjA3MjA0OTk=",
    "name": "devex-utm-builder",
    "full_name": "sdras/devex-utm-builder",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/devex-utm-builder",
    "description": null,
    "fork": false,
    "url": "https://api.github.com/repos/sdras/devex-utm-builder",
    "forks_url": "https://api.github.com/repos/sdras/devex-utm-builder/forks",
    "keys_url": "https://api.github.com/repos/sdras/devex-utm-builder/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/devex-utm-builder/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/devex-utm-builder/teams",
    "hooks_url": "https://api.github.com/repos/sdras/devex-utm-builder/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/devex-utm-builder/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/devex-utm-builder/events",
    "assignees_url": "https://api.github.com/repos/sdras/devex-utm-builder/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/devex-utm-builder/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/devex-utm-builder/tags",
    "blobs_url": "https://api.github.com/repos/sdras/devex-utm-builder/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/devex-utm-builder/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/devex-utm-builder/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/devex-utm-builder/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/devex-utm-builder/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/devex-utm-builder/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/devex-utm-builder/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/devex-utm-builder/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/devex-utm-builder/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/devex-utm-builder/subscription",
    "commits_url": "https://api.github.com/repos/sdras/devex-utm-builder/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/devex-utm-builder/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/devex-utm-builder/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/devex-utm-builder/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/devex-utm-builder/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/devex-utm-builder/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/devex-utm-builder/merges",
    "archive_url": "https://api.github.com/repos/sdras/devex-utm-builder/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/devex-utm-builder/downloads",
    "issues_url": "https://api.github.com/repos/sdras/devex-utm-builder/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/devex-utm-builder/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/devex-utm-builder/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/devex-utm-builder/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/devex-utm-builder/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/devex-utm-builder/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/devex-utm-builder/deployments",
    "created_at": "2020-05-02T15:48:18Z",
    "updated_at": "2021-01-12T20:30:14Z",
    "pushed_at": "2021-01-12T03:15:58Z",
    "git_url": "git://github.com/sdras/devex-utm-builder.git",
    "ssh_url": "git@github.com:sdras/devex-utm-builder.git",
    "clone_url": "https://github.com/sdras/devex-utm-builder.git",
    "svn_url": "https://github.com/sdras/devex-utm-builder",
    "homepage": "",
    "size": 87,
    "stargazers_count": 5,
    "watchers_count": 5,
    "language": "HTML",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 3,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 1,
    "license": {
      "key": "bsd-3-clause",
      "name": "BSD 3-Clause \"New\" or \"Revised\" License",
      "spdx_id": "BSD-3-Clause",
      "url": "https://api.github.com/licenses/bsd-3-clause",
      "node_id": "MDc6TGljZW5zZTU="
    },
    "forks": 3,
    "open_issues": 1,
    "watchers": 5,
    "default_branch": "master"
  },
  {
    "id": 150484585,
    "node_id": "MDEwOlJlcG9zaXRvcnkxNTA0ODQ1ODU=",
    "name": "durablefunctions-apiscraping-nodejs",
    "full_name": "sdras/durablefunctions-apiscraping-nodejs",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/durablefunctions-apiscraping-nodejs",
    "description": "Build an Azure Durable Functions that will scrape GitHub for opened issues and store them on Azure Storage.",
    "fork": true,
    "url": "https://api.github.com/repos/sdras/durablefunctions-apiscraping-nodejs",
    "forks_url": "https://api.github.com/repos/sdras/durablefunctions-apiscraping-nodejs/forks",
    "keys_url": "https://api.github.com/repos/sdras/durablefunctions-apiscraping-nodejs/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/durablefunctions-apiscraping-nodejs/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/durablefunctions-apiscraping-nodejs/teams",
    "hooks_url": "https://api.github.com/repos/sdras/durablefunctions-apiscraping-nodejs/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/durablefunctions-apiscraping-nodejs/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/durablefunctions-apiscraping-nodejs/events",
    "assignees_url": "https://api.github.com/repos/sdras/durablefunctions-apiscraping-nodejs/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/durablefunctions-apiscraping-nodejs/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/durablefunctions-apiscraping-nodejs/tags",
    "blobs_url": "https://api.github.com/repos/sdras/durablefunctions-apiscraping-nodejs/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/durablefunctions-apiscraping-nodejs/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/durablefunctions-apiscraping-nodejs/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/durablefunctions-apiscraping-nodejs/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/durablefunctions-apiscraping-nodejs/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/durablefunctions-apiscraping-nodejs/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/durablefunctions-apiscraping-nodejs/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/durablefunctions-apiscraping-nodejs/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/durablefunctions-apiscraping-nodejs/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/durablefunctions-apiscraping-nodejs/subscription",
    "commits_url": "https://api.github.com/repos/sdras/durablefunctions-apiscraping-nodejs/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/durablefunctions-apiscraping-nodejs/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/durablefunctions-apiscraping-nodejs/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/durablefunctions-apiscraping-nodejs/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/durablefunctions-apiscraping-nodejs/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/durablefunctions-apiscraping-nodejs/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/durablefunctions-apiscraping-nodejs/merges",
    "archive_url": "https://api.github.com/repos/sdras/durablefunctions-apiscraping-nodejs/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/durablefunctions-apiscraping-nodejs/downloads",
    "issues_url": "https://api.github.com/repos/sdras/durablefunctions-apiscraping-nodejs/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/durablefunctions-apiscraping-nodejs/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/durablefunctions-apiscraping-nodejs/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/durablefunctions-apiscraping-nodejs/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/durablefunctions-apiscraping-nodejs/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/durablefunctions-apiscraping-nodejs/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/durablefunctions-apiscraping-nodejs/deployments",
    "created_at": "2018-09-26T20:13:44Z",
    "updated_at": "2018-09-26T20:13:46Z",
    "pushed_at": "2018-09-28T23:53:12Z",
    "git_url": "git://github.com/sdras/durablefunctions-apiscraping-nodejs.git",
    "ssh_url": "git@github.com:sdras/durablefunctions-apiscraping-nodejs.git",
    "clone_url": "https://github.com/sdras/durablefunctions-apiscraping-nodejs.git",
    "svn_url": "https://github.com/sdras/durablefunctions-apiscraping-nodejs",
    "homepage": null,
    "size": 27,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "JavaScript",
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": false,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "mit",
      "name": "MIT License",
      "spdx_id": "MIT",
      "url": "https://api.github.com/licenses/mit",
      "node_id": "MDc6TGljZW5zZTEz"
    },
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 211209452,
    "node_id": "MDEwOlJlcG9zaXRvcnkyMTEyMDk0NTI=",
    "name": "easiest-netlify-lambda-example",
    "full_name": "sdras/easiest-netlify-lambda-example",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/easiest-netlify-lambda-example",
    "description": null,
    "fork": false,
    "url": "https://api.github.com/repos/sdras/easiest-netlify-lambda-example",
    "forks_url": "https://api.github.com/repos/sdras/easiest-netlify-lambda-example/forks",
    "keys_url": "https://api.github.com/repos/sdras/easiest-netlify-lambda-example/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/easiest-netlify-lambda-example/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/easiest-netlify-lambda-example/teams",
    "hooks_url": "https://api.github.com/repos/sdras/easiest-netlify-lambda-example/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/easiest-netlify-lambda-example/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/easiest-netlify-lambda-example/events",
    "assignees_url": "https://api.github.com/repos/sdras/easiest-netlify-lambda-example/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/easiest-netlify-lambda-example/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/easiest-netlify-lambda-example/tags",
    "blobs_url": "https://api.github.com/repos/sdras/easiest-netlify-lambda-example/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/easiest-netlify-lambda-example/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/easiest-netlify-lambda-example/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/easiest-netlify-lambda-example/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/easiest-netlify-lambda-example/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/easiest-netlify-lambda-example/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/easiest-netlify-lambda-example/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/easiest-netlify-lambda-example/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/easiest-netlify-lambda-example/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/easiest-netlify-lambda-example/subscription",
    "commits_url": "https://api.github.com/repos/sdras/easiest-netlify-lambda-example/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/easiest-netlify-lambda-example/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/easiest-netlify-lambda-example/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/easiest-netlify-lambda-example/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/easiest-netlify-lambda-example/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/easiest-netlify-lambda-example/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/easiest-netlify-lambda-example/merges",
    "archive_url": "https://api.github.com/repos/sdras/easiest-netlify-lambda-example/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/easiest-netlify-lambda-example/downloads",
    "issues_url": "https://api.github.com/repos/sdras/easiest-netlify-lambda-example/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/easiest-netlify-lambda-example/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/easiest-netlify-lambda-example/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/easiest-netlify-lambda-example/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/easiest-netlify-lambda-example/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/easiest-netlify-lambda-example/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/easiest-netlify-lambda-example/deployments",
    "created_at": "2019-09-27T01:14:31Z",
    "updated_at": "2019-10-01T19:56:35Z",
    "pushed_at": "2019-09-27T01:47:24Z",
    "git_url": "git://github.com/sdras/easiest-netlify-lambda-example.git",
    "ssh_url": "git@github.com:sdras/easiest-netlify-lambda-example.git",
    "clone_url": "https://github.com/sdras/easiest-netlify-lambda-example.git",
    "svn_url": "https://github.com/sdras/easiest-netlify-lambda-example",
    "homepage": null,
    "size": 6,
    "stargazers_count": 5,
    "watchers_count": 5,
    "language": "JavaScript",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "mit",
      "name": "MIT License",
      "spdx_id": "MIT",
      "url": "https://api.github.com/licenses/mit",
      "node_id": "MDc6TGljZW5zZTEz"
    },
    "forks": 0,
    "open_issues": 0,
    "watchers": 5,
    "default_branch": "master"
  },
  {
    "id": 195306388,
    "node_id": "MDEwOlJlcG9zaXRvcnkxOTUzMDYzODg=",
    "name": "ecommerce-netlify",
    "full_name": "sdras/ecommerce-netlify",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/ecommerce-netlify",
    "description": "🛍 A JAMstack Ecommerce Site built with Nuxt and Netlify Functions",
    "fork": false,
    "url": "https://api.github.com/repos/sdras/ecommerce-netlify",
    "forks_url": "https://api.github.com/repos/sdras/ecommerce-netlify/forks",
    "keys_url": "https://api.github.com/repos/sdras/ecommerce-netlify/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/ecommerce-netlify/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/ecommerce-netlify/teams",
    "hooks_url": "https://api.github.com/repos/sdras/ecommerce-netlify/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/ecommerce-netlify/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/ecommerce-netlify/events",
    "assignees_url": "https://api.github.com/repos/sdras/ecommerce-netlify/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/ecommerce-netlify/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/ecommerce-netlify/tags",
    "blobs_url": "https://api.github.com/repos/sdras/ecommerce-netlify/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/ecommerce-netlify/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/ecommerce-netlify/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/ecommerce-netlify/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/ecommerce-netlify/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/ecommerce-netlify/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/ecommerce-netlify/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/ecommerce-netlify/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/ecommerce-netlify/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/ecommerce-netlify/subscription",
    "commits_url": "https://api.github.com/repos/sdras/ecommerce-netlify/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/ecommerce-netlify/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/ecommerce-netlify/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/ecommerce-netlify/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/ecommerce-netlify/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/ecommerce-netlify/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/ecommerce-netlify/merges",
    "archive_url": "https://api.github.com/repos/sdras/ecommerce-netlify/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/ecommerce-netlify/downloads",
    "issues_url": "https://api.github.com/repos/sdras/ecommerce-netlify/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/ecommerce-netlify/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/ecommerce-netlify/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/ecommerce-netlify/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/ecommerce-netlify/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/ecommerce-netlify/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/ecommerce-netlify/deployments",
    "created_at": "2019-07-04T22:17:31Z",
    "updated_at": "2021-01-13T15:11:11Z",
    "pushed_at": "2021-01-05T15:06:19Z",
    "git_url": "git://github.com/sdras/ecommerce-netlify.git",
    "ssh_url": "git@github.com:sdras/ecommerce-netlify.git",
    "clone_url": "https://github.com/sdras/ecommerce-netlify.git",
    "svn_url": "https://github.com/sdras/ecommerce-netlify",
    "homepage": "https://ecommerce-netlify.netlify.app/",
    "size": 1105,
    "stargazers_count": 1064,
    "watchers_count": 1064,
    "language": "Vue",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 297,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 8,
    "license": null,
    "forks": 297,
    "open_issues": 8,
    "watchers": 1064,
    "default_branch": "master"
  },
  {
    "id": 153392539,
    "node_id": "MDEwOlJlcG9zaXRvcnkxNTMzOTI1Mzk=",
    "name": "example-azure-node",
    "full_name": "sdras/example-azure-node",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/example-azure-node",
    "description": "An example Node webapp deployed with GitHub actions",
    "fork": false,
    "url": "https://api.github.com/repos/sdras/example-azure-node",
    "forks_url": "https://api.github.com/repos/sdras/example-azure-node/forks",
    "keys_url": "https://api.github.com/repos/sdras/example-azure-node/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/example-azure-node/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/example-azure-node/teams",
    "hooks_url": "https://api.github.com/repos/sdras/example-azure-node/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/example-azure-node/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/example-azure-node/events",
    "assignees_url": "https://api.github.com/repos/sdras/example-azure-node/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/example-azure-node/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/example-azure-node/tags",
    "blobs_url": "https://api.github.com/repos/sdras/example-azure-node/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/example-azure-node/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/example-azure-node/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/example-azure-node/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/example-azure-node/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/example-azure-node/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/example-azure-node/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/example-azure-node/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/example-azure-node/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/example-azure-node/subscription",
    "commits_url": "https://api.github.com/repos/sdras/example-azure-node/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/example-azure-node/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/example-azure-node/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/example-azure-node/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/example-azure-node/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/example-azure-node/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/example-azure-node/merges",
    "archive_url": "https://api.github.com/repos/sdras/example-azure-node/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/example-azure-node/downloads",
    "issues_url": "https://api.github.com/repos/sdras/example-azure-node/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/example-azure-node/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/example-azure-node/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/example-azure-node/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/example-azure-node/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/example-azure-node/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/example-azure-node/deployments",
    "created_at": "2018-10-17T03:51:51Z",
    "updated_at": "2020-09-29T13:56:15Z",
    "pushed_at": "2019-08-28T15:16:42Z",
    "git_url": "git://github.com/sdras/example-azure-node.git",
    "ssh_url": "git@github.com:sdras/example-azure-node.git",
    "clone_url": "https://github.com/sdras/example-azure-node.git",
    "svn_url": "https://github.com/sdras/example-azure-node",
    "homepage": null,
    "size": 7,
    "stargazers_count": 68,
    "watchers_count": 68,
    "language": "Shell",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 39,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 1,
    "license": {
      "key": "mit",
      "name": "MIT License",
      "spdx_id": "MIT",
      "url": "https://api.github.com/licenses/mit",
      "node_id": "MDc6TGljZW5zZTEz"
    },
    "forks": 39,
    "open_issues": 1,
    "watchers": 68,
    "default_branch": "master"
  },
  {
    "id": 304960633,
    "node_id": "MDEwOlJlcG9zaXRvcnkzMDQ5NjA2MzM=",
    "name": "favegame",
    "full_name": "sdras/favegame",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/favegame",
    "description": "Small starter example of Hasura, Nuxt, and Netlify for Jamstack/SSR rendering",
    "fork": false,
    "url": "https://api.github.com/repos/sdras/favegame",
    "forks_url": "https://api.github.com/repos/sdras/favegame/forks",
    "keys_url": "https://api.github.com/repos/sdras/favegame/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/favegame/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/favegame/teams",
    "hooks_url": "https://api.github.com/repos/sdras/favegame/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/favegame/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/favegame/events",
    "assignees_url": "https://api.github.com/repos/sdras/favegame/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/favegame/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/favegame/tags",
    "blobs_url": "https://api.github.com/repos/sdras/favegame/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/favegame/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/favegame/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/favegame/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/favegame/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/favegame/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/favegame/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/favegame/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/favegame/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/favegame/subscription",
    "commits_url": "https://api.github.com/repos/sdras/favegame/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/favegame/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/favegame/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/favegame/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/favegame/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/favegame/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/favegame/merges",
    "archive_url": "https://api.github.com/repos/sdras/favegame/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/favegame/downloads",
    "issues_url": "https://api.github.com/repos/sdras/favegame/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/favegame/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/favegame/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/favegame/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/favegame/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/favegame/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/favegame/deployments",
    "created_at": "2020-10-17T20:08:42Z",
    "updated_at": "2021-01-11T22:04:48Z",
    "pushed_at": "2020-10-25T20:21:08Z",
    "git_url": "git://github.com/sdras/favegame.git",
    "ssh_url": "git@github.com:sdras/favegame.git",
    "clone_url": "https://github.com/sdras/favegame.git",
    "svn_url": "https://github.com/sdras/favegame",
    "homepage": "https://hasura-nuxt-demo.netlify.app/",
    "size": 675,
    "stargazers_count": 37,
    "watchers_count": 37,
    "language": "Vue",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 1,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 1,
    "open_issues": 0,
    "watchers": 37,
    "default_branch": "master"
  },
  {
    "id": 120164392,
    "node_id": "MDEwOlJlcG9zaXRvcnkxMjAxNjQzOTI=",
    "name": "firefighter-demo",
    "full_name": "sdras/firefighter-demo",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/firefighter-demo",
    "description": "🚨 Demo to improve an existing firefighter app by making it queue tasks offline",
    "fork": false,
    "url": "https://api.github.com/repos/sdras/firefighter-demo",
    "forks_url": "https://api.github.com/repos/sdras/firefighter-demo/forks",
    "keys_url": "https://api.github.com/repos/sdras/firefighter-demo/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/firefighter-demo/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/firefighter-demo/teams",
    "hooks_url": "https://api.github.com/repos/sdras/firefighter-demo/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/firefighter-demo/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/firefighter-demo/events",
    "assignees_url": "https://api.github.com/repos/sdras/firefighter-demo/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/firefighter-demo/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/firefighter-demo/tags",
    "blobs_url": "https://api.github.com/repos/sdras/firefighter-demo/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/firefighter-demo/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/firefighter-demo/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/firefighter-demo/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/firefighter-demo/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/firefighter-demo/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/firefighter-demo/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/firefighter-demo/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/firefighter-demo/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/firefighter-demo/subscription",
    "commits_url": "https://api.github.com/repos/sdras/firefighter-demo/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/firefighter-demo/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/firefighter-demo/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/firefighter-demo/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/firefighter-demo/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/firefighter-demo/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/firefighter-demo/merges",
    "archive_url": "https://api.github.com/repos/sdras/firefighter-demo/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/firefighter-demo/downloads",
    "issues_url": "https://api.github.com/repos/sdras/firefighter-demo/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/firefighter-demo/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/firefighter-demo/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/firefighter-demo/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/firefighter-demo/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/firefighter-demo/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/firefighter-demo/deployments",
    "created_at": "2018-02-04T07:29:17Z",
    "updated_at": "2020-07-07T10:17:36Z",
    "pushed_at": "2018-02-04T22:19:44Z",
    "git_url": "git://github.com/sdras/firefighter-demo.git",
    "ssh_url": "git@github.com:sdras/firefighter-demo.git",
    "clone_url": "https://github.com/sdras/firefighter-demo.git",
    "svn_url": "https://github.com/sdras/firefighter-demo",
    "homepage": "https://sdras.github.io/firefighter-demo/",
    "size": 13,
    "stargazers_count": 66,
    "watchers_count": 66,
    "language": "HTML",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": true,
    "forks_count": 4,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "mit",
      "name": "MIT License",
      "spdx_id": "MIT",
      "url": "https://api.github.com/licenses/mit",
      "node_id": "MDc6TGljZW5zZTEz"
    },
    "forks": 4,
    "open_issues": 0,
    "watchers": 66,
    "default_branch": "master"
  },
  {
    "id": 45194600,
    "node_id": "MDEwOlJlcG9zaXRvcnk0NTE5NDYwMA==",
    "name": "front-end-handbook",
    "full_name": "sdras/front-end-handbook",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/front-end-handbook",
    "description": null,
    "fork": true,
    "url": "https://api.github.com/repos/sdras/front-end-handbook",
    "forks_url": "https://api.github.com/repos/sdras/front-end-handbook/forks",
    "keys_url": "https://api.github.com/repos/sdras/front-end-handbook/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/front-end-handbook/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/front-end-handbook/teams",
    "hooks_url": "https://api.github.com/repos/sdras/front-end-handbook/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/front-end-handbook/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/front-end-handbook/events",
    "assignees_url": "https://api.github.com/repos/sdras/front-end-handbook/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/front-end-handbook/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/front-end-handbook/tags",
    "blobs_url": "https://api.github.com/repos/sdras/front-end-handbook/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/front-end-handbook/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/front-end-handbook/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/front-end-handbook/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/front-end-handbook/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/front-end-handbook/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/front-end-handbook/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/front-end-handbook/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/front-end-handbook/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/front-end-handbook/subscription",
    "commits_url": "https://api.github.com/repos/sdras/front-end-handbook/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/front-end-handbook/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/front-end-handbook/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/front-end-handbook/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/front-end-handbook/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/front-end-handbook/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/front-end-handbook/merges",
    "archive_url": "https://api.github.com/repos/sdras/front-end-handbook/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/front-end-handbook/downloads",
    "issues_url": "https://api.github.com/repos/sdras/front-end-handbook/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/front-end-handbook/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/front-end-handbook/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/front-end-handbook/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/front-end-handbook/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/front-end-handbook/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/front-end-handbook/deployments",
    "created_at": "2015-10-29T16:06:54Z",
    "updated_at": "2020-05-23T18:25:39Z",
    "pushed_at": "2015-10-29T16:17:16Z",
    "git_url": "git://github.com/sdras/front-end-handbook.git",
    "ssh_url": "git@github.com:sdras/front-end-handbook.git",
    "clone_url": "https://github.com/sdras/front-end-handbook.git",
    "svn_url": "https://github.com/sdras/front-end-handbook",
    "homepage": "",
    "size": 3973,
    "stargazers_count": 9,
    "watchers_count": 9,
    "language": "CSS",
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 9,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 9,
    "open_issues": 0,
    "watchers": 9,
    "default_branch": "master"
  },
  {
    "id": 44459340,
    "node_id": "MDEwOlJlcG9zaXRvcnk0NDQ1OTM0MA==",
    "name": "frontendmasters-svganimation",
    "full_name": "sdras/frontendmasters-svganimation",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/frontendmasters-svganimation",
    "description": "Frontend Masters- Advanced SVG Animation Course",
    "fork": false,
    "url": "https://api.github.com/repos/sdras/frontendmasters-svganimation",
    "forks_url": "https://api.github.com/repos/sdras/frontendmasters-svganimation/forks",
    "keys_url": "https://api.github.com/repos/sdras/frontendmasters-svganimation/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/frontendmasters-svganimation/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/frontendmasters-svganimation/teams",
    "hooks_url": "https://api.github.com/repos/sdras/frontendmasters-svganimation/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/frontendmasters-svganimation/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/frontendmasters-svganimation/events",
    "assignees_url": "https://api.github.com/repos/sdras/frontendmasters-svganimation/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/frontendmasters-svganimation/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/frontendmasters-svganimation/tags",
    "blobs_url": "https://api.github.com/repos/sdras/frontendmasters-svganimation/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/frontendmasters-svganimation/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/frontendmasters-svganimation/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/frontendmasters-svganimation/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/frontendmasters-svganimation/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/frontendmasters-svganimation/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/frontendmasters-svganimation/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/frontendmasters-svganimation/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/frontendmasters-svganimation/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/frontendmasters-svganimation/subscription",
    "commits_url": "https://api.github.com/repos/sdras/frontendmasters-svganimation/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/frontendmasters-svganimation/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/frontendmasters-svganimation/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/frontendmasters-svganimation/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/frontendmasters-svganimation/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/frontendmasters-svganimation/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/frontendmasters-svganimation/merges",
    "archive_url": "https://api.github.com/repos/sdras/frontendmasters-svganimation/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/frontendmasters-svganimation/downloads",
    "issues_url": "https://api.github.com/repos/sdras/frontendmasters-svganimation/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/frontendmasters-svganimation/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/frontendmasters-svganimation/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/frontendmasters-svganimation/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/frontendmasters-svganimation/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/frontendmasters-svganimation/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/frontendmasters-svganimation/deployments",
    "created_at": "2015-10-18T00:06:56Z",
    "updated_at": "2021-01-14T14:09:16Z",
    "pushed_at": "2015-10-19T00:46:27Z",
    "git_url": "git://github.com/sdras/frontendmasters-svganimation.git",
    "ssh_url": "git@github.com:sdras/frontendmasters-svganimation.git",
    "clone_url": "https://github.com/sdras/frontendmasters-svganimation.git",
    "svn_url": "https://github.com/sdras/frontendmasters-svganimation",
    "homepage": "",
    "size": 144,
    "stargazers_count": 189,
    "watchers_count": 189,
    "language": "HTML",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 30,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "mit",
      "name": "MIT License",
      "spdx_id": "MIT",
      "url": "https://api.github.com/licenses/mit",
      "node_id": "MDc6TGljZW5zZTEz"
    },
    "forks": 30,
    "open_issues": 0,
    "watchers": 189,
    "default_branch": "master"
  },
  {
    "id": 299991768,
    "node_id": "MDEwOlJlcG9zaXRvcnkyOTk5OTE3Njg=",
    "name": "functions",
    "full_name": "sdras/functions",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/functions",
    "description": "Playground repo for Netlify’s Lambda Functions",
    "fork": true,
    "url": "https://api.github.com/repos/sdras/functions",
    "forks_url": "https://api.github.com/repos/sdras/functions/forks",
    "keys_url": "https://api.github.com/repos/sdras/functions/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/functions/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/functions/teams",
    "hooks_url": "https://api.github.com/repos/sdras/functions/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/functions/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/functions/events",
    "assignees_url": "https://api.github.com/repos/sdras/functions/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/functions/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/functions/tags",
    "blobs_url": "https://api.github.com/repos/sdras/functions/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/functions/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/functions/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/functions/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/functions/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/functions/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/functions/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/functions/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/functions/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/functions/subscription",
    "commits_url": "https://api.github.com/repos/sdras/functions/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/functions/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/functions/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/functions/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/functions/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/functions/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/functions/merges",
    "archive_url": "https://api.github.com/repos/sdras/functions/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/functions/downloads",
    "issues_url": "https://api.github.com/repos/sdras/functions/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/functions/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/functions/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/functions/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/functions/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/functions/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/functions/deployments",
    "created_at": "2020-09-30T17:03:13Z",
    "updated_at": "2020-10-01T14:42:55Z",
    "pushed_at": "2020-09-15T23:12:13Z",
    "git_url": "git://github.com/sdras/functions.git",
    "ssh_url": "git@github.com:sdras/functions.git",
    "clone_url": "https://github.com/sdras/functions.git",
    "svn_url": "https://github.com/sdras/functions",
    "homepage": "https://functions-playground.netlify.com",
    "size": 659,
    "stargazers_count": 1,
    "watchers_count": 1,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 1,
    "default_branch": "master"
  },
  {
    "id": 219844424,
    "node_id": "MDEwOlJlcG9zaXRvcnkyMTk4NDQ0MjQ=",
    "name": "gatsby",
    "full_name": "sdras/gatsby",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/gatsby",
    "description": "Build blazing fast, modern apps and websites with React",
    "fork": true,
    "url": "https://api.github.com/repos/sdras/gatsby",
    "forks_url": "https://api.github.com/repos/sdras/gatsby/forks",
    "keys_url": "https://api.github.com/repos/sdras/gatsby/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/gatsby/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/gatsby/teams",
    "hooks_url": "https://api.github.com/repos/sdras/gatsby/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/gatsby/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/gatsby/events",
    "assignees_url": "https://api.github.com/repos/sdras/gatsby/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/gatsby/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/gatsby/tags",
    "blobs_url": "https://api.github.com/repos/sdras/gatsby/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/gatsby/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/gatsby/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/gatsby/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/gatsby/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/gatsby/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/gatsby/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/gatsby/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/gatsby/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/gatsby/subscription",
    "commits_url": "https://api.github.com/repos/sdras/gatsby/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/gatsby/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/gatsby/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/gatsby/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/gatsby/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/gatsby/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/gatsby/merges",
    "archive_url": "https://api.github.com/repos/sdras/gatsby/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/gatsby/downloads",
    "issues_url": "https://api.github.com/repos/sdras/gatsby/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/gatsby/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/gatsby/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/gatsby/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/gatsby/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/gatsby/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/gatsby/deployments",
    "created_at": "2019-11-05T20:29:04Z",
    "updated_at": "2021-01-01T06:02:50Z",
    "pushed_at": "2019-11-13T23:06:11Z",
    "git_url": "git://github.com/sdras/gatsby.git",
    "ssh_url": "git@github.com:sdras/gatsby.git",
    "clone_url": "https://github.com/sdras/gatsby.git",
    "svn_url": "https://github.com/sdras/gatsby",
    "homepage": "https://www.gatsbyjs.org",
    "size": 660740,
    "stargazers_count": 5,
    "watchers_count": 5,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": false,
    "has_pages": false,
    "forks_count": 1,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "mit",
      "name": "MIT License",
      "spdx_id": "MIT",
      "url": "https://api.github.com/licenses/mit",
      "node_id": "MDc6TGljZW5zZTEz"
    },
    "forks": 1,
    "open_issues": 0,
    "watchers": 5,
    "default_branch": "master"
  },
  {
    "id": 148184011,
    "node_id": "MDEwOlJlcG9zaXRvcnkxNDgxODQwMTE=",
    "name": "github-release-notes",
    "full_name": "sdras/github-release-notes",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/github-release-notes",
    "description": "Node module to create a release or a changelog from a tag and uses issues or commits to creating the release notes.",
    "fork": true,
    "url": "https://api.github.com/repos/sdras/github-release-notes",
    "forks_url": "https://api.github.com/repos/sdras/github-release-notes/forks",
    "keys_url": "https://api.github.com/repos/sdras/github-release-notes/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/github-release-notes/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/github-release-notes/teams",
    "hooks_url": "https://api.github.com/repos/sdras/github-release-notes/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/github-release-notes/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/github-release-notes/events",
    "assignees_url": "https://api.github.com/repos/sdras/github-release-notes/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/github-release-notes/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/github-release-notes/tags",
    "blobs_url": "https://api.github.com/repos/sdras/github-release-notes/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/github-release-notes/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/github-release-notes/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/github-release-notes/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/github-release-notes/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/github-release-notes/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/github-release-notes/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/github-release-notes/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/github-release-notes/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/github-release-notes/subscription",
    "commits_url": "https://api.github.com/repos/sdras/github-release-notes/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/github-release-notes/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/github-release-notes/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/github-release-notes/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/github-release-notes/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/github-release-notes/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/github-release-notes/merges",
    "archive_url": "https://api.github.com/repos/sdras/github-release-notes/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/github-release-notes/downloads",
    "issues_url": "https://api.github.com/repos/sdras/github-release-notes/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/github-release-notes/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/github-release-notes/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/github-release-notes/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/github-release-notes/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/github-release-notes/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/github-release-notes/deployments",
    "created_at": "2018-09-10T16:17:36Z",
    "updated_at": "2020-01-27T17:13:12Z",
    "pushed_at": "2018-07-08T23:01:20Z",
    "git_url": "git://github.com/sdras/github-release-notes.git",
    "ssh_url": "git@github.com:sdras/github-release-notes.git",
    "clone_url": "https://github.com/sdras/github-release-notes.git",
    "svn_url": "https://github.com/sdras/github-release-notes",
    "homepage": "https://github-tools.github.io/github-release-notes/",
    "size": 3390,
    "stargazers_count": 3,
    "watchers_count": 3,
    "language": "JavaScript",
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": false,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "gpl-3.0",
      "name": "GNU General Public License v3.0",
      "spdx_id": "GPL-3.0",
      "url": "https://api.github.com/licenses/gpl-3.0",
      "node_id": "MDc6TGljZW5zZTk="
    },
    "forks": 0,
    "open_issues": 0,
    "watchers": 3,
    "default_branch": "master"
  },
  {
    "id": 254102010,
    "node_id": "MDEwOlJlcG9zaXRvcnkyNTQxMDIwMTA=",
    "name": "gotruejs-in-vue",
    "full_name": "sdras/gotruejs-in-vue",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/gotruejs-in-vue",
    "description": null,
    "fork": true,
    "url": "https://api.github.com/repos/sdras/gotruejs-in-vue",
    "forks_url": "https://api.github.com/repos/sdras/gotruejs-in-vue/forks",
    "keys_url": "https://api.github.com/repos/sdras/gotruejs-in-vue/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/gotruejs-in-vue/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/gotruejs-in-vue/teams",
    "hooks_url": "https://api.github.com/repos/sdras/gotruejs-in-vue/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/gotruejs-in-vue/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/gotruejs-in-vue/events",
    "assignees_url": "https://api.github.com/repos/sdras/gotruejs-in-vue/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/gotruejs-in-vue/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/gotruejs-in-vue/tags",
    "blobs_url": "https://api.github.com/repos/sdras/gotruejs-in-vue/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/gotruejs-in-vue/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/gotruejs-in-vue/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/gotruejs-in-vue/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/gotruejs-in-vue/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/gotruejs-in-vue/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/gotruejs-in-vue/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/gotruejs-in-vue/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/gotruejs-in-vue/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/gotruejs-in-vue/subscription",
    "commits_url": "https://api.github.com/repos/sdras/gotruejs-in-vue/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/gotruejs-in-vue/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/gotruejs-in-vue/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/gotruejs-in-vue/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/gotruejs-in-vue/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/gotruejs-in-vue/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/gotruejs-in-vue/merges",
    "archive_url": "https://api.github.com/repos/sdras/gotruejs-in-vue/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/gotruejs-in-vue/downloads",
    "issues_url": "https://api.github.com/repos/sdras/gotruejs-in-vue/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/gotruejs-in-vue/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/gotruejs-in-vue/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/gotruejs-in-vue/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/gotruejs-in-vue/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/gotruejs-in-vue/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/gotruejs-in-vue/deployments",
    "created_at": "2020-04-08T13:53:15Z",
    "updated_at": "2021-01-01T06:03:23Z",
    "pushed_at": "2019-09-24T02:07:50Z",
    "git_url": "git://github.com/sdras/gotruejs-in-vue.git",
    "ssh_url": "git@github.com:sdras/gotruejs-in-vue.git",
    "clone_url": "https://github.com/sdras/gotruejs-in-vue.git",
    "svn_url": "https://github.com/sdras/gotruejs-in-vue",
    "homepage": null,
    "size": 7577,
    "stargazers_count": 1,
    "watchers_count": 1,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 1,
    "default_branch": "master"
  },
  {
    "id": 84117686,
    "node_id": "MDEwOlJlcG9zaXRvcnk4NDExNzY4Ng==",
    "name": "gsap-player",
    "full_name": "sdras/gsap-player",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/gsap-player",
    "description": "A small, customizable youtube-like player for gsap timelines",
    "fork": false,
    "url": "https://api.github.com/repos/sdras/gsap-player",
    "forks_url": "https://api.github.com/repos/sdras/gsap-player/forks",
    "keys_url": "https://api.github.com/repos/sdras/gsap-player/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/gsap-player/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/gsap-player/teams",
    "hooks_url": "https://api.github.com/repos/sdras/gsap-player/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/gsap-player/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/gsap-player/events",
    "assignees_url": "https://api.github.com/repos/sdras/gsap-player/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/gsap-player/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/gsap-player/tags",
    "blobs_url": "https://api.github.com/repos/sdras/gsap-player/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/gsap-player/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/gsap-player/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/gsap-player/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/gsap-player/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/gsap-player/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/gsap-player/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/gsap-player/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/gsap-player/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/gsap-player/subscription",
    "commits_url": "https://api.github.com/repos/sdras/gsap-player/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/gsap-player/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/gsap-player/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/gsap-player/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/gsap-player/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/gsap-player/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/gsap-player/merges",
    "archive_url": "https://api.github.com/repos/sdras/gsap-player/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/gsap-player/downloads",
    "issues_url": "https://api.github.com/repos/sdras/gsap-player/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/gsap-player/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/gsap-player/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/gsap-player/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/gsap-player/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/gsap-player/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/gsap-player/deployments",
    "created_at": "2017-03-06T20:29:06Z",
    "updated_at": "2020-11-16T17:59:12Z",
    "pushed_at": "2017-03-09T15:50:36Z",
    "git_url": "git://github.com/sdras/gsap-player.git",
    "ssh_url": "git@github.com:sdras/gsap-player.git",
    "clone_url": "https://github.com/sdras/gsap-player.git",
    "svn_url": "https://github.com/sdras/gsap-player",
    "homepage": null,
    "size": 20,
    "stargazers_count": 92,
    "watchers_count": 92,
    "language": "JavaScript",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 10,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 2,
    "license": null,
    "forks": 10,
    "open_issues": 2,
    "watchers": 92,
    "default_branch": "master"
  },
  {
    "id": 254994570,
    "node_id": "MDEwOlJlcG9zaXRvcnkyNTQ5OTQ1NzA=",
    "name": "headless-wp-nuxt2",
    "full_name": "sdras/headless-wp-nuxt2",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/headless-wp-nuxt2",
    "description": null,
    "fork": false,
    "url": "https://api.github.com/repos/sdras/headless-wp-nuxt2",
    "forks_url": "https://api.github.com/repos/sdras/headless-wp-nuxt2/forks",
    "keys_url": "https://api.github.com/repos/sdras/headless-wp-nuxt2/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/headless-wp-nuxt2/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/headless-wp-nuxt2/teams",
    "hooks_url": "https://api.github.com/repos/sdras/headless-wp-nuxt2/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/headless-wp-nuxt2/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/headless-wp-nuxt2/events",
    "assignees_url": "https://api.github.com/repos/sdras/headless-wp-nuxt2/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/headless-wp-nuxt2/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/headless-wp-nuxt2/tags",
    "blobs_url": "https://api.github.com/repos/sdras/headless-wp-nuxt2/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/headless-wp-nuxt2/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/headless-wp-nuxt2/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/headless-wp-nuxt2/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/headless-wp-nuxt2/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/headless-wp-nuxt2/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/headless-wp-nuxt2/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/headless-wp-nuxt2/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/headless-wp-nuxt2/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/headless-wp-nuxt2/subscription",
    "commits_url": "https://api.github.com/repos/sdras/headless-wp-nuxt2/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/headless-wp-nuxt2/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/headless-wp-nuxt2/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/headless-wp-nuxt2/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/headless-wp-nuxt2/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/headless-wp-nuxt2/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/headless-wp-nuxt2/merges",
    "archive_url": "https://api.github.com/repos/sdras/headless-wp-nuxt2/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/headless-wp-nuxt2/downloads",
    "issues_url": "https://api.github.com/repos/sdras/headless-wp-nuxt2/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/headless-wp-nuxt2/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/headless-wp-nuxt2/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/headless-wp-nuxt2/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/headless-wp-nuxt2/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/headless-wp-nuxt2/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/headless-wp-nuxt2/deployments",
    "created_at": "2020-04-12T02:33:13Z",
    "updated_at": "2021-01-08T12:02:10Z",
    "pushed_at": "2021-01-06T00:14:14Z",
    "git_url": "git://github.com/sdras/headless-wp-nuxt2.git",
    "ssh_url": "git@github.com:sdras/headless-wp-nuxt2.git",
    "clone_url": "https://github.com/sdras/headless-wp-nuxt2.git",
    "svn_url": "https://github.com/sdras/headless-wp-nuxt2",
    "homepage": null,
    "size": 2991,
    "stargazers_count": 28,
    "watchers_count": 28,
    "language": "Vue",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 7,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 6,
    "license": {
      "key": "mit",
      "name": "MIT License",
      "spdx_id": "MIT",
      "url": "https://api.github.com/licenses/mit",
      "node_id": "MDc6TGljZW5zZTEz"
    },
    "forks": 7,
    "open_issues": 6,
    "watchers": 28,
    "default_branch": "master"
  },
  {
    "id": 256776348,
    "node_id": "MDEwOlJlcG9zaXRvcnkyNTY3NzYzNDg=",
    "name": "hero-generator",
    "full_name": "sdras/hero-generator",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/hero-generator",
    "description": "🦸🏻‍♀️Hero Generator! Create a nice hero image for your site or app",
    "fork": false,
    "url": "https://api.github.com/repos/sdras/hero-generator",
    "forks_url": "https://api.github.com/repos/sdras/hero-generator/forks",
    "keys_url": "https://api.github.com/repos/sdras/hero-generator/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/hero-generator/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/hero-generator/teams",
    "hooks_url": "https://api.github.com/repos/sdras/hero-generator/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/hero-generator/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/hero-generator/events",
    "assignees_url": "https://api.github.com/repos/sdras/hero-generator/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/hero-generator/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/hero-generator/tags",
    "blobs_url": "https://api.github.com/repos/sdras/hero-generator/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/hero-generator/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/hero-generator/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/hero-generator/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/hero-generator/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/hero-generator/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/hero-generator/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/hero-generator/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/hero-generator/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/hero-generator/subscription",
    "commits_url": "https://api.github.com/repos/sdras/hero-generator/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/hero-generator/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/hero-generator/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/hero-generator/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/hero-generator/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/hero-generator/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/hero-generator/merges",
    "archive_url": "https://api.github.com/repos/sdras/hero-generator/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/hero-generator/downloads",
    "issues_url": "https://api.github.com/repos/sdras/hero-generator/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/hero-generator/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/hero-generator/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/hero-generator/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/hero-generator/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/hero-generator/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/hero-generator/deployments",
    "created_at": "2020-04-18T14:39:32Z",
    "updated_at": "2021-01-14T06:28:27Z",
    "pushed_at": "2020-12-12T15:40:17Z",
    "git_url": "git://github.com/sdras/hero-generator.git",
    "ssh_url": "git@github.com:sdras/hero-generator.git",
    "clone_url": "https://github.com/sdras/hero-generator.git",
    "svn_url": "https://github.com/sdras/hero-generator",
    "homepage": "https://hero-generator.netlify.app/",
    "size": 4961,
    "stargazers_count": 542,
    "watchers_count": 542,
    "language": "Vue",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 48,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 7,
    "license": null,
    "forks": 48,
    "open_issues": 7,
    "watchers": 542,
    "default_branch": "master"
  },
  {
    "id": 149821604,
    "node_id": "MDEwOlJlcG9zaXRvcnkxNDk4MjE2MDQ=",
    "name": "ignite-2018",
    "full_name": "sdras/ignite-2018",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/ignite-2018",
    "description": null,
    "fork": true,
    "url": "https://api.github.com/repos/sdras/ignite-2018",
    "forks_url": "https://api.github.com/repos/sdras/ignite-2018/forks",
    "keys_url": "https://api.github.com/repos/sdras/ignite-2018/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/ignite-2018/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/ignite-2018/teams",
    "hooks_url": "https://api.github.com/repos/sdras/ignite-2018/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/ignite-2018/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/ignite-2018/events",
    "assignees_url": "https://api.github.com/repos/sdras/ignite-2018/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/ignite-2018/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/ignite-2018/tags",
    "blobs_url": "https://api.github.com/repos/sdras/ignite-2018/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/ignite-2018/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/ignite-2018/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/ignite-2018/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/ignite-2018/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/ignite-2018/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/ignite-2018/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/ignite-2018/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/ignite-2018/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/ignite-2018/subscription",
    "commits_url": "https://api.github.com/repos/sdras/ignite-2018/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/ignite-2018/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/ignite-2018/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/ignite-2018/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/ignite-2018/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/ignite-2018/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/ignite-2018/merges",
    "archive_url": "https://api.github.com/repos/sdras/ignite-2018/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/ignite-2018/downloads",
    "issues_url": "https://api.github.com/repos/sdras/ignite-2018/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/ignite-2018/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/ignite-2018/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/ignite-2018/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/ignite-2018/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/ignite-2018/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/ignite-2018/deployments",
    "created_at": "2018-09-21T21:46:39Z",
    "updated_at": "2018-09-21T21:49:11Z",
    "pushed_at": "2018-09-21T21:49:10Z",
    "git_url": "git://github.com/sdras/ignite-2018.git",
    "ssh_url": "git@github.com:sdras/ignite-2018.git",
    "clone_url": "https://github.com/sdras/ignite-2018.git",
    "svn_url": "https://github.com/sdras/ignite-2018",
    "homepage": null,
    "size": 1393,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "CSS",
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 298932375,
    "node_id": "MDEwOlJlcG9zaXRvcnkyOTg5MzIzNzU=",
    "name": "inbedby7pm",
    "full_name": "sdras/inbedby7pm",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/inbedby7pm",
    "description": "My other theme was for Night Owls like myself. This theme was requested for by the \"In Bed by 7pm\" crowd",
    "fork": false,
    "url": "https://api.github.com/repos/sdras/inbedby7pm",
    "forks_url": "https://api.github.com/repos/sdras/inbedby7pm/forks",
    "keys_url": "https://api.github.com/repos/sdras/inbedby7pm/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/inbedby7pm/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/inbedby7pm/teams",
    "hooks_url": "https://api.github.com/repos/sdras/inbedby7pm/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/inbedby7pm/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/inbedby7pm/events",
    "assignees_url": "https://api.github.com/repos/sdras/inbedby7pm/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/inbedby7pm/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/inbedby7pm/tags",
    "blobs_url": "https://api.github.com/repos/sdras/inbedby7pm/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/inbedby7pm/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/inbedby7pm/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/inbedby7pm/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/inbedby7pm/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/inbedby7pm/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/inbedby7pm/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/inbedby7pm/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/inbedby7pm/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/inbedby7pm/subscription",
    "commits_url": "https://api.github.com/repos/sdras/inbedby7pm/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/inbedby7pm/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/inbedby7pm/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/inbedby7pm/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/inbedby7pm/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/inbedby7pm/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/inbedby7pm/merges",
    "archive_url": "https://api.github.com/repos/sdras/inbedby7pm/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/inbedby7pm/downloads",
    "issues_url": "https://api.github.com/repos/sdras/inbedby7pm/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/inbedby7pm/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/inbedby7pm/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/inbedby7pm/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/inbedby7pm/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/inbedby7pm/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/inbedby7pm/deployments",
    "created_at": "2020-09-27T01:53:06Z",
    "updated_at": "2021-01-07T16:20:05Z",
    "pushed_at": "2020-10-31T12:06:43Z",
    "git_url": "git://github.com/sdras/inbedby7pm.git",
    "ssh_url": "git@github.com:sdras/inbedby7pm.git",
    "clone_url": "https://github.com/sdras/inbedby7pm.git",
    "svn_url": "https://github.com/sdras/inbedby7pm",
    "homepage": "https://marketplace.visualstudio.com/items?itemName=sdras.inbedby7pm",
    "size": 1715,
    "stargazers_count": 108,
    "watchers_count": 108,
    "language": null,
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 8,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 9,
    "license": null,
    "forks": 8,
    "open_issues": 9,
    "watchers": 108,
    "default_branch": "master"
  },
  {
    "id": 96451164,
    "node_id": "MDEwOlJlcG9zaXRvcnk5NjQ1MTE2NA==",
    "name": "intro-to-vue",
    "full_name": "sdras/intro-to-vue",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/intro-to-vue",
    "description": "Workshop Materials for my Introduction to Vue.js Workshop",
    "fork": false,
    "url": "https://api.github.com/repos/sdras/intro-to-vue",
    "forks_url": "https://api.github.com/repos/sdras/intro-to-vue/forks",
    "keys_url": "https://api.github.com/repos/sdras/intro-to-vue/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/intro-to-vue/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/intro-to-vue/teams",
    "hooks_url": "https://api.github.com/repos/sdras/intro-to-vue/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/intro-to-vue/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/intro-to-vue/events",
    "assignees_url": "https://api.github.com/repos/sdras/intro-to-vue/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/intro-to-vue/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/intro-to-vue/tags",
    "blobs_url": "https://api.github.com/repos/sdras/intro-to-vue/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/intro-to-vue/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/intro-to-vue/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/intro-to-vue/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/intro-to-vue/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/intro-to-vue/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/intro-to-vue/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/intro-to-vue/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/intro-to-vue/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/intro-to-vue/subscription",
    "commits_url": "https://api.github.com/repos/sdras/intro-to-vue/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/intro-to-vue/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/intro-to-vue/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/intro-to-vue/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/intro-to-vue/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/intro-to-vue/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/intro-to-vue/merges",
    "archive_url": "https://api.github.com/repos/sdras/intro-to-vue/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/intro-to-vue/downloads",
    "issues_url": "https://api.github.com/repos/sdras/intro-to-vue/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/intro-to-vue/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/intro-to-vue/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/intro-to-vue/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/intro-to-vue/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/intro-to-vue/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/intro-to-vue/deployments",
    "created_at": "2017-07-06T16:36:55Z",
    "updated_at": "2021-01-14T18:37:39Z",
    "pushed_at": "2020-12-13T03:05:00Z",
    "git_url": "git://github.com/sdras/intro-to-vue.git",
    "ssh_url": "git@github.com:sdras/intro-to-vue.git",
    "clone_url": "https://github.com/sdras/intro-to-vue.git",
    "svn_url": "https://github.com/sdras/intro-to-vue",
    "homepage": "https://frontendmasters.com/workshops/vue-v2/",
    "size": 1255,
    "stargazers_count": 2372,
    "watchers_count": 2372,
    "language": "Vue",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 510,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 10,
    "license": null,
    "forks": 510,
    "open_issues": 10,
    "watchers": 2372,
    "default_branch": "master"
  },
  {
    "id": 253121308,
    "node_id": "MDEwOlJlcG9zaXRvcnkyNTMxMjEzMDg=",
    "name": "is-this-a-sandwich",
    "full_name": "sdras/is-this-a-sandwich",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/is-this-a-sandwich",
    "description": "Is this a sandwich?",
    "fork": false,
    "url": "https://api.github.com/repos/sdras/is-this-a-sandwich",
    "forks_url": "https://api.github.com/repos/sdras/is-this-a-sandwich/forks",
    "keys_url": "https://api.github.com/repos/sdras/is-this-a-sandwich/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/is-this-a-sandwich/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/is-this-a-sandwich/teams",
    "hooks_url": "https://api.github.com/repos/sdras/is-this-a-sandwich/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/is-this-a-sandwich/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/is-this-a-sandwich/events",
    "assignees_url": "https://api.github.com/repos/sdras/is-this-a-sandwich/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/is-this-a-sandwich/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/is-this-a-sandwich/tags",
    "blobs_url": "https://api.github.com/repos/sdras/is-this-a-sandwich/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/is-this-a-sandwich/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/is-this-a-sandwich/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/is-this-a-sandwich/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/is-this-a-sandwich/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/is-this-a-sandwich/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/is-this-a-sandwich/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/is-this-a-sandwich/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/is-this-a-sandwich/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/is-this-a-sandwich/subscription",
    "commits_url": "https://api.github.com/repos/sdras/is-this-a-sandwich/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/is-this-a-sandwich/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/is-this-a-sandwich/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/is-this-a-sandwich/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/is-this-a-sandwich/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/is-this-a-sandwich/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/is-this-a-sandwich/merges",
    "archive_url": "https://api.github.com/repos/sdras/is-this-a-sandwich/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/is-this-a-sandwich/downloads",
    "issues_url": "https://api.github.com/repos/sdras/is-this-a-sandwich/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/is-this-a-sandwich/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/is-this-a-sandwich/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/is-this-a-sandwich/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/is-this-a-sandwich/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/is-this-a-sandwich/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/is-this-a-sandwich/deployments",
    "created_at": "2020-04-04T23:53:12Z",
    "updated_at": "2020-11-23T07:32:31Z",
    "pushed_at": "2020-09-12T18:41:23Z",
    "git_url": "git://github.com/sdras/is-this-a-sandwich.git",
    "ssh_url": "git@github.com:sdras/is-this-a-sandwich.git",
    "clone_url": "https://github.com/sdras/is-this-a-sandwich.git",
    "svn_url": "https://github.com/sdras/is-this-a-sandwich",
    "homepage": "https://isthisasandwich.netlify.com/",
    "size": 5057,
    "stargazers_count": 96,
    "watchers_count": 96,
    "language": "Vue",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 9,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 6,
    "license": null,
    "forks": 9,
    "open_issues": 6,
    "watchers": 96,
    "default_branch": "master"
  },
  {
    "id": 301778112,
    "node_id": "MDEwOlJlcG9zaXRvcnkzMDE3NzgxMTI=",
    "name": "jamstack-template",
    "full_name": "sdras/jamstack-template",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/jamstack-template",
    "description": null,
    "fork": false,
    "url": "https://api.github.com/repos/sdras/jamstack-template",
    "forks_url": "https://api.github.com/repos/sdras/jamstack-template/forks",
    "keys_url": "https://api.github.com/repos/sdras/jamstack-template/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/jamstack-template/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/jamstack-template/teams",
    "hooks_url": "https://api.github.com/repos/sdras/jamstack-template/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/jamstack-template/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/jamstack-template/events",
    "assignees_url": "https://api.github.com/repos/sdras/jamstack-template/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/jamstack-template/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/jamstack-template/tags",
    "blobs_url": "https://api.github.com/repos/sdras/jamstack-template/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/jamstack-template/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/jamstack-template/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/jamstack-template/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/jamstack-template/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/jamstack-template/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/jamstack-template/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/jamstack-template/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/jamstack-template/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/jamstack-template/subscription",
    "commits_url": "https://api.github.com/repos/sdras/jamstack-template/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/jamstack-template/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/jamstack-template/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/jamstack-template/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/jamstack-template/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/jamstack-template/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/jamstack-template/merges",
    "archive_url": "https://api.github.com/repos/sdras/jamstack-template/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/jamstack-template/downloads",
    "issues_url": "https://api.github.com/repos/sdras/jamstack-template/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/jamstack-template/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/jamstack-template/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/jamstack-template/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/jamstack-template/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/jamstack-template/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/jamstack-template/deployments",
    "created_at": "2020-10-06T15:49:13Z",
    "updated_at": "2020-10-14T14:39:40Z",
    "pushed_at": "2020-10-06T15:49:27Z",
    "git_url": "git://github.com/sdras/jamstack-template.git",
    "ssh_url": "git@github.com:sdras/jamstack-template.git",
    "clone_url": "https://github.com/sdras/jamstack-template.git",
    "svn_url": "https://github.com/sdras/jamstack-template",
    "homepage": null,
    "size": 2,
    "stargazers_count": 10,
    "watchers_count": 10,
    "language": "HTML",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 3,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 3,
    "open_issues": 0,
    "watchers": 10,
    "default_branch": "master"
  },
  {
    "id": 210421869,
    "node_id": "MDEwOlJlcG9zaXRvcnkyMTA0MjE4Njk=",
    "name": "JAMstack-Workshop",
    "full_name": "sdras/JAMstack-Workshop",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/JAMstack-Workshop",
    "description": "Workshop materials for JAMstack workshop using Vue and Netlify.",
    "fork": false,
    "url": "https://api.github.com/repos/sdras/JAMstack-Workshop",
    "forks_url": "https://api.github.com/repos/sdras/JAMstack-Workshop/forks",
    "keys_url": "https://api.github.com/repos/sdras/JAMstack-Workshop/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/JAMstack-Workshop/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/JAMstack-Workshop/teams",
    "hooks_url": "https://api.github.com/repos/sdras/JAMstack-Workshop/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/JAMstack-Workshop/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/JAMstack-Workshop/events",
    "assignees_url": "https://api.github.com/repos/sdras/JAMstack-Workshop/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/JAMstack-Workshop/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/JAMstack-Workshop/tags",
    "blobs_url": "https://api.github.com/repos/sdras/JAMstack-Workshop/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/JAMstack-Workshop/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/JAMstack-Workshop/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/JAMstack-Workshop/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/JAMstack-Workshop/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/JAMstack-Workshop/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/JAMstack-Workshop/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/JAMstack-Workshop/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/JAMstack-Workshop/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/JAMstack-Workshop/subscription",
    "commits_url": "https://api.github.com/repos/sdras/JAMstack-Workshop/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/JAMstack-Workshop/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/JAMstack-Workshop/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/JAMstack-Workshop/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/JAMstack-Workshop/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/JAMstack-Workshop/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/JAMstack-Workshop/merges",
    "archive_url": "https://api.github.com/repos/sdras/JAMstack-Workshop/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/JAMstack-Workshop/downloads",
    "issues_url": "https://api.github.com/repos/sdras/JAMstack-Workshop/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/JAMstack-Workshop/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/JAMstack-Workshop/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/JAMstack-Workshop/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/JAMstack-Workshop/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/JAMstack-Workshop/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/JAMstack-Workshop/deployments",
    "created_at": "2019-09-23T18:12:24Z",
    "updated_at": "2021-01-14T21:24:58Z",
    "pushed_at": "2020-12-11T22:07:26Z",
    "git_url": "git://github.com/sdras/JAMstack-Workshop.git",
    "ssh_url": "git@github.com:sdras/JAMstack-Workshop.git",
    "clone_url": "https://github.com/sdras/JAMstack-Workshop.git",
    "svn_url": "https://github.com/sdras/JAMstack-Workshop",
    "homepage": "",
    "size": 11208,
    "stargazers_count": 56,
    "watchers_count": 56,
    "language": "Vue",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 18,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 8,
    "license": null,
    "forks": 18,
    "open_issues": 8,
    "watchers": 56,
    "default_branch": "master"
  },
  {
    "id": 57518901,
    "node_id": "MDEwOlJlcG9zaXRvcnk1NzUxODkwMQ==",
    "name": "JS-stroll",
    "full_name": "sdras/JS-stroll",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/JS-stroll",
    "description": "Rewriting code from other languages or other technologies into Vanilla JS and SVG for fun and practice.",
    "fork": false,
    "url": "https://api.github.com/repos/sdras/JS-stroll",
    "forks_url": "https://api.github.com/repos/sdras/JS-stroll/forks",
    "keys_url": "https://api.github.com/repos/sdras/JS-stroll/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/JS-stroll/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/JS-stroll/teams",
    "hooks_url": "https://api.github.com/repos/sdras/JS-stroll/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/JS-stroll/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/JS-stroll/events",
    "assignees_url": "https://api.github.com/repos/sdras/JS-stroll/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/JS-stroll/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/JS-stroll/tags",
    "blobs_url": "https://api.github.com/repos/sdras/JS-stroll/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/JS-stroll/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/JS-stroll/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/JS-stroll/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/JS-stroll/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/JS-stroll/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/JS-stroll/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/JS-stroll/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/JS-stroll/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/JS-stroll/subscription",
    "commits_url": "https://api.github.com/repos/sdras/JS-stroll/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/JS-stroll/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/JS-stroll/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/JS-stroll/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/JS-stroll/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/JS-stroll/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/JS-stroll/merges",
    "archive_url": "https://api.github.com/repos/sdras/JS-stroll/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/JS-stroll/downloads",
    "issues_url": "https://api.github.com/repos/sdras/JS-stroll/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/JS-stroll/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/JS-stroll/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/JS-stroll/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/JS-stroll/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/JS-stroll/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/JS-stroll/deployments",
    "created_at": "2016-05-01T05:23:21Z",
    "updated_at": "2020-12-31T08:04:07Z",
    "pushed_at": "2017-02-12T21:42:16Z",
    "git_url": "git://github.com/sdras/JS-stroll.git",
    "ssh_url": "git@github.com:sdras/JS-stroll.git",
    "clone_url": "https://github.com/sdras/JS-stroll.git",
    "svn_url": "https://github.com/sdras/JS-stroll",
    "homepage": "",
    "size": 27,
    "stargazers_count": 212,
    "watchers_count": 212,
    "language": "JavaScript",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 14,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 14,
    "open_issues": 0,
    "watchers": 212,
    "default_branch": "master"
  },
  {
    "id": 33456390,
    "node_id": "MDEwOlJlcG9zaXRvcnkzMzQ1NjM5MA==",
    "name": "latency-benchmark",
    "full_name": "sdras/latency-benchmark",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/latency-benchmark",
    "description": "Tests web browser input latency and jank",
    "fork": true,
    "url": "https://api.github.com/repos/sdras/latency-benchmark",
    "forks_url": "https://api.github.com/repos/sdras/latency-benchmark/forks",
    "keys_url": "https://api.github.com/repos/sdras/latency-benchmark/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/latency-benchmark/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/latency-benchmark/teams",
    "hooks_url": "https://api.github.com/repos/sdras/latency-benchmark/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/latency-benchmark/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/latency-benchmark/events",
    "assignees_url": "https://api.github.com/repos/sdras/latency-benchmark/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/latency-benchmark/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/latency-benchmark/tags",
    "blobs_url": "https://api.github.com/repos/sdras/latency-benchmark/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/latency-benchmark/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/latency-benchmark/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/latency-benchmark/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/latency-benchmark/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/latency-benchmark/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/latency-benchmark/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/latency-benchmark/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/latency-benchmark/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/latency-benchmark/subscription",
    "commits_url": "https://api.github.com/repos/sdras/latency-benchmark/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/latency-benchmark/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/latency-benchmark/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/latency-benchmark/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/latency-benchmark/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/latency-benchmark/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/latency-benchmark/merges",
    "archive_url": "https://api.github.com/repos/sdras/latency-benchmark/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/latency-benchmark/downloads",
    "issues_url": "https://api.github.com/repos/sdras/latency-benchmark/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/latency-benchmark/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/latency-benchmark/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/latency-benchmark/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/latency-benchmark/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/latency-benchmark/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/latency-benchmark/deployments",
    "created_at": "2015-04-05T21:48:09Z",
    "updated_at": "2019-06-23T17:21:46Z",
    "pushed_at": "2014-01-08T02:33:44Z",
    "git_url": "git://github.com/sdras/latency-benchmark.git",
    "ssh_url": "git@github.com:sdras/latency-benchmark.git",
    "clone_url": "https://github.com/sdras/latency-benchmark.git",
    "svn_url": "https://github.com/sdras/latency-benchmark",
    "homepage": "http://google.github.io/latency-benchmark",
    "size": 3954,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "C",
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "apache-2.0",
      "name": "Apache License 2.0",
      "spdx_id": "Apache-2.0",
      "url": "https://api.github.com/licenses/apache-2.0",
      "node_id": "MDc6TGljZW5zZTI="
    },
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 137523268,
    "node_id": "MDEwOlJlcG9zaXRvcnkxMzc1MjMyNjg=",
    "name": "livecode-svganimation",
    "full_name": "sdras/livecode-svganimation",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/livecode-svganimation",
    "description": "In my Smashing Toronto talk, I'll be live coding an SVG animation from start to finish. Here's the repo that houses the base materials, and any further references for things we don't have time to cover.",
    "fork": false,
    "url": "https://api.github.com/repos/sdras/livecode-svganimation",
    "forks_url": "https://api.github.com/repos/sdras/livecode-svganimation/forks",
    "keys_url": "https://api.github.com/repos/sdras/livecode-svganimation/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/livecode-svganimation/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/livecode-svganimation/teams",
    "hooks_url": "https://api.github.com/repos/sdras/livecode-svganimation/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/livecode-svganimation/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/livecode-svganimation/events",
    "assignees_url": "https://api.github.com/repos/sdras/livecode-svganimation/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/livecode-svganimation/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/livecode-svganimation/tags",
    "blobs_url": "https://api.github.com/repos/sdras/livecode-svganimation/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/livecode-svganimation/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/livecode-svganimation/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/livecode-svganimation/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/livecode-svganimation/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/livecode-svganimation/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/livecode-svganimation/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/livecode-svganimation/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/livecode-svganimation/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/livecode-svganimation/subscription",
    "commits_url": "https://api.github.com/repos/sdras/livecode-svganimation/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/livecode-svganimation/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/livecode-svganimation/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/livecode-svganimation/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/livecode-svganimation/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/livecode-svganimation/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/livecode-svganimation/merges",
    "archive_url": "https://api.github.com/repos/sdras/livecode-svganimation/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/livecode-svganimation/downloads",
    "issues_url": "https://api.github.com/repos/sdras/livecode-svganimation/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/livecode-svganimation/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/livecode-svganimation/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/livecode-svganimation/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/livecode-svganimation/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/livecode-svganimation/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/livecode-svganimation/deployments",
    "created_at": "2018-06-15T19:11:07Z",
    "updated_at": "2020-11-27T08:37:49Z",
    "pushed_at": "2018-06-29T22:10:25Z",
    "git_url": "git://github.com/sdras/livecode-svganimation.git",
    "ssh_url": "git@github.com:sdras/livecode-svganimation.git",
    "clone_url": "https://github.com/sdras/livecode-svganimation.git",
    "svn_url": "https://github.com/sdras/livecode-svganimation",
    "homepage": null,
    "size": 6806,
    "stargazers_count": 95,
    "watchers_count": 95,
    "language": "JavaScript",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 15,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "mit",
      "name": "MIT License",
      "spdx_id": "MIT",
      "url": "https://api.github.com/licenses/mit",
      "node_id": "MDc6TGljZW5zZTEz"
    },
    "forks": 15,
    "open_issues": 0,
    "watchers": 95,
    "default_branch": "master"
  },
  {
    "id": 72151789,
    "node_id": "MDEwOlJlcG9zaXRvcnk3MjE1MTc4OQ==",
    "name": "mojs",
    "full_name": "sdras/mojs",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/mojs",
    "description": "motion graphics toolbelt for the web",
    "fork": true,
    "url": "https://api.github.com/repos/sdras/mojs",
    "forks_url": "https://api.github.com/repos/sdras/mojs/forks",
    "keys_url": "https://api.github.com/repos/sdras/mojs/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/mojs/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/mojs/teams",
    "hooks_url": "https://api.github.com/repos/sdras/mojs/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/mojs/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/mojs/events",
    "assignees_url": "https://api.github.com/repos/sdras/mojs/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/mojs/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/mojs/tags",
    "blobs_url": "https://api.github.com/repos/sdras/mojs/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/mojs/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/mojs/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/mojs/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/mojs/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/mojs/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/mojs/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/mojs/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/mojs/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/mojs/subscription",
    "commits_url": "https://api.github.com/repos/sdras/mojs/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/mojs/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/mojs/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/mojs/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/mojs/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/mojs/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/mojs/merges",
    "archive_url": "https://api.github.com/repos/sdras/mojs/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/mojs/downloads",
    "issues_url": "https://api.github.com/repos/sdras/mojs/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/mojs/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/mojs/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/mojs/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/mojs/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/mojs/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/mojs/deployments",
    "created_at": "2016-10-27T22:02:31Z",
    "updated_at": "2019-06-22T14:39:27Z",
    "pushed_at": "2016-10-23T20:47:35Z",
    "git_url": "git://github.com/sdras/mojs.git",
    "ssh_url": "git@github.com:sdras/mojs.git",
    "clone_url": "https://github.com/sdras/mojs.git",
    "svn_url": "https://github.com/sdras/mojs",
    "homepage": "http://mojs.io/",
    "size": 137132,
    "stargazers_count": 2,
    "watchers_count": 2,
    "language": "JavaScript",
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 2,
    "default_branch": "master"
  },
  {
    "id": 189794922,
    "node_id": "MDEwOlJlcG9zaXRvcnkxODk3OTQ5MjI=",
    "name": "netlify-dev-plugin",
    "full_name": "sdras/netlify-dev-plugin",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/netlify-dev-plugin",
    "description": "Local dev server with functions, rules engine and add-on support",
    "fork": true,
    "url": "https://api.github.com/repos/sdras/netlify-dev-plugin",
    "forks_url": "https://api.github.com/repos/sdras/netlify-dev-plugin/forks",
    "keys_url": "https://api.github.com/repos/sdras/netlify-dev-plugin/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/netlify-dev-plugin/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/netlify-dev-plugin/teams",
    "hooks_url": "https://api.github.com/repos/sdras/netlify-dev-plugin/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/netlify-dev-plugin/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/netlify-dev-plugin/events",
    "assignees_url": "https://api.github.com/repos/sdras/netlify-dev-plugin/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/netlify-dev-plugin/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/netlify-dev-plugin/tags",
    "blobs_url": "https://api.github.com/repos/sdras/netlify-dev-plugin/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/netlify-dev-plugin/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/netlify-dev-plugin/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/netlify-dev-plugin/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/netlify-dev-plugin/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/netlify-dev-plugin/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/netlify-dev-plugin/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/netlify-dev-plugin/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/netlify-dev-plugin/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/netlify-dev-plugin/subscription",
    "commits_url": "https://api.github.com/repos/sdras/netlify-dev-plugin/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/netlify-dev-plugin/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/netlify-dev-plugin/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/netlify-dev-plugin/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/netlify-dev-plugin/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/netlify-dev-plugin/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/netlify-dev-plugin/merges",
    "archive_url": "https://api.github.com/repos/sdras/netlify-dev-plugin/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/netlify-dev-plugin/downloads",
    "issues_url": "https://api.github.com/repos/sdras/netlify-dev-plugin/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/netlify-dev-plugin/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/netlify-dev-plugin/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/netlify-dev-plugin/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/netlify-dev-plugin/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/netlify-dev-plugin/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/netlify-dev-plugin/deployments",
    "created_at": "2019-06-02T02:02:01Z",
    "updated_at": "2019-06-02T02:02:04Z",
    "pushed_at": "2019-05-30T15:41:18Z",
    "git_url": "git://github.com/sdras/netlify-dev-plugin.git",
    "ssh_url": "git@github.com:sdras/netlify-dev-plugin.git",
    "clone_url": "https://github.com/sdras/netlify-dev-plugin.git",
    "svn_url": "https://github.com/sdras/netlify-dev-plugin",
    "homepage": "",
    "size": 674,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "JavaScript",
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 195251394,
    "node_id": "MDEwOlJlcG9zaXRvcnkxOTUyNTEzOTQ=",
    "name": "netlify-functions-example",
    "full_name": "sdras/netlify-functions-example",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/netlify-functions-example",
    "description": null,
    "fork": false,
    "url": "https://api.github.com/repos/sdras/netlify-functions-example",
    "forks_url": "https://api.github.com/repos/sdras/netlify-functions-example/forks",
    "keys_url": "https://api.github.com/repos/sdras/netlify-functions-example/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/netlify-functions-example/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/netlify-functions-example/teams",
    "hooks_url": "https://api.github.com/repos/sdras/netlify-functions-example/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/netlify-functions-example/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/netlify-functions-example/events",
    "assignees_url": "https://api.github.com/repos/sdras/netlify-functions-example/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/netlify-functions-example/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/netlify-functions-example/tags",
    "blobs_url": "https://api.github.com/repos/sdras/netlify-functions-example/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/netlify-functions-example/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/netlify-functions-example/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/netlify-functions-example/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/netlify-functions-example/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/netlify-functions-example/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/netlify-functions-example/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/netlify-functions-example/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/netlify-functions-example/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/netlify-functions-example/subscription",
    "commits_url": "https://api.github.com/repos/sdras/netlify-functions-example/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/netlify-functions-example/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/netlify-functions-example/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/netlify-functions-example/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/netlify-functions-example/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/netlify-functions-example/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/netlify-functions-example/merges",
    "archive_url": "https://api.github.com/repos/sdras/netlify-functions-example/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/netlify-functions-example/downloads",
    "issues_url": "https://api.github.com/repos/sdras/netlify-functions-example/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/netlify-functions-example/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/netlify-functions-example/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/netlify-functions-example/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/netlify-functions-example/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/netlify-functions-example/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/netlify-functions-example/deployments",
    "created_at": "2019-07-04T13:56:36Z",
    "updated_at": "2021-01-01T05:54:40Z",
    "pushed_at": "2020-12-11T15:37:49Z",
    "git_url": "git://github.com/sdras/netlify-functions-example.git",
    "ssh_url": "git@github.com:sdras/netlify-functions-example.git",
    "clone_url": "https://github.com/sdras/netlify-functions-example.git",
    "svn_url": "https://github.com/sdras/netlify-functions-example",
    "homepage": null,
    "size": 483,
    "stargazers_count": 47,
    "watchers_count": 47,
    "language": "HTML",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 4,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 9,
    "license": null,
    "forks": 4,
    "open_issues": 9,
    "watchers": 47,
    "default_branch": "master"
  },
  {
    "id": 262365290,
    "node_id": "MDEwOlJlcG9zaXRvcnkyNjIzNjUyOTA=",
    "name": "netlify-plugin-emoji-translate",
    "full_name": "sdras/netlify-plugin-emoji-translate",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/netlify-plugin-emoji-translate",
    "description": null,
    "fork": true,
    "url": "https://api.github.com/repos/sdras/netlify-plugin-emoji-translate",
    "forks_url": "https://api.github.com/repos/sdras/netlify-plugin-emoji-translate/forks",
    "keys_url": "https://api.github.com/repos/sdras/netlify-plugin-emoji-translate/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/netlify-plugin-emoji-translate/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/netlify-plugin-emoji-translate/teams",
    "hooks_url": "https://api.github.com/repos/sdras/netlify-plugin-emoji-translate/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/netlify-plugin-emoji-translate/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/netlify-plugin-emoji-translate/events",
    "assignees_url": "https://api.github.com/repos/sdras/netlify-plugin-emoji-translate/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/netlify-plugin-emoji-translate/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/netlify-plugin-emoji-translate/tags",
    "blobs_url": "https://api.github.com/repos/sdras/netlify-plugin-emoji-translate/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/netlify-plugin-emoji-translate/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/netlify-plugin-emoji-translate/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/netlify-plugin-emoji-translate/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/netlify-plugin-emoji-translate/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/netlify-plugin-emoji-translate/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/netlify-plugin-emoji-translate/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/netlify-plugin-emoji-translate/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/netlify-plugin-emoji-translate/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/netlify-plugin-emoji-translate/subscription",
    "commits_url": "https://api.github.com/repos/sdras/netlify-plugin-emoji-translate/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/netlify-plugin-emoji-translate/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/netlify-plugin-emoji-translate/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/netlify-plugin-emoji-translate/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/netlify-plugin-emoji-translate/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/netlify-plugin-emoji-translate/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/netlify-plugin-emoji-translate/merges",
    "archive_url": "https://api.github.com/repos/sdras/netlify-plugin-emoji-translate/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/netlify-plugin-emoji-translate/downloads",
    "issues_url": "https://api.github.com/repos/sdras/netlify-plugin-emoji-translate/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/netlify-plugin-emoji-translate/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/netlify-plugin-emoji-translate/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/netlify-plugin-emoji-translate/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/netlify-plugin-emoji-translate/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/netlify-plugin-emoji-translate/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/netlify-plugin-emoji-translate/deployments",
    "created_at": "2020-05-08T15:53:03Z",
    "updated_at": "2020-05-08T15:53:05Z",
    "pushed_at": "2020-05-08T15:53:32Z",
    "git_url": "git://github.com/sdras/netlify-plugin-emoji-translate.git",
    "ssh_url": "git@github.com:sdras/netlify-plugin-emoji-translate.git",
    "clone_url": "https://github.com/sdras/netlify-plugin-emoji-translate.git",
    "svn_url": "https://github.com/sdras/netlify-plugin-emoji-translate",
    "homepage": null,
    "size": 9,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 133761470,
    "node_id": "MDEwOlJlcG9zaXRvcnkxMzM3NjE0NzA=",
    "name": "night-owl-vscode-theme",
    "full_name": "sdras/night-owl-vscode-theme",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/night-owl-vscode-theme",
    "description": "🌌 NIGHT OWL: A VS Code dark theme for contrast for nighttime coding, 🦉 LIGHT OWL: a daytime light theme",
    "fork": false,
    "url": "https://api.github.com/repos/sdras/night-owl-vscode-theme",
    "forks_url": "https://api.github.com/repos/sdras/night-owl-vscode-theme/forks",
    "keys_url": "https://api.github.com/repos/sdras/night-owl-vscode-theme/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/night-owl-vscode-theme/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/night-owl-vscode-theme/teams",
    "hooks_url": "https://api.github.com/repos/sdras/night-owl-vscode-theme/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/night-owl-vscode-theme/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/night-owl-vscode-theme/events",
    "assignees_url": "https://api.github.com/repos/sdras/night-owl-vscode-theme/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/night-owl-vscode-theme/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/night-owl-vscode-theme/tags",
    "blobs_url": "https://api.github.com/repos/sdras/night-owl-vscode-theme/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/night-owl-vscode-theme/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/night-owl-vscode-theme/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/night-owl-vscode-theme/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/night-owl-vscode-theme/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/night-owl-vscode-theme/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/night-owl-vscode-theme/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/night-owl-vscode-theme/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/night-owl-vscode-theme/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/night-owl-vscode-theme/subscription",
    "commits_url": "https://api.github.com/repos/sdras/night-owl-vscode-theme/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/night-owl-vscode-theme/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/night-owl-vscode-theme/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/night-owl-vscode-theme/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/night-owl-vscode-theme/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/night-owl-vscode-theme/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/night-owl-vscode-theme/merges",
    "archive_url": "https://api.github.com/repos/sdras/night-owl-vscode-theme/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/night-owl-vscode-theme/downloads",
    "issues_url": "https://api.github.com/repos/sdras/night-owl-vscode-theme/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/night-owl-vscode-theme/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/night-owl-vscode-theme/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/night-owl-vscode-theme/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/night-owl-vscode-theme/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/night-owl-vscode-theme/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/night-owl-vscode-theme/deployments",
    "created_at": "2018-05-17T05:06:45Z",
    "updated_at": "2021-01-15T10:49:50Z",
    "pushed_at": "2020-12-20T19:39:11Z",
    "git_url": "git://github.com/sdras/night-owl-vscode-theme.git",
    "ssh_url": "git@github.com:sdras/night-owl-vscode-theme.git",
    "clone_url": "https://github.com/sdras/night-owl-vscode-theme.git",
    "svn_url": "https://github.com/sdras/night-owl-vscode-theme",
    "homepage": "https://aka.ms/nightowl",
    "size": 2063,
    "stargazers_count": 2135,
    "watchers_count": 2135,
    "language": null,
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 192,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 42,
    "license": {
      "key": "mit",
      "name": "MIT License",
      "spdx_id": "MIT",
      "url": "https://api.github.com/licenses/mit",
      "node_id": "MDc6TGljZW5zZTEz"
    },
    "forks": 192,
    "open_issues": 42,
    "watchers": 2135,
    "default_branch": "master"
  },
  {
    "id": 226727557,
    "node_id": "MDEwOlJlcG9zaXRvcnkyMjY3Mjc1NTc=",
    "name": "nuxt.js",
    "full_name": "sdras/nuxt.js",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/nuxt.js",
    "description": "The Vue.js Framework",
    "fork": true,
    "url": "https://api.github.com/repos/sdras/nuxt.js",
    "forks_url": "https://api.github.com/repos/sdras/nuxt.js/forks",
    "keys_url": "https://api.github.com/repos/sdras/nuxt.js/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/nuxt.js/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/nuxt.js/teams",
    "hooks_url": "https://api.github.com/repos/sdras/nuxt.js/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/nuxt.js/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/nuxt.js/events",
    "assignees_url": "https://api.github.com/repos/sdras/nuxt.js/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/nuxt.js/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/nuxt.js/tags",
    "blobs_url": "https://api.github.com/repos/sdras/nuxt.js/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/nuxt.js/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/nuxt.js/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/nuxt.js/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/nuxt.js/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/nuxt.js/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/nuxt.js/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/nuxt.js/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/nuxt.js/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/nuxt.js/subscription",
    "commits_url": "https://api.github.com/repos/sdras/nuxt.js/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/nuxt.js/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/nuxt.js/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/nuxt.js/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/nuxt.js/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/nuxt.js/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/nuxt.js/merges",
    "archive_url": "https://api.github.com/repos/sdras/nuxt.js/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/nuxt.js/downloads",
    "issues_url": "https://api.github.com/repos/sdras/nuxt.js/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/nuxt.js/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/nuxt.js/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/nuxt.js/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/nuxt.js/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/nuxt.js/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/nuxt.js/deployments",
    "created_at": "2019-12-08T20:32:29Z",
    "updated_at": "2020-03-03T05:54:14Z",
    "pushed_at": "2019-12-08T03:45:01Z",
    "git_url": "git://github.com/sdras/nuxt.js.git",
    "ssh_url": "git@github.com:sdras/nuxt.js.git",
    "clone_url": "https://github.com/sdras/nuxt.js.git",
    "svn_url": "https://github.com/sdras/nuxt.js",
    "homepage": "https://nuxtjs.org",
    "size": 25306,
    "stargazers_count": 1,
    "watchers_count": 1,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "other",
      "name": "Other",
      "spdx_id": "NOASSERTION",
      "url": null,
      "node_id": "MDc6TGljZW5zZTA="
    },
    "forks": 0,
    "open_issues": 0,
    "watchers": 1,
    "default_branch": "dev"
  },
  {
    "id": 115576472,
    "node_id": "MDEwOlJlcG9zaXRvcnkxMTU1NzY0NzI=",
    "name": "object-explorer",
    "full_name": "sdras/object-explorer",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/object-explorer",
    "description": "🔥 A resource to help figure out what JavaScript object method would be best to use at any given time",
    "fork": false,
    "url": "https://api.github.com/repos/sdras/object-explorer",
    "forks_url": "https://api.github.com/repos/sdras/object-explorer/forks",
    "keys_url": "https://api.github.com/repos/sdras/object-explorer/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/object-explorer/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/object-explorer/teams",
    "hooks_url": "https://api.github.com/repos/sdras/object-explorer/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/object-explorer/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/object-explorer/events",
    "assignees_url": "https://api.github.com/repos/sdras/object-explorer/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/object-explorer/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/object-explorer/tags",
    "blobs_url": "https://api.github.com/repos/sdras/object-explorer/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/object-explorer/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/object-explorer/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/object-explorer/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/object-explorer/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/object-explorer/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/object-explorer/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/object-explorer/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/object-explorer/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/object-explorer/subscription",
    "commits_url": "https://api.github.com/repos/sdras/object-explorer/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/object-explorer/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/object-explorer/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/object-explorer/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/object-explorer/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/object-explorer/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/object-explorer/merges",
    "archive_url": "https://api.github.com/repos/sdras/object-explorer/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/object-explorer/downloads",
    "issues_url": "https://api.github.com/repos/sdras/object-explorer/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/object-explorer/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/object-explorer/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/object-explorer/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/object-explorer/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/object-explorer/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/object-explorer/deployments",
    "created_at": "2017-12-28T02:31:13Z",
    "updated_at": "2021-01-03T00:33:08Z",
    "pushed_at": "2020-12-21T16:48:00Z",
    "git_url": "git://github.com/sdras/object-explorer.git",
    "ssh_url": "git@github.com:sdras/object-explorer.git",
    "clone_url": "https://github.com/sdras/object-explorer.git",
    "svn_url": "https://github.com/sdras/object-explorer",
    "homepage": "https://objectexplorer.netlify.com/",
    "size": 1448,
    "stargazers_count": 1353,
    "watchers_count": 1353,
    "language": "JavaScript",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": true,
    "forks_count": 110,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 11,
    "license": {
      "key": "mit",
      "name": "MIT License",
      "spdx_id": "MIT",
      "url": "https://api.github.com/licenses/mit",
      "node_id": "MDc6TGljZW5zZTEz"
    },
    "forks": 110,
    "open_issues": 11,
    "watchers": 1353,
    "default_branch": "master"
  },
  {
    "id": 126620410,
    "node_id": "MDEwOlJlcG9zaXRvcnkxMjY2MjA0MTA=",
    "name": "page-transitions-simple",
    "full_name": "sdras/page-transitions-simple",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/page-transitions-simple",
    "description": "Vue/Nuxt Page Transitions- Simple Demonstration",
    "fork": false,
    "url": "https://api.github.com/repos/sdras/page-transitions-simple",
    "forks_url": "https://api.github.com/repos/sdras/page-transitions-simple/forks",
    "keys_url": "https://api.github.com/repos/sdras/page-transitions-simple/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/page-transitions-simple/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/page-transitions-simple/teams",
    "hooks_url": "https://api.github.com/repos/sdras/page-transitions-simple/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/page-transitions-simple/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/page-transitions-simple/events",
    "assignees_url": "https://api.github.com/repos/sdras/page-transitions-simple/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/page-transitions-simple/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/page-transitions-simple/tags",
    "blobs_url": "https://api.github.com/repos/sdras/page-transitions-simple/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/page-transitions-simple/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/page-transitions-simple/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/page-transitions-simple/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/page-transitions-simple/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/page-transitions-simple/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/page-transitions-simple/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/page-transitions-simple/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/page-transitions-simple/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/page-transitions-simple/subscription",
    "commits_url": "https://api.github.com/repos/sdras/page-transitions-simple/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/page-transitions-simple/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/page-transitions-simple/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/page-transitions-simple/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/page-transitions-simple/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/page-transitions-simple/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/page-transitions-simple/merges",
    "archive_url": "https://api.github.com/repos/sdras/page-transitions-simple/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/page-transitions-simple/downloads",
    "issues_url": "https://api.github.com/repos/sdras/page-transitions-simple/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/page-transitions-simple/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/page-transitions-simple/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/page-transitions-simple/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/page-transitions-simple/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/page-transitions-simple/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/page-transitions-simple/deployments",
    "created_at": "2018-03-24T16:52:56Z",
    "updated_at": "2021-01-01T06:08:17Z",
    "pushed_at": "2018-04-23T10:45:28Z",
    "git_url": "git://github.com/sdras/page-transitions-simple.git",
    "ssh_url": "git@github.com:sdras/page-transitions-simple.git",
    "clone_url": "https://github.com/sdras/page-transitions-simple.git",
    "svn_url": "https://github.com/sdras/page-transitions-simple",
    "homepage": "",
    "size": 77,
    "stargazers_count": 150,
    "watchers_count": 150,
    "language": "Vue",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 25,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 1,
    "license": {
      "key": "mit",
      "name": "MIT License",
      "spdx_id": "MIT",
      "url": "https://api.github.com/licenses/mit",
      "node_id": "MDc6TGljZW5zZTEz"
    },
    "forks": 25,
    "open_issues": 1,
    "watchers": 150,
    "default_branch": "master"
  },
  {
    "id": 127487566,
    "node_id": "MDEwOlJlcG9zaXRvcnkxMjc0ODc1NjY=",
    "name": "page-transitions-travelapp",
    "full_name": "sdras/page-transitions-travelapp",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/page-transitions-travelapp",
    "description": "Travel App, Native-like Page Transitions",
    "fork": false,
    "url": "https://api.github.com/repos/sdras/page-transitions-travelapp",
    "forks_url": "https://api.github.com/repos/sdras/page-transitions-travelapp/forks",
    "keys_url": "https://api.github.com/repos/sdras/page-transitions-travelapp/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/page-transitions-travelapp/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/page-transitions-travelapp/teams",
    "hooks_url": "https://api.github.com/repos/sdras/page-transitions-travelapp/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/page-transitions-travelapp/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/page-transitions-travelapp/events",
    "assignees_url": "https://api.github.com/repos/sdras/page-transitions-travelapp/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/page-transitions-travelapp/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/page-transitions-travelapp/tags",
    "blobs_url": "https://api.github.com/repos/sdras/page-transitions-travelapp/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/page-transitions-travelapp/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/page-transitions-travelapp/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/page-transitions-travelapp/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/page-transitions-travelapp/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/page-transitions-travelapp/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/page-transitions-travelapp/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/page-transitions-travelapp/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/page-transitions-travelapp/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/page-transitions-travelapp/subscription",
    "commits_url": "https://api.github.com/repos/sdras/page-transitions-travelapp/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/page-transitions-travelapp/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/page-transitions-travelapp/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/page-transitions-travelapp/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/page-transitions-travelapp/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/page-transitions-travelapp/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/page-transitions-travelapp/merges",
    "archive_url": "https://api.github.com/repos/sdras/page-transitions-travelapp/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/page-transitions-travelapp/downloads",
    "issues_url": "https://api.github.com/repos/sdras/page-transitions-travelapp/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/page-transitions-travelapp/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/page-transitions-travelapp/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/page-transitions-travelapp/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/page-transitions-travelapp/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/page-transitions-travelapp/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/page-transitions-travelapp/deployments",
    "created_at": "2018-03-31T01:17:39Z",
    "updated_at": "2021-01-13T19:55:42Z",
    "pushed_at": "2020-12-11T03:28:35Z",
    "git_url": "git://github.com/sdras/page-transitions-travelapp.git",
    "ssh_url": "git@github.com:sdras/page-transitions-travelapp.git",
    "clone_url": "https://github.com/sdras/page-transitions-travelapp.git",
    "svn_url": "https://github.com/sdras/page-transitions-travelapp",
    "homepage": "https://pagetransitions.netlify.app/",
    "size": 1811,
    "stargazers_count": 1558,
    "watchers_count": 1558,
    "language": "Vue",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 181,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 13,
    "license": null,
    "forks": 181,
    "open_issues": 13,
    "watchers": 1558,
    "default_branch": "master"
  },
  {
    "id": 178600030,
    "node_id": "MDEwOlJlcG9zaXRvcnkxNzg2MDAwMzA=",
    "name": "perfmatters-demo",
    "full_name": "sdras/perfmatters-demo",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/perfmatters-demo",
    "description": "demo for perfmatters conf https://perfmattersconf.com/",
    "fork": false,
    "url": "https://api.github.com/repos/sdras/perfmatters-demo",
    "forks_url": "https://api.github.com/repos/sdras/perfmatters-demo/forks",
    "keys_url": "https://api.github.com/repos/sdras/perfmatters-demo/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/perfmatters-demo/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/perfmatters-demo/teams",
    "hooks_url": "https://api.github.com/repos/sdras/perfmatters-demo/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/perfmatters-demo/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/perfmatters-demo/events",
    "assignees_url": "https://api.github.com/repos/sdras/perfmatters-demo/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/perfmatters-demo/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/perfmatters-demo/tags",
    "blobs_url": "https://api.github.com/repos/sdras/perfmatters-demo/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/perfmatters-demo/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/perfmatters-demo/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/perfmatters-demo/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/perfmatters-demo/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/perfmatters-demo/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/perfmatters-demo/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/perfmatters-demo/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/perfmatters-demo/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/perfmatters-demo/subscription",
    "commits_url": "https://api.github.com/repos/sdras/perfmatters-demo/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/perfmatters-demo/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/perfmatters-demo/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/perfmatters-demo/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/perfmatters-demo/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/perfmatters-demo/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/perfmatters-demo/merges",
    "archive_url": "https://api.github.com/repos/sdras/perfmatters-demo/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/perfmatters-demo/downloads",
    "issues_url": "https://api.github.com/repos/sdras/perfmatters-demo/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/perfmatters-demo/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/perfmatters-demo/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/perfmatters-demo/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/perfmatters-demo/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/perfmatters-demo/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/perfmatters-demo/deployments",
    "created_at": "2019-03-30T19:05:05Z",
    "updated_at": "2020-02-14T08:38:54Z",
    "pushed_at": "2019-03-31T03:21:24Z",
    "git_url": "git://github.com/sdras/perfmatters-demo.git",
    "ssh_url": "git@github.com:sdras/perfmatters-demo.git",
    "clone_url": "https://github.com/sdras/perfmatters-demo.git",
    "svn_url": "https://github.com/sdras/perfmatters-demo",
    "homepage": null,
    "size": 259,
    "stargazers_count": 11,
    "watchers_count": 11,
    "language": "Vue",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "mit",
      "name": "MIT License",
      "spdx_id": "MIT",
      "url": "https://api.github.com/licenses/mit",
      "node_id": "MDc6TGljZW5zZTEz"
    },
    "forks": 0,
    "open_issues": 0,
    "watchers": 11,
    "default_branch": "master"
  },
  {
    "id": 189527081,
    "node_id": "MDEwOlJlcG9zaXRvcnkxODk1MjcwODE=",
    "name": "petsofnetlify",
    "full_name": "sdras/petsofnetlify",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/petsofnetlify",
    "description": "pets of netlifiers",
    "fork": true,
    "url": "https://api.github.com/repos/sdras/petsofnetlify",
    "forks_url": "https://api.github.com/repos/sdras/petsofnetlify/forks",
    "keys_url": "https://api.github.com/repos/sdras/petsofnetlify/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/petsofnetlify/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/petsofnetlify/teams",
    "hooks_url": "https://api.github.com/repos/sdras/petsofnetlify/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/petsofnetlify/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/petsofnetlify/events",
    "assignees_url": "https://api.github.com/repos/sdras/petsofnetlify/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/petsofnetlify/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/petsofnetlify/tags",
    "blobs_url": "https://api.github.com/repos/sdras/petsofnetlify/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/petsofnetlify/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/petsofnetlify/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/petsofnetlify/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/petsofnetlify/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/petsofnetlify/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/petsofnetlify/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/petsofnetlify/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/petsofnetlify/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/petsofnetlify/subscription",
    "commits_url": "https://api.github.com/repos/sdras/petsofnetlify/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/petsofnetlify/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/petsofnetlify/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/petsofnetlify/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/petsofnetlify/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/petsofnetlify/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/petsofnetlify/merges",
    "archive_url": "https://api.github.com/repos/sdras/petsofnetlify/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/petsofnetlify/downloads",
    "issues_url": "https://api.github.com/repos/sdras/petsofnetlify/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/petsofnetlify/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/petsofnetlify/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/petsofnetlify/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/petsofnetlify/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/petsofnetlify/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/petsofnetlify/deployments",
    "created_at": "2019-05-31T04:23:13Z",
    "updated_at": "2019-06-04T01:27:29Z",
    "pushed_at": "2019-05-31T04:31:42Z",
    "git_url": "git://github.com/sdras/petsofnetlify.git",
    "ssh_url": "git@github.com:sdras/petsofnetlify.git",
    "clone_url": "https://github.com/sdras/petsofnetlify.git",
    "svn_url": "https://github.com/sdras/petsofnetlify",
    "homepage": null,
    "size": 2501,
    "stargazers_count": 1,
    "watchers_count": 1,
    "language": "HTML",
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 1,
    "default_branch": "master"
  },
  {
    "id": 197872016,
    "node_id": "MDEwOlJlcG9zaXRvcnkxOTc4NzIwMTY=",
    "name": "productive-twitter",
    "full_name": "sdras/productive-twitter",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/productive-twitter",
    "description": "Chrome extension: Minimal and friendly theme for productive twitter use",
    "fork": false,
    "url": "https://api.github.com/repos/sdras/productive-twitter",
    "forks_url": "https://api.github.com/repos/sdras/productive-twitter/forks",
    "keys_url": "https://api.github.com/repos/sdras/productive-twitter/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/productive-twitter/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/productive-twitter/teams",
    "hooks_url": "https://api.github.com/repos/sdras/productive-twitter/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/productive-twitter/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/productive-twitter/events",
    "assignees_url": "https://api.github.com/repos/sdras/productive-twitter/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/productive-twitter/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/productive-twitter/tags",
    "blobs_url": "https://api.github.com/repos/sdras/productive-twitter/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/productive-twitter/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/productive-twitter/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/productive-twitter/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/productive-twitter/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/productive-twitter/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/productive-twitter/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/productive-twitter/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/productive-twitter/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/productive-twitter/subscription",
    "commits_url": "https://api.github.com/repos/sdras/productive-twitter/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/productive-twitter/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/productive-twitter/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/productive-twitter/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/productive-twitter/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/productive-twitter/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/productive-twitter/merges",
    "archive_url": "https://api.github.com/repos/sdras/productive-twitter/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/productive-twitter/downloads",
    "issues_url": "https://api.github.com/repos/sdras/productive-twitter/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/productive-twitter/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/productive-twitter/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/productive-twitter/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/productive-twitter/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/productive-twitter/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/productive-twitter/deployments",
    "created_at": "2019-07-20T03:00:51Z",
    "updated_at": "2020-12-05T14:34:00Z",
    "pushed_at": "2020-10-17T15:37:56Z",
    "git_url": "git://github.com/sdras/productive-twitter.git",
    "ssh_url": "git@github.com:sdras/productive-twitter.git",
    "clone_url": "https://github.com/sdras/productive-twitter.git",
    "svn_url": "https://github.com/sdras/productive-twitter",
    "homepage": "https://chrome.google.com/webstore/detail/productive-twitter/elgfikcdihncknnnedljbbignlmnppii",
    "size": 64,
    "stargazers_count": 143,
    "watchers_count": 143,
    "language": "CSS",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 31,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 2,
    "license": {
      "key": "bsd-3-clause",
      "name": "BSD 3-Clause \"New\" or \"Revised\" License",
      "spdx_id": "BSD-3-Clause",
      "url": "https://api.github.com/licenses/bsd-3-clause",
      "node_id": "MDc6TGljZW5zZTU="
    },
    "forks": 31,
    "open_issues": 2,
    "watchers": 143,
    "default_branch": "master"
  },
  {
    "id": 147777231,
    "node_id": "MDEwOlJlcG9zaXRvcnkxNDc3NzcyMzE=",
    "name": "project-explorer",
    "full_name": "sdras/project-explorer",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/project-explorer",
    "description": " 🎋A CLI tool to create an annotated tree visualization of any project",
    "fork": false,
    "url": "https://api.github.com/repos/sdras/project-explorer",
    "forks_url": "https://api.github.com/repos/sdras/project-explorer/forks",
    "keys_url": "https://api.github.com/repos/sdras/project-explorer/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/project-explorer/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/project-explorer/teams",
    "hooks_url": "https://api.github.com/repos/sdras/project-explorer/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/project-explorer/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/project-explorer/events",
    "assignees_url": "https://api.github.com/repos/sdras/project-explorer/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/project-explorer/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/project-explorer/tags",
    "blobs_url": "https://api.github.com/repos/sdras/project-explorer/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/project-explorer/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/project-explorer/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/project-explorer/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/project-explorer/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/project-explorer/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/project-explorer/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/project-explorer/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/project-explorer/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/project-explorer/subscription",
    "commits_url": "https://api.github.com/repos/sdras/project-explorer/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/project-explorer/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/project-explorer/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/project-explorer/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/project-explorer/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/project-explorer/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/project-explorer/merges",
    "archive_url": "https://api.github.com/repos/sdras/project-explorer/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/project-explorer/downloads",
    "issues_url": "https://api.github.com/repos/sdras/project-explorer/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/project-explorer/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/project-explorer/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/project-explorer/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/project-explorer/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/project-explorer/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/project-explorer/deployments",
    "created_at": "2018-09-07T05:54:35Z",
    "updated_at": "2021-01-07T17:19:46Z",
    "pushed_at": "2019-08-28T15:25:34Z",
    "git_url": "git://github.com/sdras/project-explorer.git",
    "ssh_url": "git@github.com:sdras/project-explorer.git",
    "clone_url": "https://github.com/sdras/project-explorer.git",
    "svn_url": "https://github.com/sdras/project-explorer",
    "homepage": "https://sdras.github.io/project-explorer-site/",
    "size": 110,
    "stargazers_count": 485,
    "watchers_count": 485,
    "language": "JavaScript",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 22,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 7,
    "license": {
      "key": "mit",
      "name": "MIT License",
      "spdx_id": "MIT",
      "url": "https://api.github.com/licenses/mit",
      "node_id": "MDc6TGljZW5zZTEz"
    },
    "forks": 22,
    "open_issues": 7,
    "watchers": 485,
    "default_branch": "master"
  },
  {
    "id": 66226012,
    "node_id": "MDEwOlJlcG9zaXRvcnk2NjIyNjAxMg==",
    "name": "react-aframe-demo1",
    "full_name": "sdras/react-aframe-demo1",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/react-aframe-demo1",
    "description": "React A-Frame Demo 1",
    "fork": false,
    "url": "https://api.github.com/repos/sdras/react-aframe-demo1",
    "forks_url": "https://api.github.com/repos/sdras/react-aframe-demo1/forks",
    "keys_url": "https://api.github.com/repos/sdras/react-aframe-demo1/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/react-aframe-demo1/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/react-aframe-demo1/teams",
    "hooks_url": "https://api.github.com/repos/sdras/react-aframe-demo1/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/react-aframe-demo1/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/react-aframe-demo1/events",
    "assignees_url": "https://api.github.com/repos/sdras/react-aframe-demo1/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/react-aframe-demo1/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/react-aframe-demo1/tags",
    "blobs_url": "https://api.github.com/repos/sdras/react-aframe-demo1/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/react-aframe-demo1/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/react-aframe-demo1/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/react-aframe-demo1/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/react-aframe-demo1/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/react-aframe-demo1/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/react-aframe-demo1/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/react-aframe-demo1/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/react-aframe-demo1/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/react-aframe-demo1/subscription",
    "commits_url": "https://api.github.com/repos/sdras/react-aframe-demo1/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/react-aframe-demo1/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/react-aframe-demo1/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/react-aframe-demo1/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/react-aframe-demo1/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/react-aframe-demo1/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/react-aframe-demo1/merges",
    "archive_url": "https://api.github.com/repos/sdras/react-aframe-demo1/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/react-aframe-demo1/downloads",
    "issues_url": "https://api.github.com/repos/sdras/react-aframe-demo1/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/react-aframe-demo1/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/react-aframe-demo1/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/react-aframe-demo1/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/react-aframe-demo1/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/react-aframe-demo1/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/react-aframe-demo1/deployments",
    "created_at": "2016-08-21T23:43:30Z",
    "updated_at": "2019-09-18T13:56:54Z",
    "pushed_at": "2016-08-22T05:23:15Z",
    "git_url": "git://github.com/sdras/react-aframe-demo1.git",
    "ssh_url": "git@github.com:sdras/react-aframe-demo1.git",
    "clone_url": "https://github.com/sdras/react-aframe-demo1.git",
    "svn_url": "https://github.com/sdras/react-aframe-demo1",
    "homepage": null,
    "size": 588,
    "stargazers_count": 16,
    "watchers_count": 16,
    "language": "JavaScript",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": true,
    "forks_count": 1,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "mit",
      "name": "MIT License",
      "spdx_id": "MIT",
      "url": "https://api.github.com/licenses/mit",
      "node_id": "MDc6TGljZW5zZTEz"
    },
    "forks": 1,
    "open_issues": 0,
    "watchers": 16,
    "default_branch": "master"
  },
  {
    "id": 57947267,
    "node_id": "MDEwOlJlcG9zaXRvcnk1Nzk0NzI2Nw==",
    "name": "react-subjects",
    "full_name": "sdras/react-subjects",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/react-subjects",
    "description": "Course material for React Training",
    "fork": true,
    "url": "https://api.github.com/repos/sdras/react-subjects",
    "forks_url": "https://api.github.com/repos/sdras/react-subjects/forks",
    "keys_url": "https://api.github.com/repos/sdras/react-subjects/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/react-subjects/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/react-subjects/teams",
    "hooks_url": "https://api.github.com/repos/sdras/react-subjects/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/react-subjects/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/react-subjects/events",
    "assignees_url": "https://api.github.com/repos/sdras/react-subjects/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/react-subjects/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/react-subjects/tags",
    "blobs_url": "https://api.github.com/repos/sdras/react-subjects/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/react-subjects/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/react-subjects/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/react-subjects/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/react-subjects/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/react-subjects/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/react-subjects/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/react-subjects/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/react-subjects/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/react-subjects/subscription",
    "commits_url": "https://api.github.com/repos/sdras/react-subjects/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/react-subjects/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/react-subjects/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/react-subjects/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/react-subjects/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/react-subjects/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/react-subjects/merges",
    "archive_url": "https://api.github.com/repos/sdras/react-subjects/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/react-subjects/downloads",
    "issues_url": "https://api.github.com/repos/sdras/react-subjects/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/react-subjects/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/react-subjects/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/react-subjects/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/react-subjects/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/react-subjects/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/react-subjects/deployments",
    "created_at": "2016-05-03T06:40:28Z",
    "updated_at": "2020-11-10T20:31:01Z",
    "pushed_at": "2016-05-03T06:58:22Z",
    "git_url": "git://github.com/sdras/react-subjects.git",
    "ssh_url": "git@github.com:sdras/react-subjects.git",
    "clone_url": "https://github.com/sdras/react-subjects.git",
    "svn_url": "https://github.com/sdras/react-subjects",
    "homepage": "https://reactjs-training.com",
    "size": 8381,
    "stargazers_count": 1,
    "watchers_count": 1,
    "language": "JavaScript",
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": false,
    "has_pages": false,
    "forks_count": 1,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 1,
    "open_issues": 0,
    "watchers": 1,
    "default_branch": "master"
  },
  {
    "id": 124556091,
    "node_id": "MDEwOlJlcG9zaXRvcnkxMjQ1NTYwOTE=",
    "name": "roadmap",
    "full_name": "sdras/roadmap",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/roadmap",
    "description": "🗺️ Roadmap for the Vue.js project",
    "fork": true,
    "url": "https://api.github.com/repos/sdras/roadmap",
    "forks_url": "https://api.github.com/repos/sdras/roadmap/forks",
    "keys_url": "https://api.github.com/repos/sdras/roadmap/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/roadmap/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/roadmap/teams",
    "hooks_url": "https://api.github.com/repos/sdras/roadmap/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/roadmap/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/roadmap/events",
    "assignees_url": "https://api.github.com/repos/sdras/roadmap/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/roadmap/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/roadmap/tags",
    "blobs_url": "https://api.github.com/repos/sdras/roadmap/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/roadmap/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/roadmap/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/roadmap/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/roadmap/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/roadmap/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/roadmap/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/roadmap/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/roadmap/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/roadmap/subscription",
    "commits_url": "https://api.github.com/repos/sdras/roadmap/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/roadmap/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/roadmap/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/roadmap/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/roadmap/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/roadmap/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/roadmap/merges",
    "archive_url": "https://api.github.com/repos/sdras/roadmap/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/roadmap/downloads",
    "issues_url": "https://api.github.com/repos/sdras/roadmap/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/roadmap/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/roadmap/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/roadmap/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/roadmap/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/roadmap/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/roadmap/deployments",
    "created_at": "2018-03-09T15:12:37Z",
    "updated_at": "2020-10-06T03:27:18Z",
    "pushed_at": "2018-03-17T21:38:22Z",
    "git_url": "git://github.com/sdras/roadmap.git",
    "ssh_url": "git@github.com:sdras/roadmap.git",
    "clone_url": "https://github.com/sdras/roadmap.git",
    "svn_url": "https://github.com/sdras/roadmap",
    "homepage": "",
    "size": 8,
    "stargazers_count": 3,
    "watchers_count": 3,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": false,
    "has_pages": false,
    "forks_count": 1,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 1,
    "open_issues": 0,
    "watchers": 3,
    "default_branch": "master"
  },
  {
    "id": 102878691,
    "node_id": "MDEwOlJlcG9zaXRvcnkxMDI4Nzg2OTE=",
    "name": "Rythm.js",
    "full_name": "sdras/Rythm.js",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/Rythm.js",
    "description": "A javascript library that makes your page dance.",
    "fork": true,
    "url": "https://api.github.com/repos/sdras/Rythm.js",
    "forks_url": "https://api.github.com/repos/sdras/Rythm.js/forks",
    "keys_url": "https://api.github.com/repos/sdras/Rythm.js/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/Rythm.js/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/Rythm.js/teams",
    "hooks_url": "https://api.github.com/repos/sdras/Rythm.js/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/Rythm.js/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/Rythm.js/events",
    "assignees_url": "https://api.github.com/repos/sdras/Rythm.js/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/Rythm.js/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/Rythm.js/tags",
    "blobs_url": "https://api.github.com/repos/sdras/Rythm.js/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/Rythm.js/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/Rythm.js/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/Rythm.js/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/Rythm.js/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/Rythm.js/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/Rythm.js/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/Rythm.js/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/Rythm.js/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/Rythm.js/subscription",
    "commits_url": "https://api.github.com/repos/sdras/Rythm.js/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/Rythm.js/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/Rythm.js/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/Rythm.js/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/Rythm.js/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/Rythm.js/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/Rythm.js/merges",
    "archive_url": "https://api.github.com/repos/sdras/Rythm.js/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/Rythm.js/downloads",
    "issues_url": "https://api.github.com/repos/sdras/Rythm.js/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/Rythm.js/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/Rythm.js/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/Rythm.js/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/Rythm.js/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/Rythm.js/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/Rythm.js/deployments",
    "created_at": "2017-09-08T15:53:35Z",
    "updated_at": "2020-09-09T10:52:32Z",
    "pushed_at": "2017-09-09T12:25:38Z",
    "git_url": "git://github.com/sdras/Rythm.js.git",
    "ssh_url": "git@github.com:sdras/Rythm.js.git",
    "clone_url": "https://github.com/sdras/Rythm.js.git",
    "svn_url": "https://github.com/sdras/Rythm.js",
    "homepage": "https://okazari.github.io/Rythm.js/",
    "size": 14828,
    "stargazers_count": 7,
    "watchers_count": 7,
    "language": "JavaScript",
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 3,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "gpl-3.0",
      "name": "GNU General Public License v3.0",
      "spdx_id": "GPL-3.0",
      "url": "https://api.github.com/licenses/gpl-3.0",
      "node_id": "MDc6TGljZW5zZTk="
    },
    "forks": 3,
    "open_issues": 0,
    "watchers": 7,
    "default_branch": "master"
  },
  {
    "id": 112036900,
    "node_id": "MDEwOlJlcG9zaXRvcnkxMTIwMzY5MDA=",
    "name": "sample-stripe-handler",
    "full_name": "sdras/sample-stripe-handler",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/sample-stripe-handler",
    "description": "Serverless function that uses the stripe api for a checkout process in a Vue application",
    "fork": false,
    "url": "https://api.github.com/repos/sdras/sample-stripe-handler",
    "forks_url": "https://api.github.com/repos/sdras/sample-stripe-handler/forks",
    "keys_url": "https://api.github.com/repos/sdras/sample-stripe-handler/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/sample-stripe-handler/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/sample-stripe-handler/teams",
    "hooks_url": "https://api.github.com/repos/sdras/sample-stripe-handler/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/sample-stripe-handler/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/sample-stripe-handler/events",
    "assignees_url": "https://api.github.com/repos/sdras/sample-stripe-handler/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/sample-stripe-handler/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/sample-stripe-handler/tags",
    "blobs_url": "https://api.github.com/repos/sdras/sample-stripe-handler/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/sample-stripe-handler/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/sample-stripe-handler/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/sample-stripe-handler/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/sample-stripe-handler/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/sample-stripe-handler/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/sample-stripe-handler/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/sample-stripe-handler/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/sample-stripe-handler/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/sample-stripe-handler/subscription",
    "commits_url": "https://api.github.com/repos/sdras/sample-stripe-handler/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/sample-stripe-handler/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/sample-stripe-handler/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/sample-stripe-handler/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/sample-stripe-handler/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/sample-stripe-handler/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/sample-stripe-handler/merges",
    "archive_url": "https://api.github.com/repos/sdras/sample-stripe-handler/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/sample-stripe-handler/downloads",
    "issues_url": "https://api.github.com/repos/sdras/sample-stripe-handler/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/sample-stripe-handler/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/sample-stripe-handler/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/sample-stripe-handler/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/sample-stripe-handler/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/sample-stripe-handler/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/sample-stripe-handler/deployments",
    "created_at": "2017-11-25T21:52:42Z",
    "updated_at": "2021-01-13T19:54:39Z",
    "pushed_at": "2017-12-05T13:03:45Z",
    "git_url": "git://github.com/sdras/sample-stripe-handler.git",
    "ssh_url": "git@github.com:sdras/sample-stripe-handler.git",
    "clone_url": "https://github.com/sdras/sample-stripe-handler.git",
    "svn_url": "https://github.com/sdras/sample-stripe-handler",
    "homepage": "https://shoppity.azurewebsites.net/",
    "size": 8,
    "stargazers_count": 154,
    "watchers_count": 154,
    "language": "JavaScript",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 26,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "mit",
      "name": "MIT License",
      "spdx_id": "MIT",
      "url": "https://api.github.com/licenses/mit",
      "node_id": "MDc6TGljZW5zZTEz"
    },
    "forks": 26,
    "open_issues": 0,
    "watchers": 154,
    "default_branch": "master"
  },
  {
    "id": 111872580,
    "node_id": "MDEwOlJlcG9zaXRvcnkxMTE4NzI1ODA=",
    "name": "sample-vue-shop",
    "full_name": "sdras/sample-vue-shop",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/sample-vue-shop",
    "description": "See readme for newer repo details! A sample shop that shows how to manage payments with Vue, Stripe, and Serverless Functions",
    "fork": false,
    "url": "https://api.github.com/repos/sdras/sample-vue-shop",
    "forks_url": "https://api.github.com/repos/sdras/sample-vue-shop/forks",
    "keys_url": "https://api.github.com/repos/sdras/sample-vue-shop/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/sample-vue-shop/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/sample-vue-shop/teams",
    "hooks_url": "https://api.github.com/repos/sdras/sample-vue-shop/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/sample-vue-shop/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/sample-vue-shop/events",
    "assignees_url": "https://api.github.com/repos/sdras/sample-vue-shop/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/sample-vue-shop/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/sample-vue-shop/tags",
    "blobs_url": "https://api.github.com/repos/sdras/sample-vue-shop/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/sample-vue-shop/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/sample-vue-shop/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/sample-vue-shop/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/sample-vue-shop/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/sample-vue-shop/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/sample-vue-shop/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/sample-vue-shop/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/sample-vue-shop/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/sample-vue-shop/subscription",
    "commits_url": "https://api.github.com/repos/sdras/sample-vue-shop/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/sample-vue-shop/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/sample-vue-shop/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/sample-vue-shop/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/sample-vue-shop/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/sample-vue-shop/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/sample-vue-shop/merges",
    "archive_url": "https://api.github.com/repos/sdras/sample-vue-shop/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/sample-vue-shop/downloads",
    "issues_url": "https://api.github.com/repos/sdras/sample-vue-shop/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/sample-vue-shop/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/sample-vue-shop/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/sample-vue-shop/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/sample-vue-shop/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/sample-vue-shop/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/sample-vue-shop/deployments",
    "created_at": "2017-11-24T03:37:11Z",
    "updated_at": "2021-01-01T20:57:56Z",
    "pushed_at": "2021-01-05T07:37:03Z",
    "git_url": "git://github.com/sdras/sample-vue-shop.git",
    "ssh_url": "git@github.com:sdras/sample-vue-shop.git",
    "clone_url": "https://github.com/sdras/sample-vue-shop.git",
    "svn_url": "https://github.com/sdras/sample-vue-shop",
    "homepage": "https://shoppity.azurewebsites.net/",
    "size": 1069,
    "stargazers_count": 1157,
    "watchers_count": 1157,
    "language": "Vue",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 241,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 12,
    "license": {
      "key": "mit",
      "name": "MIT License",
      "spdx_id": "MIT",
      "url": "https://api.github.com/licenses/mit",
      "node_id": "MDc6TGljZW5zZTEz"
    },
    "forks": 241,
    "open_issues": 12,
    "watchers": 1157,
    "default_branch": "master"
  },
  {
    "id": 278231093,
    "node_id": "MDEwOlJlcG9zaXRvcnkyNzgyMzEwOTM=",
    "name": "sdras",
    "full_name": "sdras/sdras",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/sdras",
    "description": "it me!",
    "fork": false,
    "url": "https://api.github.com/repos/sdras/sdras",
    "forks_url": "https://api.github.com/repos/sdras/sdras/forks",
    "keys_url": "https://api.github.com/repos/sdras/sdras/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/sdras/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/sdras/teams",
    "hooks_url": "https://api.github.com/repos/sdras/sdras/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/sdras/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/sdras/events",
    "assignees_url": "https://api.github.com/repos/sdras/sdras/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/sdras/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/sdras/tags",
    "blobs_url": "https://api.github.com/repos/sdras/sdras/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/sdras/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/sdras/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/sdras/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/sdras/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/sdras/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/sdras/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/sdras/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/sdras/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/sdras/subscription",
    "commits_url": "https://api.github.com/repos/sdras/sdras/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/sdras/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/sdras/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/sdras/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/sdras/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/sdras/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/sdras/merges",
    "archive_url": "https://api.github.com/repos/sdras/sdras/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/sdras/downloads",
    "issues_url": "https://api.github.com/repos/sdras/sdras/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/sdras/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/sdras/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/sdras/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/sdras/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/sdras/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/sdras/deployments",
    "created_at": "2020-07-09T01:21:39Z",
    "updated_at": "2020-12-07T02:17:34Z",
    "pushed_at": "2020-10-03T21:58:49Z",
    "git_url": "git://github.com/sdras/sdras.git",
    "ssh_url": "git@github.com:sdras/sdras.git",
    "clone_url": "https://github.com/sdras/sdras.git",
    "svn_url": "https://github.com/sdras/sdras",
    "homepage": null,
    "size": 10,
    "stargazers_count": 20,
    "watchers_count": 20,
    "language": null,
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 6,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 6,
    "open_issues": 0,
    "watchers": 20,
    "default_branch": "master"
  },
  {
    "id": 189779730,
    "node_id": "MDEwOlJlcG9zaXRvcnkxODk3Nzk3MzA=",
    "name": "serverless",
    "full_name": "sdras/serverless",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/serverless",
    "description": "The Power of Serverless for Front-End Developers https://thepowerofserverless.info/",
    "fork": true,
    "url": "https://api.github.com/repos/sdras/serverless",
    "forks_url": "https://api.github.com/repos/sdras/serverless/forks",
    "keys_url": "https://api.github.com/repos/sdras/serverless/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/serverless/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/serverless/teams",
    "hooks_url": "https://api.github.com/repos/sdras/serverless/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/serverless/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/serverless/events",
    "assignees_url": "https://api.github.com/repos/sdras/serverless/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/serverless/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/serverless/tags",
    "blobs_url": "https://api.github.com/repos/sdras/serverless/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/serverless/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/serverless/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/serverless/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/serverless/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/serverless/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/serverless/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/serverless/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/serverless/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/serverless/subscription",
    "commits_url": "https://api.github.com/repos/sdras/serverless/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/serverless/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/serverless/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/serverless/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/serverless/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/serverless/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/serverless/merges",
    "archive_url": "https://api.github.com/repos/sdras/serverless/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/serverless/downloads",
    "issues_url": "https://api.github.com/repos/sdras/serverless/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/serverless/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/serverless/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/serverless/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/serverless/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/serverless/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/serverless/deployments",
    "created_at": "2019-06-01T21:38:39Z",
    "updated_at": "2020-06-01T02:14:19Z",
    "pushed_at": "2019-06-02T18:40:09Z",
    "git_url": "git://github.com/sdras/serverless.git",
    "ssh_url": "git@github.com:sdras/serverless.git",
    "clone_url": "https://github.com/sdras/serverless.git",
    "svn_url": "https://github.com/sdras/serverless",
    "homepage": null,
    "size": 19815,
    "stargazers_count": 3,
    "watchers_count": 3,
    "language": "JavaScript",
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "mit",
      "name": "MIT License",
      "spdx_id": "MIT",
      "url": "https://api.github.com/licenses/mit",
      "node_id": "MDc6TGljZW5zZTEz"
    },
    "forks": 0,
    "open_issues": 0,
    "watchers": 3,
    "default_branch": "master"
  },
  {
    "id": 193728725,
    "node_id": "MDEwOlJlcG9zaXRvcnkxOTM3Mjg3MjU=",
    "name": "smashing",
    "full_name": "sdras/smashing",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/smashing",
    "description": "This was the result of a live code talk at Smashing Conf in Toronto, this is how far I got in 45 minutes",
    "fork": false,
    "url": "https://api.github.com/repos/sdras/smashing",
    "forks_url": "https://api.github.com/repos/sdras/smashing/forks",
    "keys_url": "https://api.github.com/repos/sdras/smashing/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/smashing/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/smashing/teams",
    "hooks_url": "https://api.github.com/repos/sdras/smashing/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/smashing/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/smashing/events",
    "assignees_url": "https://api.github.com/repos/sdras/smashing/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/smashing/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/smashing/tags",
    "blobs_url": "https://api.github.com/repos/sdras/smashing/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/smashing/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/smashing/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/smashing/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/smashing/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/smashing/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/smashing/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/smashing/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/smashing/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/smashing/subscription",
    "commits_url": "https://api.github.com/repos/sdras/smashing/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/smashing/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/smashing/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/smashing/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/smashing/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/smashing/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/smashing/merges",
    "archive_url": "https://api.github.com/repos/sdras/smashing/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/smashing/downloads",
    "issues_url": "https://api.github.com/repos/sdras/smashing/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/smashing/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/smashing/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/smashing/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/smashing/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/smashing/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/smashing/deployments",
    "created_at": "2019-06-25T14:54:07Z",
    "updated_at": "2021-01-01T05:55:28Z",
    "pushed_at": "2020-12-11T09:58:49Z",
    "git_url": "git://github.com/sdras/smashing.git",
    "ssh_url": "git@github.com:sdras/smashing.git",
    "clone_url": "https://github.com/sdras/smashing.git",
    "svn_url": "https://github.com/sdras/smashing",
    "homepage": "https://smashingtoronto.netlify.com/",
    "size": 1144,
    "stargazers_count": 70,
    "watchers_count": 70,
    "language": "Vue",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 15,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 4,
    "license": null,
    "forks": 15,
    "open_issues": 4,
    "watchers": 70,
    "default_branch": "master"
  },
  {
    "id": 192017045,
    "node_id": "MDEwOlJlcG9zaXRvcnkxOTIwMTcwNDU=",
    "name": "smashing-template",
    "full_name": "sdras/smashing-template",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/smashing-template",
    "description": "a base of the smashing talk",
    "fork": false,
    "url": "https://api.github.com/repos/sdras/smashing-template",
    "forks_url": "https://api.github.com/repos/sdras/smashing-template/forks",
    "keys_url": "https://api.github.com/repos/sdras/smashing-template/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/smashing-template/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/smashing-template/teams",
    "hooks_url": "https://api.github.com/repos/sdras/smashing-template/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/smashing-template/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/smashing-template/events",
    "assignees_url": "https://api.github.com/repos/sdras/smashing-template/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/smashing-template/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/smashing-template/tags",
    "blobs_url": "https://api.github.com/repos/sdras/smashing-template/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/smashing-template/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/smashing-template/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/smashing-template/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/smashing-template/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/smashing-template/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/smashing-template/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/smashing-template/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/smashing-template/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/smashing-template/subscription",
    "commits_url": "https://api.github.com/repos/sdras/smashing-template/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/smashing-template/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/smashing-template/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/smashing-template/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/smashing-template/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/smashing-template/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/smashing-template/merges",
    "archive_url": "https://api.github.com/repos/sdras/smashing-template/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/smashing-template/downloads",
    "issues_url": "https://api.github.com/repos/sdras/smashing-template/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/smashing-template/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/smashing-template/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/smashing-template/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/smashing-template/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/smashing-template/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/smashing-template/deployments",
    "created_at": "2019-06-14T23:44:33Z",
    "updated_at": "2020-02-14T09:50:54Z",
    "pushed_at": "2020-12-11T09:15:44Z",
    "git_url": "git://github.com/sdras/smashing-template.git",
    "ssh_url": "git@github.com:sdras/smashing-template.git",
    "clone_url": "https://github.com/sdras/smashing-template.git",
    "svn_url": "https://github.com/sdras/smashing-template",
    "homepage": "",
    "size": 4706,
    "stargazers_count": 10,
    "watchers_count": 10,
    "language": "Vue",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 1,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 8,
    "license": {
      "key": "mit",
      "name": "MIT License",
      "spdx_id": "MIT",
      "url": "https://api.github.com/licenses/mit",
      "node_id": "MDc6TGljZW5zZTEz"
    },
    "forks": 1,
    "open_issues": 8,
    "watchers": 10,
    "default_branch": "master"
  },
  {
    "id": 60487530,
    "node_id": "MDEwOlJlcG9zaXRvcnk2MDQ4NzUzMA==",
    "name": "svg-workshop",
    "full_name": "sdras/svg-workshop",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/svg-workshop",
    "description": "Materials for SVG Essentials & Animation Course",
    "fork": false,
    "url": "https://api.github.com/repos/sdras/svg-workshop",
    "forks_url": "https://api.github.com/repos/sdras/svg-workshop/forks",
    "keys_url": "https://api.github.com/repos/sdras/svg-workshop/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/svg-workshop/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/svg-workshop/teams",
    "hooks_url": "https://api.github.com/repos/sdras/svg-workshop/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/svg-workshop/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/svg-workshop/events",
    "assignees_url": "https://api.github.com/repos/sdras/svg-workshop/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/svg-workshop/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/svg-workshop/tags",
    "blobs_url": "https://api.github.com/repos/sdras/svg-workshop/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/svg-workshop/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/svg-workshop/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/svg-workshop/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/svg-workshop/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/svg-workshop/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/svg-workshop/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/svg-workshop/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/svg-workshop/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/svg-workshop/subscription",
    "commits_url": "https://api.github.com/repos/sdras/svg-workshop/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/svg-workshop/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/svg-workshop/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/svg-workshop/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/svg-workshop/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/svg-workshop/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/svg-workshop/merges",
    "archive_url": "https://api.github.com/repos/sdras/svg-workshop/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/svg-workshop/downloads",
    "issues_url": "https://api.github.com/repos/sdras/svg-workshop/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/svg-workshop/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/svg-workshop/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/svg-workshop/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/svg-workshop/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/svg-workshop/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/svg-workshop/deployments",
    "created_at": "2016-06-06T00:22:45Z",
    "updated_at": "2021-01-14T01:07:00Z",
    "pushed_at": "2019-01-15T00:27:34Z",
    "git_url": "git://github.com/sdras/svg-workshop.git",
    "ssh_url": "git@github.com:sdras/svg-workshop.git",
    "clone_url": "https://github.com/sdras/svg-workshop.git",
    "svn_url": "https://github.com/sdras/svg-workshop",
    "homepage": "https://frontendmasters.com/courses/svg-essentials-animation/",
    "size": 99,
    "stargazers_count": 589,
    "watchers_count": 589,
    "language": "HTML",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 217,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 1,
    "license": null,
    "forks": 217,
    "open_issues": 1,
    "watchers": 589,
    "default_branch": "master"
  },
  {
    "id": 103659743,
    "node_id": "MDEwOlJlcG9zaXRvcnkxMDM2NTk3NDM=",
    "name": "teacher-bios",
    "full_name": "sdras/teacher-bios",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/teacher-bios",
    "description": "Biographies of Frontend Masters' Teachers",
    "fork": true,
    "url": "https://api.github.com/repos/sdras/teacher-bios",
    "forks_url": "https://api.github.com/repos/sdras/teacher-bios/forks",
    "keys_url": "https://api.github.com/repos/sdras/teacher-bios/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/teacher-bios/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/teacher-bios/teams",
    "hooks_url": "https://api.github.com/repos/sdras/teacher-bios/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/teacher-bios/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/teacher-bios/events",
    "assignees_url": "https://api.github.com/repos/sdras/teacher-bios/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/teacher-bios/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/teacher-bios/tags",
    "blobs_url": "https://api.github.com/repos/sdras/teacher-bios/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/teacher-bios/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/teacher-bios/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/teacher-bios/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/teacher-bios/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/teacher-bios/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/teacher-bios/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/teacher-bios/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/teacher-bios/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/teacher-bios/subscription",
    "commits_url": "https://api.github.com/repos/sdras/teacher-bios/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/teacher-bios/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/teacher-bios/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/teacher-bios/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/teacher-bios/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/teacher-bios/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/teacher-bios/merges",
    "archive_url": "https://api.github.com/repos/sdras/teacher-bios/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/teacher-bios/downloads",
    "issues_url": "https://api.github.com/repos/sdras/teacher-bios/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/teacher-bios/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/teacher-bios/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/teacher-bios/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/teacher-bios/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/teacher-bios/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/teacher-bios/deployments",
    "created_at": "2017-09-15T13:22:13Z",
    "updated_at": "2017-09-19T03:14:09Z",
    "pushed_at": "2017-09-15T13:23:59Z",
    "git_url": "git://github.com/sdras/teacher-bios.git",
    "ssh_url": "git@github.com:sdras/teacher-bios.git",
    "clone_url": "https://github.com/sdras/teacher-bios.git",
    "svn_url": "https://github.com/sdras/teacher-bios",
    "homepage": "",
    "size": 3382,
    "stargazers_count": 1,
    "watchers_count": 1,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 1,
    "default_branch": "master"
  },
  {
    "id": 124803662,
    "node_id": "MDEwOlJlcG9zaXRvcnkxMjQ4MDM2NjI=",
    "name": "three-vue-pattern",
    "full_name": "sdras/three-vue-pattern",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/three-vue-pattern",
    "description": "A biofeedback visualization made with Three.js, Vue, and LUIS (cognitive services), made with Brian Holt",
    "fork": false,
    "url": "https://api.github.com/repos/sdras/three-vue-pattern",
    "forks_url": "https://api.github.com/repos/sdras/three-vue-pattern/forks",
    "keys_url": "https://api.github.com/repos/sdras/three-vue-pattern/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/three-vue-pattern/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/three-vue-pattern/teams",
    "hooks_url": "https://api.github.com/repos/sdras/three-vue-pattern/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/three-vue-pattern/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/three-vue-pattern/events",
    "assignees_url": "https://api.github.com/repos/sdras/three-vue-pattern/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/three-vue-pattern/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/three-vue-pattern/tags",
    "blobs_url": "https://api.github.com/repos/sdras/three-vue-pattern/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/three-vue-pattern/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/three-vue-pattern/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/three-vue-pattern/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/three-vue-pattern/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/three-vue-pattern/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/three-vue-pattern/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/three-vue-pattern/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/three-vue-pattern/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/three-vue-pattern/subscription",
    "commits_url": "https://api.github.com/repos/sdras/three-vue-pattern/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/three-vue-pattern/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/three-vue-pattern/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/three-vue-pattern/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/three-vue-pattern/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/three-vue-pattern/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/three-vue-pattern/merges",
    "archive_url": "https://api.github.com/repos/sdras/three-vue-pattern/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/three-vue-pattern/downloads",
    "issues_url": "https://api.github.com/repos/sdras/three-vue-pattern/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/three-vue-pattern/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/three-vue-pattern/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/three-vue-pattern/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/three-vue-pattern/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/three-vue-pattern/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/three-vue-pattern/deployments",
    "created_at": "2018-03-11T22:02:18Z",
    "updated_at": "2020-09-15T19:12:29Z",
    "pushed_at": "2018-10-10T03:36:01Z",
    "git_url": "git://github.com/sdras/three-vue-pattern.git",
    "ssh_url": "git@github.com:sdras/three-vue-pattern.git",
    "clone_url": "https://github.com/sdras/three-vue-pattern.git",
    "svn_url": "https://github.com/sdras/three-vue-pattern",
    "homepage": "https://sdras.github.io/three-vue-pattern/",
    "size": 886,
    "stargazers_count": 95,
    "watchers_count": 95,
    "language": "Vue",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": true,
    "forks_count": 11,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 1,
    "license": {
      "key": "mit",
      "name": "MIT License",
      "spdx_id": "MIT",
      "url": "https://api.github.com/licenses/mit",
      "node_id": "MDc6TGljZW5zZTEz"
    },
    "forks": 11,
    "open_issues": 1,
    "watchers": 95,
    "default_branch": "master"
  },
  {
    "id": 11664161,
    "node_id": "MDEwOlJlcG9zaXRvcnkxMTY2NDE2MQ==",
    "name": "Transform_intro",
    "full_name": "sdras/Transform_intro",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/Transform_intro",
    "description": "Introduction to Transforms, with the use of a transition in a class applied to all examples",
    "fork": false,
    "url": "https://api.github.com/repos/sdras/Transform_intro",
    "forks_url": "https://api.github.com/repos/sdras/Transform_intro/forks",
    "keys_url": "https://api.github.com/repos/sdras/Transform_intro/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/Transform_intro/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/Transform_intro/teams",
    "hooks_url": "https://api.github.com/repos/sdras/Transform_intro/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/Transform_intro/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/Transform_intro/events",
    "assignees_url": "https://api.github.com/repos/sdras/Transform_intro/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/Transform_intro/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/Transform_intro/tags",
    "blobs_url": "https://api.github.com/repos/sdras/Transform_intro/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/Transform_intro/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/Transform_intro/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/Transform_intro/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/Transform_intro/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/Transform_intro/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/Transform_intro/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/Transform_intro/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/Transform_intro/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/Transform_intro/subscription",
    "commits_url": "https://api.github.com/repos/sdras/Transform_intro/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/Transform_intro/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/Transform_intro/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/Transform_intro/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/Transform_intro/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/Transform_intro/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/Transform_intro/merges",
    "archive_url": "https://api.github.com/repos/sdras/Transform_intro/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/Transform_intro/downloads",
    "issues_url": "https://api.github.com/repos/sdras/Transform_intro/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/Transform_intro/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/Transform_intro/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/Transform_intro/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/Transform_intro/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/Transform_intro/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/Transform_intro/deployments",
    "created_at": "2013-07-25T15:35:00Z",
    "updated_at": "2020-06-01T02:16:08Z",
    "pushed_at": "2013-07-25T15:44:43Z",
    "git_url": "git://github.com/sdras/Transform_intro.git",
    "ssh_url": "git@github.com:sdras/Transform_intro.git",
    "clone_url": "https://github.com/sdras/Transform_intro.git",
    "svn_url": "https://github.com/sdras/Transform_intro",
    "homepage": null,
    "size": 62,
    "stargazers_count": 6,
    "watchers_count": 6,
    "language": null,
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 0,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 0,
    "open_issues": 0,
    "watchers": 6,
    "default_branch": "master"
  },
  {
    "id": 128483355,
    "node_id": "MDEwOlJlcG9zaXRvcnkxMjg0ODMzNTU=",
    "name": "vue",
    "full_name": "sdras/vue",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/vue",
    "description": "🖖 A progressive, incrementally-adoptable JavaScript framework for building UI on the web.",
    "fork": true,
    "url": "https://api.github.com/repos/sdras/vue",
    "forks_url": "https://api.github.com/repos/sdras/vue/forks",
    "keys_url": "https://api.github.com/repos/sdras/vue/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/vue/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/vue/teams",
    "hooks_url": "https://api.github.com/repos/sdras/vue/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/vue/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/vue/events",
    "assignees_url": "https://api.github.com/repos/sdras/vue/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/vue/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/vue/tags",
    "blobs_url": "https://api.github.com/repos/sdras/vue/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/vue/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/vue/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/vue/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/vue/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/vue/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/vue/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/vue/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/vue/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/vue/subscription",
    "commits_url": "https://api.github.com/repos/sdras/vue/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/vue/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/vue/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/vue/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/vue/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/vue/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/vue/merges",
    "archive_url": "https://api.github.com/repos/sdras/vue/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/vue/downloads",
    "issues_url": "https://api.github.com/repos/sdras/vue/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/vue/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/vue/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/vue/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/vue/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/vue/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/vue/deployments",
    "created_at": "2018-04-07T00:31:41Z",
    "updated_at": "2019-06-22T14:38:17Z",
    "pushed_at": "2018-04-06T08:41:47Z",
    "git_url": "git://github.com/sdras/vue.git",
    "ssh_url": "git@github.com:sdras/vue.git",
    "clone_url": "https://github.com/sdras/vue.git",
    "svn_url": "https://github.com/sdras/vue",
    "homepage": "http://vuejs.org",
    "size": 23470,
    "stargazers_count": 2,
    "watchers_count": 2,
    "language": "JavaScript",
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": false,
    "has_pages": false,
    "forks_count": 1,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "mit",
      "name": "MIT License",
      "spdx_id": "MIT",
      "url": "https://api.github.com/licenses/mit",
      "node_id": "MDc6TGljZW5zZTEz"
    },
    "forks": 1,
    "open_issues": 0,
    "watchers": 2,
    "default_branch": "dev"
  },
  {
    "id": 145156031,
    "node_id": "MDEwOlJlcG9zaXRvcnkxNDUxNTYwMzE=",
    "name": "vue-auth-vuex",
    "full_name": "sdras/vue-auth-vuex",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/vue-auth-vuex",
    "description": null,
    "fork": true,
    "url": "https://api.github.com/repos/sdras/vue-auth-vuex",
    "forks_url": "https://api.github.com/repos/sdras/vue-auth-vuex/forks",
    "keys_url": "https://api.github.com/repos/sdras/vue-auth-vuex/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/vue-auth-vuex/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/vue-auth-vuex/teams",
    "hooks_url": "https://api.github.com/repos/sdras/vue-auth-vuex/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/vue-auth-vuex/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/vue-auth-vuex/events",
    "assignees_url": "https://api.github.com/repos/sdras/vue-auth-vuex/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/vue-auth-vuex/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/vue-auth-vuex/tags",
    "blobs_url": "https://api.github.com/repos/sdras/vue-auth-vuex/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/vue-auth-vuex/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/vue-auth-vuex/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/vue-auth-vuex/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/vue-auth-vuex/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/vue-auth-vuex/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/vue-auth-vuex/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/vue-auth-vuex/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/vue-auth-vuex/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/vue-auth-vuex/subscription",
    "commits_url": "https://api.github.com/repos/sdras/vue-auth-vuex/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/vue-auth-vuex/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/vue-auth-vuex/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/vue-auth-vuex/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/vue-auth-vuex/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/vue-auth-vuex/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/vue-auth-vuex/merges",
    "archive_url": "https://api.github.com/repos/sdras/vue-auth-vuex/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/vue-auth-vuex/downloads",
    "issues_url": "https://api.github.com/repos/sdras/vue-auth-vuex/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/vue-auth-vuex/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/vue-auth-vuex/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/vue-auth-vuex/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/vue-auth-vuex/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/vue-auth-vuex/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/vue-auth-vuex/deployments",
    "created_at": "2018-08-17T18:53:33Z",
    "updated_at": "2021-01-01T06:06:07Z",
    "pushed_at": "2018-08-02T16:09:15Z",
    "git_url": "git://github.com/sdras/vue-auth-vuex.git",
    "ssh_url": "git@github.com:sdras/vue-auth-vuex.git",
    "clone_url": "https://github.com/sdras/vue-auth-vuex.git",
    "svn_url": "https://github.com/sdras/vue-auth-vuex",
    "homepage": null,
    "size": 103,
    "stargazers_count": 8,
    "watchers_count": 8,
    "language": "Vue",
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 5,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 5,
    "open_issues": 0,
    "watchers": 8,
    "default_branch": "master"
  },
  {
    "id": 110051032,
    "node_id": "MDEwOlJlcG9zaXRvcnkxMTAwNTEwMzI=",
    "name": "vue-cosmosdb",
    "full_name": "sdras/vue-cosmosdb",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/vue-cosmosdb",
    "description": "Cosmos DB, Express.js, Vue, and Node.js app",
    "fork": true,
    "url": "https://api.github.com/repos/sdras/vue-cosmosdb",
    "forks_url": "https://api.github.com/repos/sdras/vue-cosmosdb/forks",
    "keys_url": "https://api.github.com/repos/sdras/vue-cosmosdb/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/vue-cosmosdb/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/vue-cosmosdb/teams",
    "hooks_url": "https://api.github.com/repos/sdras/vue-cosmosdb/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/vue-cosmosdb/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/vue-cosmosdb/events",
    "assignees_url": "https://api.github.com/repos/sdras/vue-cosmosdb/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/vue-cosmosdb/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/vue-cosmosdb/tags",
    "blobs_url": "https://api.github.com/repos/sdras/vue-cosmosdb/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/vue-cosmosdb/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/vue-cosmosdb/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/vue-cosmosdb/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/vue-cosmosdb/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/vue-cosmosdb/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/vue-cosmosdb/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/vue-cosmosdb/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/vue-cosmosdb/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/vue-cosmosdb/subscription",
    "commits_url": "https://api.github.com/repos/sdras/vue-cosmosdb/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/vue-cosmosdb/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/vue-cosmosdb/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/vue-cosmosdb/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/vue-cosmosdb/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/vue-cosmosdb/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/vue-cosmosdb/merges",
    "archive_url": "https://api.github.com/repos/sdras/vue-cosmosdb/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/vue-cosmosdb/downloads",
    "issues_url": "https://api.github.com/repos/sdras/vue-cosmosdb/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/vue-cosmosdb/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/vue-cosmosdb/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/vue-cosmosdb/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/vue-cosmosdb/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/vue-cosmosdb/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/vue-cosmosdb/deployments",
    "created_at": "2017-11-09T01:26:34Z",
    "updated_at": "2021-01-01T06:09:55Z",
    "pushed_at": "2017-11-09T02:27:57Z",
    "git_url": "git://github.com/sdras/vue-cosmosdb.git",
    "ssh_url": "git@github.com:sdras/vue-cosmosdb.git",
    "clone_url": "https://github.com/sdras/vue-cosmosdb.git",
    "svn_url": "https://github.com/sdras/vue-cosmosdb",
    "homepage": null,
    "size": 500,
    "stargazers_count": 2,
    "watchers_count": 2,
    "language": "Vue",
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 1,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "mit",
      "name": "MIT License",
      "spdx_id": "MIT",
      "url": "https://api.github.com/licenses/mit",
      "node_id": "MDc6TGljZW5zZTEz"
    },
    "forks": 1,
    "open_issues": 0,
    "watchers": 2,
    "default_branch": "master"
  },
  {
    "id": 128571331,
    "node_id": "MDEwOlJlcG9zaXRvcnkxMjg1NzEzMzE=",
    "name": "vue-directory-tree",
    "full_name": "sdras/vue-directory-tree",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/vue-directory-tree",
    "description": "A visualization of relevant files for vue repo, along with notes",
    "fork": false,
    "url": "https://api.github.com/repos/sdras/vue-directory-tree",
    "forks_url": "https://api.github.com/repos/sdras/vue-directory-tree/forks",
    "keys_url": "https://api.github.com/repos/sdras/vue-directory-tree/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/vue-directory-tree/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/vue-directory-tree/teams",
    "hooks_url": "https://api.github.com/repos/sdras/vue-directory-tree/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/vue-directory-tree/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/vue-directory-tree/events",
    "assignees_url": "https://api.github.com/repos/sdras/vue-directory-tree/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/vue-directory-tree/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/vue-directory-tree/tags",
    "blobs_url": "https://api.github.com/repos/sdras/vue-directory-tree/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/vue-directory-tree/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/vue-directory-tree/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/vue-directory-tree/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/vue-directory-tree/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/vue-directory-tree/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/vue-directory-tree/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/vue-directory-tree/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/vue-directory-tree/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/vue-directory-tree/subscription",
    "commits_url": "https://api.github.com/repos/sdras/vue-directory-tree/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/vue-directory-tree/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/vue-directory-tree/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/vue-directory-tree/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/vue-directory-tree/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/vue-directory-tree/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/vue-directory-tree/merges",
    "archive_url": "https://api.github.com/repos/sdras/vue-directory-tree/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/vue-directory-tree/downloads",
    "issues_url": "https://api.github.com/repos/sdras/vue-directory-tree/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/vue-directory-tree/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/vue-directory-tree/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/vue-directory-tree/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/vue-directory-tree/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/vue-directory-tree/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/vue-directory-tree/deployments",
    "created_at": "2018-04-07T21:47:02Z",
    "updated_at": "2020-11-17T14:03:52Z",
    "pushed_at": "2018-10-12T21:55:35Z",
    "git_url": "git://github.com/sdras/vue-directory-tree.git",
    "ssh_url": "git@github.com:sdras/vue-directory-tree.git",
    "clone_url": "https://github.com/sdras/vue-directory-tree.git",
    "svn_url": "https://github.com/sdras/vue-directory-tree",
    "homepage": "https://sdras.github.io/vue-directory-tree/",
    "size": 415,
    "stargazers_count": 160,
    "watchers_count": 160,
    "language": "JavaScript",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": true,
    "forks_count": 6,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 6,
    "license": {
      "key": "mit",
      "name": "MIT License",
      "spdx_id": "MIT",
      "url": "https://api.github.com/licenses/mit",
      "node_id": "MDc6TGljZW5zZTEz"
    },
    "forks": 6,
    "open_issues": 6,
    "watchers": 160,
    "default_branch": "master"
  },
  {
    "id": 109599349,
    "node_id": "MDEwOlJlcG9zaXRvcnkxMDk1OTkzNDk=",
    "name": "vue-heroes",
    "full_name": "sdras/vue-heroes",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/vue-heroes",
    "description": null,
    "fork": true,
    "url": "https://api.github.com/repos/sdras/vue-heroes",
    "forks_url": "https://api.github.com/repos/sdras/vue-heroes/forks",
    "keys_url": "https://api.github.com/repos/sdras/vue-heroes/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/vue-heroes/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/vue-heroes/teams",
    "hooks_url": "https://api.github.com/repos/sdras/vue-heroes/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/vue-heroes/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/vue-heroes/events",
    "assignees_url": "https://api.github.com/repos/sdras/vue-heroes/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/vue-heroes/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/vue-heroes/tags",
    "blobs_url": "https://api.github.com/repos/sdras/vue-heroes/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/vue-heroes/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/vue-heroes/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/vue-heroes/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/vue-heroes/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/vue-heroes/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/vue-heroes/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/vue-heroes/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/vue-heroes/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/vue-heroes/subscription",
    "commits_url": "https://api.github.com/repos/sdras/vue-heroes/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/vue-heroes/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/vue-heroes/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/vue-heroes/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/vue-heroes/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/vue-heroes/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/vue-heroes/merges",
    "archive_url": "https://api.github.com/repos/sdras/vue-heroes/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/vue-heroes/downloads",
    "issues_url": "https://api.github.com/repos/sdras/vue-heroes/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/vue-heroes/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/vue-heroes/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/vue-heroes/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/vue-heroes/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/vue-heroes/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/vue-heroes/deployments",
    "created_at": "2017-11-05T17:12:37Z",
    "updated_at": "2021-01-01T06:10:54Z",
    "pushed_at": "2017-11-05T17:16:10Z",
    "git_url": "git://github.com/sdras/vue-heroes.git",
    "ssh_url": "git@github.com:sdras/vue-heroes.git",
    "clone_url": "https://github.com/sdras/vue-heroes.git",
    "svn_url": "https://github.com/sdras/vue-heroes",
    "homepage": null,
    "size": 430,
    "stargazers_count": 3,
    "watchers_count": 3,
    "language": "JavaScript",
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 1,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 1,
    "open_issues": 0,
    "watchers": 3,
    "default_branch": "master"
  },
  {
    "id": 166589467,
    "node_id": "MDEwOlJlcG9zaXRvcnkxNjY1ODk0Njc=",
    "name": "vue-hooks-foodapp",
    "full_name": "sdras/vue-hooks-foodapp",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/vue-hooks-foodapp",
    "description": "A food app using a few hooks in Vue to show how they can work (experimental)",
    "fork": false,
    "url": "https://api.github.com/repos/sdras/vue-hooks-foodapp",
    "forks_url": "https://api.github.com/repos/sdras/vue-hooks-foodapp/forks",
    "keys_url": "https://api.github.com/repos/sdras/vue-hooks-foodapp/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/vue-hooks-foodapp/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/vue-hooks-foodapp/teams",
    "hooks_url": "https://api.github.com/repos/sdras/vue-hooks-foodapp/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/vue-hooks-foodapp/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/vue-hooks-foodapp/events",
    "assignees_url": "https://api.github.com/repos/sdras/vue-hooks-foodapp/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/vue-hooks-foodapp/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/vue-hooks-foodapp/tags",
    "blobs_url": "https://api.github.com/repos/sdras/vue-hooks-foodapp/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/vue-hooks-foodapp/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/vue-hooks-foodapp/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/vue-hooks-foodapp/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/vue-hooks-foodapp/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/vue-hooks-foodapp/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/vue-hooks-foodapp/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/vue-hooks-foodapp/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/vue-hooks-foodapp/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/vue-hooks-foodapp/subscription",
    "commits_url": "https://api.github.com/repos/sdras/vue-hooks-foodapp/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/vue-hooks-foodapp/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/vue-hooks-foodapp/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/vue-hooks-foodapp/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/vue-hooks-foodapp/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/vue-hooks-foodapp/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/vue-hooks-foodapp/merges",
    "archive_url": "https://api.github.com/repos/sdras/vue-hooks-foodapp/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/vue-hooks-foodapp/downloads",
    "issues_url": "https://api.github.com/repos/sdras/vue-hooks-foodapp/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/vue-hooks-foodapp/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/vue-hooks-foodapp/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/vue-hooks-foodapp/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/vue-hooks-foodapp/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/vue-hooks-foodapp/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/vue-hooks-foodapp/deployments",
    "created_at": "2019-01-19T20:19:50Z",
    "updated_at": "2021-01-01T06:04:05Z",
    "pushed_at": "2019-02-04T20:07:27Z",
    "git_url": "git://github.com/sdras/vue-hooks-foodapp.git",
    "ssh_url": "git@github.com:sdras/vue-hooks-foodapp.git",
    "clone_url": "https://github.com/sdras/vue-hooks-foodapp.git",
    "svn_url": "https://github.com/sdras/vue-hooks-foodapp",
    "homepage": "https://sdras.github.io/vue-hooks-foodapp/",
    "size": 4301,
    "stargazers_count": 179,
    "watchers_count": 179,
    "language": "Vue",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": true,
    "forks_count": 12,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "mit",
      "name": "MIT License",
      "spdx_id": "MIT",
      "url": "https://api.github.com/licenses/mit",
      "node_id": "MDc6TGljZW5zZTEz"
    },
    "forks": 12,
    "open_issues": 0,
    "watchers": 179,
    "default_branch": "master"
  },
  {
    "id": 115216805,
    "node_id": "MDEwOlJlcG9zaXRvcnkxMTUyMTY4MDU=",
    "name": "vue-sample-svg-icons",
    "full_name": "sdras/vue-sample-svg-icons",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/vue-sample-svg-icons",
    "description": "An opinionated example of how to use SVG icons in a Vue.js application",
    "fork": false,
    "url": "https://api.github.com/repos/sdras/vue-sample-svg-icons",
    "forks_url": "https://api.github.com/repos/sdras/vue-sample-svg-icons/forks",
    "keys_url": "https://api.github.com/repos/sdras/vue-sample-svg-icons/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/vue-sample-svg-icons/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/vue-sample-svg-icons/teams",
    "hooks_url": "https://api.github.com/repos/sdras/vue-sample-svg-icons/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/vue-sample-svg-icons/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/vue-sample-svg-icons/events",
    "assignees_url": "https://api.github.com/repos/sdras/vue-sample-svg-icons/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/vue-sample-svg-icons/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/vue-sample-svg-icons/tags",
    "blobs_url": "https://api.github.com/repos/sdras/vue-sample-svg-icons/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/vue-sample-svg-icons/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/vue-sample-svg-icons/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/vue-sample-svg-icons/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/vue-sample-svg-icons/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/vue-sample-svg-icons/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/vue-sample-svg-icons/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/vue-sample-svg-icons/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/vue-sample-svg-icons/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/vue-sample-svg-icons/subscription",
    "commits_url": "https://api.github.com/repos/sdras/vue-sample-svg-icons/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/vue-sample-svg-icons/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/vue-sample-svg-icons/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/vue-sample-svg-icons/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/vue-sample-svg-icons/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/vue-sample-svg-icons/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/vue-sample-svg-icons/merges",
    "archive_url": "https://api.github.com/repos/sdras/vue-sample-svg-icons/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/vue-sample-svg-icons/downloads",
    "issues_url": "https://api.github.com/repos/sdras/vue-sample-svg-icons/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/vue-sample-svg-icons/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/vue-sample-svg-icons/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/vue-sample-svg-icons/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/vue-sample-svg-icons/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/vue-sample-svg-icons/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/vue-sample-svg-icons/deployments",
    "created_at": "2017-12-23T19:20:51Z",
    "updated_at": "2021-01-15T11:25:17Z",
    "pushed_at": "2020-12-27T16:23:27Z",
    "git_url": "git://github.com/sdras/vue-sample-svg-icons.git",
    "ssh_url": "git@github.com:sdras/vue-sample-svg-icons.git",
    "clone_url": "https://github.com/sdras/vue-sample-svg-icons.git",
    "svn_url": "https://github.com/sdras/vue-sample-svg-icons",
    "homepage": "https://sdras.github.io/vue-sample-svg-icons/",
    "size": 1075,
    "stargazers_count": 378,
    "watchers_count": 378,
    "language": "Vue",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": true,
    "forks_count": 95,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 3,
    "license": {
      "key": "mit",
      "name": "MIT License",
      "spdx_id": "MIT",
      "url": "https://api.github.com/licenses/mit",
      "node_id": "MDc6TGljZW5zZTEz"
    },
    "forks": 95,
    "open_issues": 3,
    "watchers": 378,
    "default_branch": "master"
  },
  {
    "id": 78369522,
    "node_id": "MDEwOlJlcG9zaXRvcnk3ODM2OTUyMg==",
    "name": "vue-sublime-snippets",
    "full_name": "sdras/vue-sublime-snippets",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/vue-sublime-snippets",
    "description": "Simplify and supercharging my workflow with snippets for Vue.js that help me spin things up quickly",
    "fork": false,
    "url": "https://api.github.com/repos/sdras/vue-sublime-snippets",
    "forks_url": "https://api.github.com/repos/sdras/vue-sublime-snippets/forks",
    "keys_url": "https://api.github.com/repos/sdras/vue-sublime-snippets/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/vue-sublime-snippets/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/vue-sublime-snippets/teams",
    "hooks_url": "https://api.github.com/repos/sdras/vue-sublime-snippets/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/vue-sublime-snippets/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/vue-sublime-snippets/events",
    "assignees_url": "https://api.github.com/repos/sdras/vue-sublime-snippets/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/vue-sublime-snippets/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/vue-sublime-snippets/tags",
    "blobs_url": "https://api.github.com/repos/sdras/vue-sublime-snippets/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/vue-sublime-snippets/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/vue-sublime-snippets/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/vue-sublime-snippets/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/vue-sublime-snippets/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/vue-sublime-snippets/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/vue-sublime-snippets/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/vue-sublime-snippets/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/vue-sublime-snippets/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/vue-sublime-snippets/subscription",
    "commits_url": "https://api.github.com/repos/sdras/vue-sublime-snippets/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/vue-sublime-snippets/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/vue-sublime-snippets/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/vue-sublime-snippets/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/vue-sublime-snippets/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/vue-sublime-snippets/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/vue-sublime-snippets/merges",
    "archive_url": "https://api.github.com/repos/sdras/vue-sublime-snippets/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/vue-sublime-snippets/downloads",
    "issues_url": "https://api.github.com/repos/sdras/vue-sublime-snippets/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/vue-sublime-snippets/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/vue-sublime-snippets/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/vue-sublime-snippets/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/vue-sublime-snippets/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/vue-sublime-snippets/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/vue-sublime-snippets/deployments",
    "created_at": "2017-01-08T20:46:27Z",
    "updated_at": "2020-12-03T13:50:42Z",
    "pushed_at": "2018-01-09T16:26:45Z",
    "git_url": "git://github.com/sdras/vue-sublime-snippets.git",
    "ssh_url": "git@github.com:sdras/vue-sublime-snippets.git",
    "clone_url": "https://github.com/sdras/vue-sublime-snippets.git",
    "svn_url": "https://github.com/sdras/vue-sublime-snippets",
    "homepage": null,
    "size": 10,
    "stargazers_count": 146,
    "watchers_count": 146,
    "language": null,
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 13,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 13,
    "open_issues": 0,
    "watchers": 146,
    "default_branch": "master"
  },
  {
    "id": 111356664,
    "node_id": "MDEwOlJlcG9zaXRvcnkxMTEzNTY2NjQ=",
    "name": "vue-vscode-extensionpack",
    "full_name": "sdras/vue-vscode-extensionpack",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/vue-vscode-extensionpack",
    "description": "The extensions I use when developing a Vue application with VS Code",
    "fork": false,
    "url": "https://api.github.com/repos/sdras/vue-vscode-extensionpack",
    "forks_url": "https://api.github.com/repos/sdras/vue-vscode-extensionpack/forks",
    "keys_url": "https://api.github.com/repos/sdras/vue-vscode-extensionpack/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/vue-vscode-extensionpack/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/vue-vscode-extensionpack/teams",
    "hooks_url": "https://api.github.com/repos/sdras/vue-vscode-extensionpack/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/vue-vscode-extensionpack/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/vue-vscode-extensionpack/events",
    "assignees_url": "https://api.github.com/repos/sdras/vue-vscode-extensionpack/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/vue-vscode-extensionpack/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/vue-vscode-extensionpack/tags",
    "blobs_url": "https://api.github.com/repos/sdras/vue-vscode-extensionpack/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/vue-vscode-extensionpack/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/vue-vscode-extensionpack/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/vue-vscode-extensionpack/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/vue-vscode-extensionpack/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/vue-vscode-extensionpack/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/vue-vscode-extensionpack/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/vue-vscode-extensionpack/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/vue-vscode-extensionpack/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/vue-vscode-extensionpack/subscription",
    "commits_url": "https://api.github.com/repos/sdras/vue-vscode-extensionpack/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/vue-vscode-extensionpack/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/vue-vscode-extensionpack/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/vue-vscode-extensionpack/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/vue-vscode-extensionpack/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/vue-vscode-extensionpack/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/vue-vscode-extensionpack/merges",
    "archive_url": "https://api.github.com/repos/sdras/vue-vscode-extensionpack/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/vue-vscode-extensionpack/downloads",
    "issues_url": "https://api.github.com/repos/sdras/vue-vscode-extensionpack/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/vue-vscode-extensionpack/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/vue-vscode-extensionpack/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/vue-vscode-extensionpack/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/vue-vscode-extensionpack/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/vue-vscode-extensionpack/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/vue-vscode-extensionpack/deployments",
    "created_at": "2017-11-20T03:21:34Z",
    "updated_at": "2021-01-12T23:04:53Z",
    "pushed_at": "2020-03-18T18:13:04Z",
    "git_url": "git://github.com/sdras/vue-vscode-extensionpack.git",
    "ssh_url": "git@github.com:sdras/vue-vscode-extensionpack.git",
    "clone_url": "https://github.com/sdras/vue-vscode-extensionpack.git",
    "svn_url": "https://github.com/sdras/vue-vscode-extensionpack",
    "homepage": null,
    "size": 1039,
    "stargazers_count": 262,
    "watchers_count": 262,
    "language": null,
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 15,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 4,
    "license": {
      "key": "mit",
      "name": "MIT License",
      "spdx_id": "MIT",
      "url": "https://api.github.com/licenses/mit",
      "node_id": "MDc6TGljZW5zZTEz"
    },
    "forks": 15,
    "open_issues": 4,
    "watchers": 262,
    "default_branch": "master"
  },
  {
    "id": 100876550,
    "node_id": "MDEwOlJlcG9zaXRvcnkxMDA4NzY1NTA=",
    "name": "vue-vscode-snippets",
    "full_name": "sdras/vue-vscode-snippets",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/vue-vscode-snippets",
    "description": "These snippets were built to supercharge my workflow in the most seamless manner possible.",
    "fork": false,
    "url": "https://api.github.com/repos/sdras/vue-vscode-snippets",
    "forks_url": "https://api.github.com/repos/sdras/vue-vscode-snippets/forks",
    "keys_url": "https://api.github.com/repos/sdras/vue-vscode-snippets/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/vue-vscode-snippets/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/vue-vscode-snippets/teams",
    "hooks_url": "https://api.github.com/repos/sdras/vue-vscode-snippets/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/vue-vscode-snippets/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/vue-vscode-snippets/events",
    "assignees_url": "https://api.github.com/repos/sdras/vue-vscode-snippets/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/vue-vscode-snippets/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/vue-vscode-snippets/tags",
    "blobs_url": "https://api.github.com/repos/sdras/vue-vscode-snippets/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/vue-vscode-snippets/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/vue-vscode-snippets/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/vue-vscode-snippets/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/vue-vscode-snippets/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/vue-vscode-snippets/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/vue-vscode-snippets/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/vue-vscode-snippets/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/vue-vscode-snippets/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/vue-vscode-snippets/subscription",
    "commits_url": "https://api.github.com/repos/sdras/vue-vscode-snippets/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/vue-vscode-snippets/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/vue-vscode-snippets/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/vue-vscode-snippets/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/vue-vscode-snippets/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/vue-vscode-snippets/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/vue-vscode-snippets/merges",
    "archive_url": "https://api.github.com/repos/sdras/vue-vscode-snippets/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/vue-vscode-snippets/downloads",
    "issues_url": "https://api.github.com/repos/sdras/vue-vscode-snippets/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/vue-vscode-snippets/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/vue-vscode-snippets/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/vue-vscode-snippets/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/vue-vscode-snippets/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/vue-vscode-snippets/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/vue-vscode-snippets/deployments",
    "created_at": "2017-08-20T17:09:47Z",
    "updated_at": "2021-01-14T13:06:01Z",
    "pushed_at": "2020-11-05T12:39:47Z",
    "git_url": "git://github.com/sdras/vue-vscode-snippets.git",
    "ssh_url": "git@github.com:sdras/vue-vscode-snippets.git",
    "clone_url": "https://github.com/sdras/vue-vscode-snippets.git",
    "svn_url": "https://github.com/sdras/vue-vscode-snippets",
    "homepage": "https://marketplace.visualstudio.com/items?itemName=sdras.vue-vscode-snippets",
    "size": 1695,
    "stargazers_count": 1069,
    "watchers_count": 1069,
    "language": "JavaScript",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 123,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 15,
    "license": {
      "key": "mit",
      "name": "MIT License",
      "spdx_id": "MIT",
      "url": "https://api.github.com/licenses/mit",
      "node_id": "MDc6TGljZW5zZTEz"
    },
    "forks": 123,
    "open_issues": 15,
    "watchers": 1069,
    "default_branch": "master"
  },
  {
    "id": 78888506,
    "node_id": "MDEwOlJlcG9zaXRvcnk3ODg4ODUwNg==",
    "name": "vue-weather-notifier",
    "full_name": "sdras/vue-weather-notifier",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/vue-weather-notifier",
    "description": "A small SVG animation illustrating a weather app notification in Vue",
    "fork": false,
    "url": "https://api.github.com/repos/sdras/vue-weather-notifier",
    "forks_url": "https://api.github.com/repos/sdras/vue-weather-notifier/forks",
    "keys_url": "https://api.github.com/repos/sdras/vue-weather-notifier/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/vue-weather-notifier/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/vue-weather-notifier/teams",
    "hooks_url": "https://api.github.com/repos/sdras/vue-weather-notifier/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/vue-weather-notifier/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/vue-weather-notifier/events",
    "assignees_url": "https://api.github.com/repos/sdras/vue-weather-notifier/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/vue-weather-notifier/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/vue-weather-notifier/tags",
    "blobs_url": "https://api.github.com/repos/sdras/vue-weather-notifier/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/vue-weather-notifier/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/vue-weather-notifier/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/vue-weather-notifier/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/vue-weather-notifier/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/vue-weather-notifier/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/vue-weather-notifier/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/vue-weather-notifier/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/vue-weather-notifier/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/vue-weather-notifier/subscription",
    "commits_url": "https://api.github.com/repos/sdras/vue-weather-notifier/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/vue-weather-notifier/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/vue-weather-notifier/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/vue-weather-notifier/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/vue-weather-notifier/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/vue-weather-notifier/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/vue-weather-notifier/merges",
    "archive_url": "https://api.github.com/repos/sdras/vue-weather-notifier/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/vue-weather-notifier/downloads",
    "issues_url": "https://api.github.com/repos/sdras/vue-weather-notifier/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/vue-weather-notifier/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/vue-weather-notifier/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/vue-weather-notifier/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/vue-weather-notifier/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/vue-weather-notifier/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/vue-weather-notifier/deployments",
    "created_at": "2017-01-13T21:35:20Z",
    "updated_at": "2020-12-12T12:00:53Z",
    "pushed_at": "2017-01-25T16:55:57Z",
    "git_url": "git://github.com/sdras/vue-weather-notifier.git",
    "ssh_url": "git@github.com:sdras/vue-weather-notifier.git",
    "clone_url": "https://github.com/sdras/vue-weather-notifier.git",
    "svn_url": "https://github.com/sdras/vue-weather-notifier",
    "homepage": null,
    "size": 333,
    "stargazers_count": 186,
    "watchers_count": 186,
    "language": "Vue",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 31,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 1,
    "license": null,
    "forks": 31,
    "open_issues": 1,
    "watchers": 186,
    "default_branch": "master"
  },
  {
    "id": 78554297,
    "node_id": "MDEwOlJlcG9zaXRvcnk3ODU1NDI5Nw==",
    "name": "vue-wine-label",
    "full_name": "sdras/vue-wine-label",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/vue-wine-label",
    "description": "A very silly demo showing how to make a wine label making dashboard with Vue.js",
    "fork": false,
    "url": "https://api.github.com/repos/sdras/vue-wine-label",
    "forks_url": "https://api.github.com/repos/sdras/vue-wine-label/forks",
    "keys_url": "https://api.github.com/repos/sdras/vue-wine-label/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/vue-wine-label/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/vue-wine-label/teams",
    "hooks_url": "https://api.github.com/repos/sdras/vue-wine-label/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/vue-wine-label/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/vue-wine-label/events",
    "assignees_url": "https://api.github.com/repos/sdras/vue-wine-label/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/vue-wine-label/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/vue-wine-label/tags",
    "blobs_url": "https://api.github.com/repos/sdras/vue-wine-label/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/vue-wine-label/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/vue-wine-label/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/vue-wine-label/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/vue-wine-label/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/vue-wine-label/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/vue-wine-label/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/vue-wine-label/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/vue-wine-label/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/vue-wine-label/subscription",
    "commits_url": "https://api.github.com/repos/sdras/vue-wine-label/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/vue-wine-label/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/vue-wine-label/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/vue-wine-label/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/vue-wine-label/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/vue-wine-label/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/vue-wine-label/merges",
    "archive_url": "https://api.github.com/repos/sdras/vue-wine-label/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/vue-wine-label/downloads",
    "issues_url": "https://api.github.com/repos/sdras/vue-wine-label/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/vue-wine-label/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/vue-wine-label/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/vue-wine-label/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/vue-wine-label/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/vue-wine-label/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/vue-wine-label/deployments",
    "created_at": "2017-01-10T16:56:05Z",
    "updated_at": "2020-12-03T08:55:21Z",
    "pushed_at": "2018-02-19T20:22:54Z",
    "git_url": "git://github.com/sdras/vue-wine-label.git",
    "ssh_url": "git@github.com:sdras/vue-wine-label.git",
    "clone_url": "https://github.com/sdras/vue-wine-label.git",
    "svn_url": "https://github.com/sdras/vue-wine-label",
    "homepage": null,
    "size": 338,
    "stargazers_count": 53,
    "watchers_count": 53,
    "language": "JavaScript",
    "has_issues": true,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 18,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 18,
    "open_issues": 0,
    "watchers": 53,
    "default_branch": "master"
  },
  {
    "id": 109181254,
    "node_id": "MDEwOlJlcG9zaXRvcnkxMDkxODEyNTQ=",
    "name": "vuejs.org",
    "full_name": "sdras/vuejs.org",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/vuejs.org",
    "description": "The website.",
    "fork": true,
    "url": "https://api.github.com/repos/sdras/vuejs.org",
    "forks_url": "https://api.github.com/repos/sdras/vuejs.org/forks",
    "keys_url": "https://api.github.com/repos/sdras/vuejs.org/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/vuejs.org/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/vuejs.org/teams",
    "hooks_url": "https://api.github.com/repos/sdras/vuejs.org/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/vuejs.org/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/vuejs.org/events",
    "assignees_url": "https://api.github.com/repos/sdras/vuejs.org/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/vuejs.org/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/vuejs.org/tags",
    "blobs_url": "https://api.github.com/repos/sdras/vuejs.org/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/vuejs.org/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/vuejs.org/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/vuejs.org/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/vuejs.org/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/vuejs.org/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/vuejs.org/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/vuejs.org/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/vuejs.org/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/vuejs.org/subscription",
    "commits_url": "https://api.github.com/repos/sdras/vuejs.org/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/vuejs.org/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/vuejs.org/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/vuejs.org/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/vuejs.org/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/vuejs.org/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/vuejs.org/merges",
    "archive_url": "https://api.github.com/repos/sdras/vuejs.org/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/vuejs.org/downloads",
    "issues_url": "https://api.github.com/repos/sdras/vuejs.org/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/vuejs.org/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/vuejs.org/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/vuejs.org/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/vuejs.org/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/vuejs.org/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/vuejs.org/deployments",
    "created_at": "2017-11-01T20:35:56Z",
    "updated_at": "2019-11-07T06:06:57Z",
    "pushed_at": "2020-04-03T13:50:38Z",
    "git_url": "git://github.com/sdras/vuejs.org.git",
    "ssh_url": "git@github.com:sdras/vuejs.org.git",
    "clone_url": "https://github.com/sdras/vuejs.org.git",
    "svn_url": "https://github.com/sdras/vuejs.org",
    "homepage": "vuejs.org",
    "size": 47433,
    "stargazers_count": 3,
    "watchers_count": 3,
    "language": "JavaScript",
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": false,
    "has_pages": false,
    "forks_count": 1,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "mit",
      "name": "MIT License",
      "spdx_id": "MIT",
      "url": "https://api.github.com/licenses/mit",
      "node_id": "MDc6TGljZW5zZTEz"
    },
    "forks": 1,
    "open_issues": 0,
    "watchers": 3,
    "default_branch": "master"
  },
  {
    "id": 231132150,
    "node_id": "MDEwOlJlcG9zaXRvcnkyMzExMzIxNTA=",
    "name": "wedding",
    "full_name": "sdras/wedding",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/wedding",
    "description": null,
    "fork": true,
    "url": "https://api.github.com/repos/sdras/wedding",
    "forks_url": "https://api.github.com/repos/sdras/wedding/forks",
    "keys_url": "https://api.github.com/repos/sdras/wedding/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/wedding/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/wedding/teams",
    "hooks_url": "https://api.github.com/repos/sdras/wedding/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/wedding/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/wedding/events",
    "assignees_url": "https://api.github.com/repos/sdras/wedding/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/wedding/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/wedding/tags",
    "blobs_url": "https://api.github.com/repos/sdras/wedding/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/wedding/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/wedding/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/wedding/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/wedding/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/wedding/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/wedding/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/wedding/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/wedding/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/wedding/subscription",
    "commits_url": "https://api.github.com/repos/sdras/wedding/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/wedding/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/wedding/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/wedding/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/wedding/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/wedding/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/wedding/merges",
    "archive_url": "https://api.github.com/repos/sdras/wedding/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/wedding/downloads",
    "issues_url": "https://api.github.com/repos/sdras/wedding/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/wedding/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/wedding/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/wedding/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/wedding/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/wedding/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/wedding/deployments",
    "created_at": "2019-12-31T18:27:56Z",
    "updated_at": "2021-01-12T08:25:13Z",
    "pushed_at": "2019-12-31T18:37:16Z",
    "git_url": "git://github.com/sdras/wedding.git",
    "ssh_url": "git@github.com:sdras/wedding.git",
    "clone_url": "https://github.com/sdras/wedding.git",
    "svn_url": "https://github.com/sdras/wedding",
    "homepage": null,
    "size": 22935,
    "stargazers_count": 3,
    "watchers_count": 3,
    "language": "HTML",
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 5,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 5,
    "open_issues": 0,
    "watchers": 3,
    "default_branch": "master"
  },
  {
    "id": 164779439,
    "node_id": "MDEwOlJlcG9zaXRvcnkxNjQ3Nzk0Mzk=",
    "name": "who-is-horse-js",
    "full_name": "sdras/who-is-horse-js",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/who-is-horse-js",
    "description": "🐴 ¯\\_(ツ)_/¯",
    "fork": true,
    "url": "https://api.github.com/repos/sdras/who-is-horse-js",
    "forks_url": "https://api.github.com/repos/sdras/who-is-horse-js/forks",
    "keys_url": "https://api.github.com/repos/sdras/who-is-horse-js/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/who-is-horse-js/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/who-is-horse-js/teams",
    "hooks_url": "https://api.github.com/repos/sdras/who-is-horse-js/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/who-is-horse-js/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/who-is-horse-js/events",
    "assignees_url": "https://api.github.com/repos/sdras/who-is-horse-js/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/who-is-horse-js/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/who-is-horse-js/tags",
    "blobs_url": "https://api.github.com/repos/sdras/who-is-horse-js/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/who-is-horse-js/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/who-is-horse-js/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/who-is-horse-js/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/who-is-horse-js/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/who-is-horse-js/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/who-is-horse-js/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/who-is-horse-js/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/who-is-horse-js/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/who-is-horse-js/subscription",
    "commits_url": "https://api.github.com/repos/sdras/who-is-horse-js/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/who-is-horse-js/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/who-is-horse-js/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/who-is-horse-js/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/who-is-horse-js/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/who-is-horse-js/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/who-is-horse-js/merges",
    "archive_url": "https://api.github.com/repos/sdras/who-is-horse-js/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/who-is-horse-js/downloads",
    "issues_url": "https://api.github.com/repos/sdras/who-is-horse-js/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/who-is-horse-js/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/who-is-horse-js/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/who-is-horse-js/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/who-is-horse-js/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/who-is-horse-js/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/who-is-horse-js/deployments",
    "created_at": "2019-01-09T03:23:22Z",
    "updated_at": "2019-01-10T19:05:06Z",
    "pushed_at": "2019-01-10T19:05:04Z",
    "git_url": "git://github.com/sdras/who-is-horse-js.git",
    "ssh_url": "git@github.com:sdras/who-is-horse-js.git",
    "clone_url": "https://github.com/sdras/who-is-horse-js.git",
    "svn_url": "https://github.com/sdras/who-is-horse-js",
    "homepage": null,
    "size": 1927,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "Vue",
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 1,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": null,
    "forks": 1,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 11754143,
    "node_id": "MDEwOlJlcG9zaXRvcnkxMTc1NDE0Mw==",
    "name": "xkcdTime_atyourownpace",
    "full_name": "sdras/xkcdTime_atyourownpace",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/xkcdTime_atyourownpace",
    "description": "Displays xkcd1190 Time in a navigable way.",
    "fork": true,
    "url": "https://api.github.com/repos/sdras/xkcdTime_atyourownpace",
    "forks_url": "https://api.github.com/repos/sdras/xkcdTime_atyourownpace/forks",
    "keys_url": "https://api.github.com/repos/sdras/xkcdTime_atyourownpace/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/xkcdTime_atyourownpace/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/xkcdTime_atyourownpace/teams",
    "hooks_url": "https://api.github.com/repos/sdras/xkcdTime_atyourownpace/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/xkcdTime_atyourownpace/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/xkcdTime_atyourownpace/events",
    "assignees_url": "https://api.github.com/repos/sdras/xkcdTime_atyourownpace/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/xkcdTime_atyourownpace/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/xkcdTime_atyourownpace/tags",
    "blobs_url": "https://api.github.com/repos/sdras/xkcdTime_atyourownpace/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/xkcdTime_atyourownpace/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/xkcdTime_atyourownpace/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/xkcdTime_atyourownpace/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/xkcdTime_atyourownpace/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/xkcdTime_atyourownpace/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/xkcdTime_atyourownpace/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/xkcdTime_atyourownpace/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/xkcdTime_atyourownpace/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/xkcdTime_atyourownpace/subscription",
    "commits_url": "https://api.github.com/repos/sdras/xkcdTime_atyourownpace/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/xkcdTime_atyourownpace/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/xkcdTime_atyourownpace/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/xkcdTime_atyourownpace/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/xkcdTime_atyourownpace/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/xkcdTime_atyourownpace/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/xkcdTime_atyourownpace/merges",
    "archive_url": "https://api.github.com/repos/sdras/xkcdTime_atyourownpace/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/xkcdTime_atyourownpace/downloads",
    "issues_url": "https://api.github.com/repos/sdras/xkcdTime_atyourownpace/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/xkcdTime_atyourownpace/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/xkcdTime_atyourownpace/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/xkcdTime_atyourownpace/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/xkcdTime_atyourownpace/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/xkcdTime_atyourownpace/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/xkcdTime_atyourownpace/deployments",
    "created_at": "2013-07-30T01:54:26Z",
    "updated_at": "2013-07-30T01:54:27Z",
    "pushed_at": "2013-07-28T23:34:28Z",
    "git_url": "git://github.com/sdras/xkcdTime_atyourownpace.git",
    "ssh_url": "git@github.com:sdras/xkcdTime_atyourownpace.git",
    "clone_url": "https://github.com/sdras/xkcdTime_atyourownpace.git",
    "svn_url": "https://github.com/sdras/xkcdTime_atyourownpace",
    "homepage": "http://geekwagon.net/projects/xkcd1190/",
    "size": 1539,
    "stargazers_count": 0,
    "watchers_count": 0,
    "language": "JavaScript",
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 1,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "other",
      "name": "Other",
      "spdx_id": "NOASSERTION",
      "url": null,
      "node_id": "MDc6TGljZW5zZTA="
    },
    "forks": 1,
    "open_issues": 0,
    "watchers": 0,
    "default_branch": "master"
  },
  {
    "id": 230546811,
    "node_id": "MDEwOlJlcG9zaXRvcnkyMzA1NDY4MTE=",
    "name": "You-Dont-Know-JS",
    "full_name": "sdras/You-Dont-Know-JS",
    "private": false,
    "owner": {
      "login": "sdras",
      "id": 2281088,
      "node_id": "MDQ6VXNlcjIyODEwODg=",
      "avatar_url": "https://avatars1.githubusercontent.com/u/2281088?v=4",
      "gravatar_id": "",
      "url": "https://api.github.com/users/sdras",
      "html_url": "https://github.com/sdras",
      "followers_url": "https://api.github.com/users/sdras/followers",
      "following_url": "https://api.github.com/users/sdras/following{/other_user}",
      "gists_url": "https://api.github.com/users/sdras/gists{/gist_id}",
      "starred_url": "https://api.github.com/users/sdras/starred{/owner}{/repo}",
      "subscriptions_url": "https://api.github.com/users/sdras/subscriptions",
      "organizations_url": "https://api.github.com/users/sdras/orgs",
      "repos_url": "https://api.github.com/users/sdras/repos",
      "events_url": "https://api.github.com/users/sdras/events{/privacy}",
      "received_events_url": "https://api.github.com/users/sdras/received_events",
      "type": "User",
      "site_admin": false
    },
    "html_url": "https://github.com/sdras/You-Dont-Know-JS",
    "description": "A book series on JavaScript. @YDKJS on twitter.",
    "fork": true,
    "url": "https://api.github.com/repos/sdras/You-Dont-Know-JS",
    "forks_url": "https://api.github.com/repos/sdras/You-Dont-Know-JS/forks",
    "keys_url": "https://api.github.com/repos/sdras/You-Dont-Know-JS/keys{/key_id}",
    "collaborators_url": "https://api.github.com/repos/sdras/You-Dont-Know-JS/collaborators{/collaborator}",
    "teams_url": "https://api.github.com/repos/sdras/You-Dont-Know-JS/teams",
    "hooks_url": "https://api.github.com/repos/sdras/You-Dont-Know-JS/hooks",
    "issue_events_url": "https://api.github.com/repos/sdras/You-Dont-Know-JS/issues/events{/number}",
    "events_url": "https://api.github.com/repos/sdras/You-Dont-Know-JS/events",
    "assignees_url": "https://api.github.com/repos/sdras/You-Dont-Know-JS/assignees{/user}",
    "branches_url": "https://api.github.com/repos/sdras/You-Dont-Know-JS/branches{/branch}",
    "tags_url": "https://api.github.com/repos/sdras/You-Dont-Know-JS/tags",
    "blobs_url": "https://api.github.com/repos/sdras/You-Dont-Know-JS/git/blobs{/sha}",
    "git_tags_url": "https://api.github.com/repos/sdras/You-Dont-Know-JS/git/tags{/sha}",
    "git_refs_url": "https://api.github.com/repos/sdras/You-Dont-Know-JS/git/refs{/sha}",
    "trees_url": "https://api.github.com/repos/sdras/You-Dont-Know-JS/git/trees{/sha}",
    "statuses_url": "https://api.github.com/repos/sdras/You-Dont-Know-JS/statuses/{sha}",
    "languages_url": "https://api.github.com/repos/sdras/You-Dont-Know-JS/languages",
    "stargazers_url": "https://api.github.com/repos/sdras/You-Dont-Know-JS/stargazers",
    "contributors_url": "https://api.github.com/repos/sdras/You-Dont-Know-JS/contributors",
    "subscribers_url": "https://api.github.com/repos/sdras/You-Dont-Know-JS/subscribers",
    "subscription_url": "https://api.github.com/repos/sdras/You-Dont-Know-JS/subscription",
    "commits_url": "https://api.github.com/repos/sdras/You-Dont-Know-JS/commits{/sha}",
    "git_commits_url": "https://api.github.com/repos/sdras/You-Dont-Know-JS/git/commits{/sha}",
    "comments_url": "https://api.github.com/repos/sdras/You-Dont-Know-JS/comments{/number}",
    "issue_comment_url": "https://api.github.com/repos/sdras/You-Dont-Know-JS/issues/comments{/number}",
    "contents_url": "https://api.github.com/repos/sdras/You-Dont-Know-JS/contents/{+path}",
    "compare_url": "https://api.github.com/repos/sdras/You-Dont-Know-JS/compare/{base}...{head}",
    "merges_url": "https://api.github.com/repos/sdras/You-Dont-Know-JS/merges",
    "archive_url": "https://api.github.com/repos/sdras/You-Dont-Know-JS/{archive_format}{/ref}",
    "downloads_url": "https://api.github.com/repos/sdras/You-Dont-Know-JS/downloads",
    "issues_url": "https://api.github.com/repos/sdras/You-Dont-Know-JS/issues{/number}",
    "pulls_url": "https://api.github.com/repos/sdras/You-Dont-Know-JS/pulls{/number}",
    "milestones_url": "https://api.github.com/repos/sdras/You-Dont-Know-JS/milestones{/number}",
    "notifications_url": "https://api.github.com/repos/sdras/You-Dont-Know-JS/notifications{?since,all,participating}",
    "labels_url": "https://api.github.com/repos/sdras/You-Dont-Know-JS/labels{/name}",
    "releases_url": "https://api.github.com/repos/sdras/You-Dont-Know-JS/releases{/id}",
    "deployments_url": "https://api.github.com/repos/sdras/You-Dont-Know-JS/deployments",
    "created_at": "2019-12-28T02:21:53Z",
    "updated_at": "2020-11-27T13:47:15Z",
    "pushed_at": "2019-12-28T02:27:13Z",
    "git_url": "git://github.com/sdras/You-Dont-Know-JS.git",
    "ssh_url": "git@github.com:sdras/You-Dont-Know-JS.git",
    "clone_url": "https://github.com/sdras/You-Dont-Know-JS.git",
    "svn_url": "https://github.com/sdras/You-Dont-Know-JS",
    "homepage": "",
    "size": 8382,
    "stargazers_count": 13,
    "watchers_count": 13,
    "language": null,
    "has_issues": false,
    "has_projects": true,
    "has_downloads": true,
    "has_wiki": true,
    "has_pages": false,
    "forks_count": 9,
    "mirror_url": null,
    "archived": false,
    "disabled": false,
    "open_issues_count": 0,
    "license": {
      "key": "other",
      "name": "Other",
      "spdx_id": "NOASSERTION",
      "url": null,
      "node_id": "MDc6TGljZW5zZTA="
    },
    "forks": 9,
    "open_issues": 0,
    "watchers": 13,
    "default_branch": "2nd-ed"
  }
]